import React, { useContext } from "react";
import Form from "react-bootstrap/esm/Form";
import SecondaryButton from "shared/components/SecondaryButton";
import PrimaryButton from "shared/components/PrimaryButton";
import "./ApplicationForm.css"
import CustomerAccount from "models/account/customer/customerAccount";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "react-phone-number-input";
import DatePicker from "react-datepicker";
import { Accordion, AccordionContext, Alert, Button, Card, Col, Row, Tab, Tabs } from "react-bootstrap";
import { getYear, isDate, isValid } from "date-fns";
import LoanApplication from "models/loan/loanApplication";
import { ApplicantType, CapitalSalesIncomeType, CashFlowExpenseType, CashFlowIncomeType, CashFlowLineItemPurchaseSaleType, CashFlowOtherExpenseType, CashFlowSections, CollateralEquityTypes, LoanType, NonFarmIncomeType, OtherFarmIncomeType, SubmittedPortal } from "shared/Enums";
import DealerPurchase from "models/dealerPurchase/dealerPurchase";
import Applicant from "models/applicantForm/applicant";
import EquipmentInformation from "models/dealerPurchase/equipmentInformation";
import EquipmentInsuranceInformation from "models/dealerPurchase/equipmentInsuranceInformation";
import EquipmentProduct from "models/dealerPurchase/equipmentProduct";
import SelectOption from "shared/models/selectOption";
import dealerService from "accessors/dealerService";
import loanApplicationService from "accessors/loanApplicationService";
import EntityApplicant from "models/applicantForm/entityApplicant";
import CollateralEquityCashDown from "models/collateralEquity/cashDown";
import DealerSalesman from "models/dealerPurchase/dealerSalesman";
import LendingReference from "models/dealerPurchase/lendingReference";
import GrossRevenue from "models/grossRevenue/grossRevenue";
import globalUtility from "utilities/GlobalUtility";
import loanApplicationUtility from "utilities/LoanApplicationUtility";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dealer from "models/dealerPurchase/dealer";
import DealerLocation from "models/dealerPurchase/dealerLocation";
import DealerOther from "models/dealerPurchase/dealerOther";
import inputValidators from "utilities/InputValidators";
import CollateralEquityOtherCollateral from "models/collateralEquity/otherCollateral";
import DangerButton from "shared/components/DangerButton";
import { EventKey } from "react-bootstrap/esm/types";
import SubmitSummary from "components/loanDetails/submitSummary/SubmitSummary";
import CashFlow from "models/financialDocuments/cashFlow/cashFlow";
import ProductionLineOfCredit from "models/productionLineOfCredit/productionLineOfCredit";
import CashFlowIntroduction from "models/financialDocuments/cashFlow/introductionSection/introduction";
import CashFlowProductionIncome from "models/financialDocuments/cashFlow/incomeSection/productionIncome";
import CashFlowProductionPurchase from "models/financialDocuments/cashFlow/incomeSection/productionPurchase";
import CashFlowProductionSale from "models/financialDocuments/cashFlow/incomeSection/productionSale";
import { NumericFormat, PatternFormat } from "react-number-format";
import CashFlowIncomeLineItem from "models/financialDocuments/cashFlow/incomeSection/incomeLineItem";
import CashFlowExpense from "models/financialDocuments/cashFlow/expenseSection/expense";
import CashFlowOtherExpense from "models/financialDocuments/cashFlow/otherExpensesSection/otherExpense";
import CashFlowIncomeSection from "models/financialDocuments/cashFlow/incomeSection/incomeSection";
import CashFlowExpenseSection from "models/financialDocuments/cashFlow/expenseSection/expenseSection";
import CashFlowOtherExpensesSection from "models/financialDocuments/cashFlow/otherExpensesSection/otherExpenseSection";
import CashFlowOtherFarmIncome from "models/financialDocuments/cashFlow/incomeSection/otherFarmIncome";
import CashFlowNonFarmIncome from "models/financialDocuments/cashFlow/incomeSection/nonFarmIncome";
import CashFlowLoanPayment from "models/financialDocuments/cashFlow/loanPaymentsSection/loanPayment";
import CashFlowLoanPaymentsSection from "models/financialDocuments/cashFlow/loanPaymentsSection/loanPaymentSection";
import CashFlowCapitalSalesIncome from "models/financialDocuments/cashFlow/incomeSection/capitalSalesIncome";
import JointApplicant from "models/applicantForm/jointApplicant";
import LoanAuctionInformation from "models/dealerPurchase/auctionInformation";
import PrincipalOwnerInformation from "models/applicantForm/principalOwnerInformation";
import EntityApplicantExtraData from "models/applicantForm/entityApplicantExtraData";
import toastUtility from 'utilities/ToastUtility';
import { DraftApplicationSummary } from 'models/loan/draftApplicationSummary';
import AccountGateTab from 'components/loan/applicationForm/AccountGateTab';
type loadingCallback = (loading: boolean) => void;
type submitCallback = (loanApplication: LoanApplication) => Promise<boolean>;

const STATES = ['AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'];
const EquipmentOnlyLoans = [LoanType.DealerPurchase, LoanType.EquipmentRefinance]; // Removing LoanType.EquipmentAuctionPurchase for now
const AllEquipmentLoans = [LoanType.DealerPurchase, LoanType.EquipmentRefinance, LoanType.EquipmentAuctionPurchase];

interface ApplicationFormProps {
  dealers: Dealer[];
  userLoggedIn?: boolean;
  defaultLoanType?: LoanType;
  loanTypesToShow?: LoanType[];
  defaultDealer?: Dealer;
  customerAccountInfo?: CustomerAccount;
  toggleLoading: loadingCallback;
  submitCallback: submitCallback;
  initialDraftToken?: string;
  anonymousDraftTokens?: string[];  // post-login tokens to claim (from ?claimTokens= URL param)
  sqId?: string;
}

interface ApplicationFormState {
  activeTabKey: EventKey;
  validStartData: boolean;
  validPurchaseInformation: boolean;
  validEquipmentInformation: boolean;
  validGeneralData: boolean;
  validCashFlowIntroData: boolean;
  validTopLevelLineItemData: boolean;
  validCashFlowProductionIncomeData: boolean;
  validCashFlowProductionPurchaseData: boolean;
  validCashFlowProductionSaleData: boolean;
  validAllCashFlowIncomeData: boolean;
  validCashFlowOtherIncomeData: boolean;
  validCashFlowExpensesData: boolean;
  validCashFlowOtherExpensesData: boolean;
  validCashFlowCapitalData: boolean;
  validCashFlowLoanPaymentData: boolean;
  validLendingReferenceData: boolean;
  validRevenueData: boolean;
  validApplicantInfo: boolean;
  loanApplication: LoanApplication;
  selectedDealer: Dealer;
  selectedDealerLocation: DealerLocation;
  selectedDealerSalesman: DealerSalesman;
  otherSalesmanSelected: boolean;
  validOtherPhoneNumber: boolean;
  validInsurancePhoneNumber: boolean;
  validLendingReferencePhoneNumber: boolean;
  validCollateral: boolean;
  loadingAccountOptions: boolean;
  accountSelectOptions: Array<Array<SelectOption>>;
  accountOptions: Array<Array<CustomerAccount>>;
  productOptions: EquipmentProduct[];

  cropProduction: boolean;
  livestockPoultryProduction: boolean;
  dairyProduction: boolean;

  isFarmer: boolean;
  agProductOptions: Array<SelectOption>;
  previousApplication?: LoanApplication | null;
  wantsPrefill?: boolean;
  prefilled: boolean;
  prefillLoading: boolean;
  draftToken?: string;
  draftEmailOptInVisible: boolean;
  draftMagicLinkEmail: string;
  draftsLoading: boolean;
  availableDrafts: DraftApplicationSummary[];
  isResumingDraft: boolean;
  newApplication: boolean;
}

class ApplicationForm extends React.Component<ApplicationFormProps, ApplicationFormState> {
  constructor(props: any) {
    super(props);

    this.state = {
      activeTabKey: 'start',
      validStartData: this.props.defaultLoanType != undefined,
      validPurchaseInformation: false,
      validEquipmentInformation: false,
      validGeneralData: false,
      validCashFlowIntroData: false,
      validTopLevelLineItemData: true, // Some of these items can be optional depending on what's selected -- validation will handle setting these values
      validCashFlowProductionIncomeData: true, // Some of these items can be optional depending on what's selected -- validation will handle setting these values
      validCashFlowProductionPurchaseData: true, // Some of these items can be optional depending on what's selected -- validation will handle setting these values
      validCashFlowProductionSaleData: true, // Some of these items can be optional depending on what's selected -- validation will handle setting these values
      validAllCashFlowIncomeData: false,
      validCashFlowOtherIncomeData: true, // Optional Item
      validCashFlowExpensesData: true, // Optional Item
      validCashFlowOtherExpensesData: true, // Optional Item
      validCashFlowCapitalData: true, // Optional Item
      validCashFlowLoanPaymentData: true, // Optional Item
      validLendingReferenceData: false,
      validRevenueData: false,
      validApplicantInfo: false,
      loanApplication: {
        submittedPortal: SubmittedPortal.Customer,
        loanType: this.props.defaultLoanType,
        // loanDealerPurchase: {} as DealerPurchase,
        // loanEquipmentInformation: [{ index: 0, new: false } as EquipmentInformation] as EquipmentInformation[],
        // loanEquipmentInsuranceInformation: {} as EquipmentInsuranceInformation,
        applicant: {} as Applicant
      } as LoanApplication,
      selectedDealer: this.props.defaultDealer ?? {} as Dealer,
      selectedDealerLocation: {} as DealerLocation,
      selectedDealerSalesman: {} as DealerSalesman,
      otherSalesmanSelected: false,
      validOtherPhoneNumber: true,
      validInsurancePhoneNumber: false,
      validLendingReferencePhoneNumber: false,
      validCollateral: false,
      loadingAccountOptions: false,
      accountSelectOptions: [[], []],
      accountOptions: [[], []],
      productOptions: [],

      cropProduction: false,
      livestockPoultryProduction: false,
      dairyProduction: false,

      isFarmer: false,
      agProductOptions: loanApplicationUtility.GetPrimaryAgProductOptions(),
      previousApplication: undefined,
      wantsPrefill: undefined,
      prefilled: false,
      prefillLoading: true,
      draftToken: undefined,
      draftEmailOptInVisible: false,
      draftMagicLinkEmail: '',
      draftsLoading: false,
      availableDrafts: [],
      isResumingDraft: false,
      newApplication: false
    };
  }

  async componentDidMount() {
    await this.setDefaultCustomerAccountInfo();

    if (this.props.defaultLoanType != undefined) {
      await this.setLoanTypeState(this.props.defaultLoanType, true, true);
    }

    if (this.props.defaultDealer != undefined) {
      await this.setDealerState(this.props.defaultDealer.id, this.props.defaultLoanType);
    }

    // Read and clean ?claimToken= URL param (magic link resume)
    const urlParams = new URLSearchParams(window.location.search);
    const claimToken = urlParams.get('claimToken');
    if (claimToken) {
      const url = new URL(window.location.href);
      url.searchParams.delete('claimToken');
      window.history.replaceState({}, '', url.toString());
    }

    // Unified loading gate: covers prefill + all draft restore
    this.props.toggleLoading(true);
    try {
      // Fetch prefill data after account info is populated and if user is logged in
      if (this.props.userLoggedIn) {
        const result = await loanApplicationService.GetApplicationPrefill().catch(() => null);
        this.setState({ previousApplication: result ?? null, prefillLoading: false });
      }

      // Draft restore
      const { userLoggedIn, anonymousDraftTokens, initialDraftToken } = this.props;

      this.setState({ draftsLoading: true });

      if (userLoggedIn) {
        // Claim magic link draft (from ?claimToken= URL param) — token is rotated on claim
        let claimedToken: string | null = null;
        if (claimToken) {
          claimedToken = await loanApplicationService.ClaimDraft(claimToken);
        }

        // Claim pre-login anonymous drafts (from ?claimTokens= post-login redirect) — best-effort, return value ignored
        if (anonymousDraftTokens && anonymousDraftTokens.length > 0) {
          for (const token of anonymousDraftTokens) {
            await loanApplicationService.ClaimDraft(token);
          }
          localStorage.removeItem('agcredit_draft_tokens');
        }

        const drafts = await loanApplicationService.GetAllDrafts();
        this.setState({ availableDrafts: drafts });

        // Auto-resume the magic link draft if it was successfully claimed
        if (claimedToken) {
          await this.resumeDraft(claimedToken);
        }

        // if (initialDraftToken) {
        //   await this.resumeDraft(initialDraftToken);
        // }
      } else {
        // Anonymous user: migrate old single-token key to array key if needed
        const legacyToken = localStorage.getItem('agcredit_draft_token');
        if (legacyToken) {
          const existing = JSON.parse(localStorage.getItem('agcredit_draft_tokens') ?? '[]') as string[];
          if (!existing.includes(legacyToken)) {
            existing.push(legacyToken);
            localStorage.setItem('agcredit_draft_tokens', JSON.stringify(existing));
          }
          localStorage.removeItem('agcredit_draft_token');
        }

        let tokens = JSON.parse(localStorage.getItem('agcredit_draft_tokens') ?? '[]') as string[];

        if (initialDraftToken && !tokens.includes(initialDraftToken)) {
          tokens.push(initialDraftToken);
        }

        // Inject URL claimToken into the array before fetching
        if (claimToken && !tokens.includes(claimToken)) {
          tokens.unshift(claimToken);
        }

        const drafts = await loanApplicationService.GetAllDraftsPublic(tokens);
        const returnedTokens = new Set(drafts.map(d => d.accessToken));
        const validTokens = tokens.filter(t => returnedTokens.has(t));
        localStorage.setItem('agcredit_draft_tokens', JSON.stringify(validTokens));

        this.setState({ availableDrafts: drafts });

        // Auto-resume the magic link draft if it validated successfully
        if (claimToken && validTokens.includes(claimToken)) {
          await this.resumeDraft(claimToken);
        }

        // if (initialDraftToken) {
        //   await this.resumeDraft(initialDraftToken);
        // }
      }
    } finally {
      this.setState({ draftsLoading: false }, () => { this.props.toggleLoading(false); });
    }
  }

  async componentDidUpdate(prevProps: Readonly<ApplicationFormProps>, prevState: Readonly<ApplicationFormState>, snapshot?: any): Promise<void> {
    if (prevProps.customerAccountInfo != this.props.customerAccountInfo) {
      await this.setDefaultCustomerAccountInfo();
    }

    if (prevProps.defaultLoanType != this.props.defaultLoanType) {
      if (this.props.defaultLoanType != undefined) {
        await this.setLoanTypeState(this.props.defaultLoanType, true, true);
      }
    }

    if (prevProps.defaultDealer != this.props.defaultDealer) {
      if (this.props.defaultDealer != undefined) {
        await this.setDealerState(this.props.defaultDealer.id, this.props.defaultLoanType);
      }
    }
  }

  async setDefaultCustomerAccountInfo(): Promise<void> {
    if (this.props.customerAccountInfo != undefined) {
      let loanApplication: LoanApplication = { ...this.state.loanApplication }
      let customerAccount: CustomerAccount = { ...this.props.customerAccountInfo ?? {} as CustomerAccount };
      let applicantInfo: Applicant = { ...loanApplication.applicant ?? {} as Applicant };

      applicantInfo.hasAccount = true;
      applicantInfo.customerAccountId = customerAccount.id ?? -1;
      applicantInfo.emailAddress = customerAccount.email ?? '';
      applicantInfo.phoneNumber = customerAccount.phoneNumber?.toString() ?? '';
      applicantInfo.displayPhoneNumber = `+1${customerAccount.phoneNumber?.toString() ?? ''}`;
      applicantInfo.firstName = customerAccount.firstName ?? '';
      applicantInfo.lastName = customerAccount.lastName ?? '';
      applicantInfo.displayName = `${customerAccount.firstName} ${customerAccount.lastName} ${customerAccount.suffix}`;
      applicantInfo.suffix = customerAccount.suffix ?? '';
      applicantInfo.address = customerAccount.streetAddress ?? '';
      applicantInfo.addressLine2 = customerAccount.streetAddress2 ?? '';
      applicantInfo.city = customerAccount.city ?? '';
      applicantInfo.state = customerAccount.state ?? '';
      applicantInfo.zipCode = customerAccount.zipCode ?? '';
      // react-datepicker doesn't like having there being no time set on the DOB
      applicantInfo.dateOfBirth = new Date(customerAccount.dateOfBirth);
      applicantInfo.businessName = customerAccount.businessName ?? '';
      applicantInfo.farmingStartYear = customerAccount.farmingStartYear ?? 0;

      applicantInfo.validEmail = true;
      applicantInfo.validPhoneNumber = true;

      loanApplication.applicant = { ...applicantInfo };

      this.setValidFormClass(`customer-email-${0}`, true);
      this.setValidFormClass(`customer-phone-number-${0}`, true);
      this.setValidFormClass(`customer-first-name-${0}`, true);
      this.setValidFormClass(`customer-last-name-${0}`, true);
      this.setValidFormClass(`customer-address-${0}`, true);
      this.setValidFormClass(`customer-city-${0}`, true);
      this.setValidFormClass(`customer-state-${0}`, true);
      this.setValidFormClass(`customer-zip-${0}`, true);
      this.setValidFormClass(`customer-dob-${0}`, true);
      this.setValidFormClass(`business-name-${0}`, true);
      this.setValidFormClass(`managing-farm-${0}`, true);

      await this.setState({ loanApplication: loanApplication });
      return Promise.resolve();
    }
  }

  loadProductInformation(selectedDealerId: number): void {
    this.props.toggleLoading(true);

    dealerService.GetDealerEquipmentProductsPublic(selectedDealerId)
      .then((products: EquipmentProduct[]) => {
        this.props.toggleLoading(false);
        this.setState({ productOptions: products });
      })
  }

  setValidFormClass(formId: string, valid?: boolean) {
    document.getElementById(formId)?.classList.remove('global-form-valid', 'global-form-invalid');

    if (valid != undefined) {
      document.getElementById(formId)?.classList.add(valid ? 'global-form-valid' : 'global-form-invalid');
    }
  }

  async setDealerState(selectedDealerId: number, defaultLoanType?: LoanType): Promise<void> {
    let loanApplication: LoanApplication = { ...this.state.loanApplication };
    let dealer: Dealer = this.props.dealers?.find(d => d.id === selectedDealerId) ?? {} as Dealer;
    let selectedDealerLocation = { ...this.state.selectedDealerLocation };
    let selectedDealerSalesman = { ...this.state.selectedDealerSalesman };

    if (selectedDealerId > -1) {
      if (loanApplication.loanDealerPurchase != undefined) {
        loanApplication.loanDealerPurchase.dealerId = selectedDealerId;
        loanApplication.loanDealerPurchase.dealer = dealer;
        loanApplication.loanDealerPurchase.customHire = false;
      } else {
        loanApplication.loanDealerPurchase = {
          dealerId: selectedDealerId,
          dealer: dealer,
          customHire: false
        } as DealerPurchase;
      }

      // Auctions don't need a salesman to select at the moment, so we will default
      if ((defaultLoanType ?? loanApplication.loanType) === LoanType.EquipmentAuctionPurchase) {
        let dealerLocation = { ...dealer.dealerLocations[0] };
        let dealerSalesman = { ...dealerLocation.dealerSalesmen[0] };
        loanApplication.loanDealerPurchase.dealerLocationId = dealerLocation.id;
        loanApplication.loanDealerPurchase.dealerLocation = dealerLocation;
        loanApplication.loanDealerPurchase.dealerSalesmanId = dealerSalesman.id;
        loanApplication.loanDealerPurchase.dealerSalesman = dealerSalesman;
        loanApplication.loanDealerPurchase.description = `Purchase from: ${dealerLocation?.displayName ?? dealer?.name}: ${dealerLocation?.city}, ${dealerLocation?.state} on ${globalUtility.GetDateText(new Date())}`;
      }
    } else {
      if (loanApplication.loanDealerPurchase != undefined) {
        loanApplication.loanDealerPurchase.dealerId = undefined;
        loanApplication.loanDealerPurchase.dealer = undefined;
        loanApplication.loanDealerPurchase.dealerLocationId = undefined;
        loanApplication.loanDealerPurchase.dealerLocation = undefined;
        loanApplication.loanDealerPurchase.dealerSalesmanId = undefined;
        loanApplication.loanDealerPurchase.dealerSalesman = undefined;
      } else {
        loanApplication.loanDealerPurchase = {
          dealerId: undefined,
          dealer: undefined,
          dealerLocationId: undefined,
          dealerLocation: undefined,
          dealerSalesmanId: undefined,
          dealerSalesman: undefined
        } as DealerPurchase;
      }

      selectedDealerLocation = {} as DealerLocation;
      selectedDealerSalesman = {} as DealerSalesman;
    }

    this.setValidFormClass('dealer-select', selectedDealerId >= 0);
    this.setValidFormClass('dealer-location-select', Object.keys(selectedDealerLocation).length > 0);
    this.setValidFormClass('salesman-select', Object.keys(selectedDealerSalesman).length > 0);


    await this.setState({ loanApplication: loanApplication, selectedDealer: dealer, selectedDealerLocation: selectedDealerLocation, selectedDealerSalesman: selectedDealerSalesman }, () => { this.loadProductInformation(selectedDealerId); this.validatePurchaseInformation(); });
    return Promise.resolve();
  }

  setDealerLocationState(selectedLocationId: number): void {
    let loanApplication: LoanApplication = { ...this.state.loanApplication };
    let dealerLocation: DealerLocation = this.state.selectedDealer.dealerLocations?.find(dl => dl.id === selectedLocationId) ?? {} as DealerLocation;
    let selectedDealerSalesman = { ...this.state.selectedDealerSalesman };

    if (selectedLocationId > -1) {
      if (loanApplication.loanDealerPurchase != undefined) {
        loanApplication.loanDealerPurchase.dealerLocationId = selectedLocationId;
        loanApplication.loanDealerPurchase.dealerLocation = dealerLocation;
      } else {
        loanApplication.loanDealerPurchase = {
          dealerLocationId: selectedLocationId,
          dealerLocation: dealerLocation
        } as DealerPurchase;
      }
    } else {
      if (loanApplication.loanDealerPurchase != undefined) {
        loanApplication.loanDealerPurchase.dealerLocationId = undefined;
        loanApplication.loanDealerPurchase.dealerLocation = undefined;
        loanApplication.loanDealerPurchase.dealerSalesmanId = undefined;
        loanApplication.loanDealerPurchase.dealerSalesman = undefined;
      } else {
        loanApplication.loanDealerPurchase = {
          dealerLocationId: undefined,
          dealerLocation: undefined,
          dealerSalesmanId: undefined,
          dealerSalesman: undefined
        } as DealerPurchase;
      }

      selectedDealerSalesman = {} as DealerSalesman;
    }

    this.setValidFormClass('dealer-location-select', selectedLocationId >= 0);
    this.setValidFormClass('salesman-select', Object.keys(selectedDealerSalesman).length > 0);

    this.setState({ loanApplication: loanApplication, selectedDealerLocation: dealerLocation, selectedDealerSalesman: selectedDealerSalesman }, this.validatePurchaseInformation);
  }

  setDealerSalesmanState(selectedSalesmanId: number): void {
    let loanApplication: LoanApplication = { ...this.state.loanApplication };
    let dealerSalesman: DealerSalesman = this.state.selectedDealerLocation.dealerSalesmen?.find(ds => ds.id === selectedSalesmanId) ?? {} as DealerSalesman;
    let selectedLocation: DealerLocation = { ...this.state.selectedDealerLocation };
    let selectedDealer: Dealer = { ...this.state.selectedDealer };

    if (selectedSalesmanId > -1) {
      if (loanApplication.loanDealerPurchase != undefined) {
        loanApplication.loanDealerPurchase.description = `Purchase from: ${selectedLocation?.displayName ?? selectedDealer?.name}: ${selectedLocation?.city}, ${selectedLocation?.state} on ${globalUtility.GetDateText(new Date())}`;

        loanApplication.loanDealerPurchase.dealerSalesmanId = selectedSalesmanId;
        loanApplication.loanDealerPurchase.dealerSalesman = dealerSalesman;
      } else {
        loanApplication.loanDealerPurchase = {
          description: `Purchase from: ${selectedLocation?.displayName ?? selectedDealer?.name}: ${selectedLocation?.city}, ${selectedLocation?.state} on ${globalUtility.GetDateText(new Date())}`,
          dealerSalesmanId: selectedSalesmanId,
          dealerSalesman: dealerSalesman
        } as DealerPurchase;
      }
    } else {
      if (loanApplication.loanDealerPurchase != undefined) {
        loanApplication.loanDealerPurchase.dealerSalesmanId = undefined;
        loanApplication.loanDealerPurchase.dealerSalesman = undefined;
      } else {
        loanApplication.loanDealerPurchase = {
          dealerSalesmanId: undefined,
          dealerSalesman: undefined
        } as DealerPurchase;
      }
    }

    this.setValidFormClass('salesman-select', selectedSalesmanId >= 0);

    this.setState({ loanApplication: loanApplication, selectedDealerSalesman: dealerSalesman }, this.validatePurchaseInformation);
  }

  setOtherSalesmanSelected(value: boolean) {
    let loanApplication = { ...this.state.loanApplication };
    let dealerPurchase = { ...loanApplication.loanDealerPurchase };
    let validOtherPhone: boolean;

    if (value) {
      validOtherPhone = false;

      if (dealerPurchase?.dealerId != undefined) {
        let location = `${dealerPurchase.dealer?.name} - ${dealerPurchase.dealer?.city}, ${dealerPurchase.dealer?.state}`;
        dealerPurchase.dealerOther = {
          location: location
        } as DealerOther;

        dealerPurchase.description = `Purchase from: ${location} on ${globalUtility.GetDateText(new Date())}`;

        dealerPurchase.dealerSalesmanId = undefined;
        dealerPurchase.dealerSalesman = undefined;
      } else {
        dealerPurchase.dealerOther = {} as DealerOther;
      }
    } else {
      dealerPurchase.dealerOther = {} as DealerOther;
      validOtherPhone = true;
    }

    loanApplication.loanDealerPurchase = { ...dealerPurchase };

    this.setState({ otherSalesmanSelected: value, loanApplication: loanApplication, validOtherPhoneNumber: validOtherPhone, selectedDealerSalesman: {} as DealerSalesman }, () => {
      let locationSet: boolean = (this.state.loanApplication.loanDealerPurchase?.dealerOther?.location?.length ?? 0) > 0;
      this.setValidFormClass('other-salesman-location', locationSet ? true : undefined);
      this.setValidFormClass('dealer-select', value);
      this.setValidFormClass('dealer-location-select', value);
      this.setValidFormClass('salesman-select', value);
      this.validatePurchaseInformation();
    });
  }

  setOtherLocation(value: string) {
    let loanApplication = { ...this.state.loanApplication };
    let dealerPurchase = { ...loanApplication.loanDealerPurchase };

    if (dealerPurchase.dealerOther != undefined) {
      dealerPurchase.dealerOther.location = value;
      dealerPurchase.description = `Purchase from: ${value} on ${globalUtility.GetDateText(new Date())}`;
      loanApplication.loanDealerPurchase = { ...dealerPurchase };
      this.setValidFormClass('other-salesman-location', value.length > 0);
      this.setState({ loanApplication: loanApplication }, this.validatePurchaseInformation);
    }
  }

  setOtherName(value: string) {
    let loanApplication = { ...this.state.loanApplication };
    let dealerPurchase = { ...loanApplication.loanDealerPurchase };

    if (dealerPurchase.dealerOther != undefined) {
      dealerPurchase.dealerOther.name = value;
      loanApplication.loanDealerPurchase = { ...dealerPurchase };
      this.setValidFormClass('other-salesman-name', value.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validatePurchaseInformation);
    }
  }

  setOtherPhoneNumber(value: string, data: any, event: any, formattedValue: string) {
    let loanApplication = { ...this.state.loanApplication };
    let dealerPurchase = { ...loanApplication.loanDealerPurchase };

    if (dealerPurchase.dealerOther != undefined) {
      dealerPurchase.dealerOther.phoneNumber = value.length > 0 ? value.substring(1, 11) : undefined;
      dealerPurchase.dealerOther.displayPhoneNumber = value.length > 0 ? formattedValue : undefined;
      let validNumber = value.length === 0 || isValidPhoneNumber(formattedValue);

      this.setValidFormClass('other-salesman-phone', validNumber);
      loanApplication.loanDealerPurchase = { ...dealerPurchase };
      this.setState({ loanApplication: loanApplication, validOtherPhoneNumber: validNumber }, this.validatePurchaseInformation);
    }
  }

  setPurchaseAmountState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let dealerPurchase = { ...loanApplication.loanDealerPurchase };
    dealerPurchase.purchaseAmount = amount;
    loanApplication.loanDealerPurchase = { ...dealerPurchase };

    this.setValidFormClass('total-purchase-amount', amount > 0);

    let setCashDown: boolean = loanApplication.loanType === LoanType.EquipmentAuctionPurchase;

    this.setState({ loanApplication: loanApplication }, async () => { if (setCashDown) await this.setCashDownAmountState(+(amount * .2).toFixed(2)); this.validatePurchaseInformation(); });
  }

  setRequestAmountState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };
    //let dealerPurchase = { ...loanApplication.loanDealerPurchase };
    loanApplication.loanAmount = amount;
    //loanApplication.loanDealerPurchase = { ...dealerPurchase };

    this.setValidFormClass('total-request-amount', amount > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  async setLoanTypeState(loanType: LoanType, checked: boolean, skipReset?: boolean): Promise<void> {
    let loanApplication = { ...this.state.loanApplication };

    if (checked) {
      loanApplication.loanType = loanType;

      if (loanType === LoanType.ProductionLineOfCredit) {
        let currentYearStartDate = new Date(`January 1 ${getYear(new Date())}`);
        let currentYearEndDate = new Date(`December 31 ${getYear(new Date())}`);
        loanApplication.loanProductionLineOfCredit = {
          cashFlow: {
            introductionSection: {
              sectionId: CashFlowSections.Introduction,
              projected: true,
              cycleStart: currentYearStartDate,
              cycleEnd: currentYearEndDate,
              asOfDate: new Date(),
            } as CashFlowIntroduction,
            incomeSection: {
              sectionId: CashFlowSections.Income,
              incomeTypes: [],
              incomeLineItems: [],
              otherIncomeTypes: [],
              otherFarmIncome: [],
              nonFarmIncome: [],
              capitalSalesIncome: []
            } as CashFlowIncomeSection,
            expensesSection: {
              sectionId: CashFlowSections.Expenses,
              expenseTypes: [],
              expenses: [],
            } as CashFlowExpenseSection,
            otherExpenseSection: {
              sectionId: CashFlowSections.NonOperating,
              otherExpenseTypes: [],
              otherExpenseItems: [],
            } as CashFlowOtherExpensesSection,
            loanPaymentsSection: {
              sectionId: CashFlowSections.LoanPayments,
              loanPaymentItems: [],
            } as CashFlowLoanPaymentsSection
          } as CashFlow
        } as ProductionLineOfCredit;

        // Defaulting these values
        this.setValidFormClass(`business-plan-type`, true);
        this.setValidFormClass(`production-cycle-start`, true);
        this.setValidFormClass(`production-cycle-end`, true);
        this.setValidFormClass(`production-as-of-date`, true);
      } else if (EquipmentOnlyLoans.includes(loanApplication.loanType)) {
        loanApplication.loanDealerPurchase = {
          customHire: false
        } as DealerPurchase;

        loanApplication.loanEquipmentInformation = [
          {
            index: 0,
            new: false,
            quantity: 1
          } as EquipmentInformation
        ] as EquipmentInformation[];
      } else if (loanApplication.loanType === LoanType.EquipmentAuctionPurchase) {
        loanApplication.loanAmount = 0;

        loanApplication.loanDealerPurchase = {
          purchaseAmount: 0,
          description: 'Auction Purchase',
          customHire: false
        } as DealerPurchase;

        loanApplication.loanEquipmentInformation = [
          {
            index: 0,
            new: false,
            quantity: 1,
            unitPrice: 0,
            totalPrice: 0
          } as EquipmentInformation
        ] as EquipmentInformation[];

        loanApplication.loanAuctionInformation = {} as LoanAuctionInformation;
        loanApplication.collateralEquityTypes = [CollateralEquityTypes.CashDown];
        loanApplication.collateralEquityCashDown = {
          amount: 0
        } as CollateralEquityCashDown;
      }
    } else {
      loanApplication.loanType = 0;
    }

    this.setValidFormClass(`loan-type`, loanApplication.loanType > 0);

    await this.setState({ loanApplication: loanApplication, wantsPrefill: undefined }, () => {
      this.validateStartData();
      this.validateCashFlowIntroduction();
      if (!skipReset) this.resetLoanItems();
    });

    return Promise.resolve();
  }

  applyPrefill() {
    const prev = this.state.previousApplication;

    if (!prev) return;
    // Guard: only apply once per Yes selection — prevent overwriting user edits on re-click
    if (this.state.prefilled === true) return;

    let loanApplication = { ...this.state.loanApplication };
    let validLendingReferencePhoneNumber: boolean = false;

    // Lending Reference
    if (prev.loanLendingReference) {
      loanApplication.loanLendingReference = {
        bankName: prev.loanLendingReference.bankName,
        contactName: prev.loanLendingReference.contactName,
        phoneNumber: prev.loanLendingReference.phoneNumber,
        displayPhoneNumber: `+1 ${loanApplicationUtility.FormatPhoneNumber(prev.loanLendingReference.phoneNumber ?? '')}`,
      };

      validLendingReferencePhoneNumber = (loanApplication.loanLendingReference?.phoneNumber?.toString().length ?? 0) > 0;
      this.setValidFormClass('lending-bank-name', (loanApplication.loanLendingReference?.bankName ?? '').length > 0);
      this.setValidFormClass('lending-contact-name', (loanApplication.loanLendingReference?.contactName ?? '').length > 0);
      this.setValidFormClass('lending-phone-number', validLendingReferencePhoneNumber);
    }

    // Projected Gross Revenues
    if (prev.projectedGrossRevenues) {
      loanApplication.projectedGrossRevenues = { ...prev.projectedGrossRevenues };
      this.setValidFormClass('projected-gross-revenues', (loanApplication.projectedGrossRevenues.farmRevenues ?? 0) > 0);
    }

    // Prior Gross Revenues (controlled inputs after Task 5 fix)
    if (prev.priorGrossRevenues) {
      loanApplication.priorGrossRevenues = { ...prev.priorGrossRevenues };
    }

    // Cross-type General Questions (apply regardless of loan type match)
    if (prev.beganFarming) loanApplication.beganFarming = prev.beganFarming;
    if (prev.primaryAgProduct) loanApplication.primaryAgProduct = prev.primaryAgProduct;
    const isFarmer = !!prev.primaryAgProduct;

    // Loan-type-specific General Questions (only if same loan family)
    const currentIsEquipment = AllEquipmentLoans.includes(loanApplication.loanType);
    const prevIsEquipment = AllEquipmentLoans.includes(prev.loanType);
    let validInsurancePhoneNumber: boolean = false;

    if (currentIsEquipment && prevIsEquipment && prev.loanDealerPurchase) {
      loanApplication.loanDealerPurchase = {
        ...loanApplication.loanDealerPurchase,
        customHire: prev.loanDealerPurchase.customHire,
        totalAssets: prev.loanDealerPurchase.totalAssets,
        totalLiabilities: prev.loanDealerPurchase.totalLiabilities,
      };

      if (prev.loanEquipmentInsuranceInformation) {
        loanApplication.loanEquipmentInsuranceInformation = {
          companyName: prev.loanEquipmentInsuranceInformation.companyName,
          agentName: prev.loanEquipmentInsuranceInformation.agentName,
          phoneNumber: prev.loanEquipmentInsuranceInformation.phoneNumber,
          displayPhoneNumber: `+1 ${loanApplicationUtility.FormatPhoneNumber(prev.loanEquipmentInsuranceInformation?.phoneNumber ?? '')}`
        };

        validInsurancePhoneNumber = (loanApplication.loanEquipmentInsuranceInformation?.phoneNumber?.toString().length ?? 0) > 0;
        this.setValidFormClass('insurance-agency', (loanApplication.loanEquipmentInsuranceInformation.companyName ?? '').length > 0);
        this.setValidFormClass('insurance-agent-name', (loanApplication.loanEquipmentInsuranceInformation.agentName ?? '').length > 0);
        this.setValidFormClass('insurance-phone-number', validInsurancePhoneNumber);
      }
    }

    if (loanApplication.loanType === LoanType.ProductionLineOfCredit
      && prev.loanType === LoanType.ProductionLineOfCredit
      && prev.loanProductionLineOfCredit) {
      loanApplication.loanProductionLineOfCredit = {
        ...loanApplication.loanProductionLineOfCredit,
        hasCurrentLoan: prev.loanProductionLineOfCredit.hasCurrentLoan,
        currentLoanBalance: prev.loanProductionLineOfCredit.currentLoanBalance,
      } as ProductionLineOfCredit;
      loanApplication.loanAmount = prev.loanAmount;
    }

    // Joint Applicant (all fields except ssn — backend already strips ssn before sending)
    if (prev.jointApplicant) {
      loanApplication.jointApplicant = {
        ...prev.jointApplicant,
        id: 0,
        dateOfBirth: new Date(prev.jointApplicant.dateOfBirth ?? new Date()),
        displayPhoneNumber: `+1 ${loanApplicationUtility.FormatPhoneNumber(prev.jointApplicant.phoneNumber.toString())}`,
        validPhoneNumber: prev.jointApplicant.phoneNumber.toString().length > 0,
        validEmail: prev.jointApplicant.emailAddress.length > 0
      };
    }

    // Entity Applicant (all fields)
    if (prev.entityApplicant) {
      loanApplication.entityApplicant = {
        ...prev.entityApplicant,
        id: 0,
        dateOrganized: new Date(prev.entityApplicant.dateOrganized ?? new Date()),
        validEIN: (prev.entityApplicant.ein ?? '').length > 0
      };
    }

    this.setState({ loanApplication, isFarmer, prefilled: true, validInsurancePhoneNumber, validLendingReferencePhoneNumber }, () => {
      this.validateGeneralQuestions();
      if (currentIsEquipment) this.validateEquipmentInformation();
      this.validateLendingReference();
      this.validateRevenueData();
      this.validateApplicantInfoData();
      toastUtility.showSuccessToast('Your application has been pre-filled.');
    });
  }

  async saveDraft(manualSave?: boolean): Promise<void> {
    const { loanApplication, draftToken } = this.state;
    const isFirstSave = !draftToken;
    try {
      if (this.props.userLoggedIn) {
        const result = await loanApplicationService.SaveDraft(loanApplication, draftToken);
        const isNewToken = result.token !== draftToken;
        this.setState(prev => {
          const updatedDrafts = isNewToken
            ? [...prev.availableDrafts.filter(d => d.accessToken !== result.token), { accessToken: result.token } as DraftApplicationSummary]
            : prev.availableDrafts;
          return { draftToken: result.token, availableDrafts: updatedDrafts };
        });
        if (result.wasEvicted) {
          toastUtility.showSuccessToast('Your oldest draft was automatically deleted to make room for this one.');
        }
      } else {
        // Security: omit personal information from anonymous draft saves
        const { applicant, jointApplicant, entityApplicant, ...anonSafeLoanApplication } = loanApplication;
        const token = await loanApplicationService.SaveDraftPublic(anonSafeLoanApplication, draftToken);
        const storedTokens = JSON.parse(localStorage.getItem('agcredit_draft_tokens') ?? '[]') as string[];
        if (!storedTokens.includes(token)) {
          storedTokens.push(token);
          localStorage.setItem('agcredit_draft_tokens', JSON.stringify(storedTokens));
        }
        this.setState({ draftToken: token });
      }
      if (manualSave) {
        toastUtility.showSuccessToast('Draft saved!');
      } else if (isFirstSave) {
        toastUtility.showSuccessToast('Your application is being saved automatically.');
      }
    } catch {
      // Silent fail — don't interrupt navigation
    }
  }

  async applyDraft(draft: LoanApplication): Promise<void> {
    // If the draft they have saved is different than the default loan type prop, we will skip loading the draft
    if (this.props.defaultLoanType == undefined || draft.loanType === this.props.defaultLoanType) {
      if (draft.loanDealerPurchase != undefined && draft.loanType !== LoanType.EquipmentAuctionPurchase) {
        if (draft.loanDealerPurchase.dealerId != undefined && draft.loanDealerPurchase.dealerId > 0) await this.setDealerState(draft.loanDealerPurchase.dealerId);
        if (draft.loanDealerPurchase.dealerLocationId != undefined && draft.loanDealerPurchase.dealerLocationId > 0) await this.setDealerLocationState(draft.loanDealerPurchase.dealerLocationId);
        if (draft.loanDealerPurchase.dealerSalesmanId != undefined && draft.loanDealerPurchase.dealerSalesmanId > 0) await this.setDealerSalesmanState(draft.loanDealerPurchase.dealerSalesmanId);
      }

      if (draft.loanAuctionInformation != undefined && draft.loanAuctionInformation.auctionEndDate != undefined) draft.loanAuctionInformation.auctionEndDate = new Date(draft.loanAuctionInformation.auctionEndDate);
      if (draft.applicant?.dateOfBirth) draft.applicant.dateOfBirth = new Date(draft.applicant.dateOfBirth);
      if (draft.jointApplicant?.dateOfBirth) draft.jointApplicant.dateOfBirth = new Date(draft.jointApplicant.dateOfBirth);
      if ((draft.entityApplicant as any)?.dateOfBirth) (draft.entityApplicant as any).dateOfBirth = new Date((draft.entityApplicant as any).dateOfBirth);
      let validInsurancePhoneNumber = (draft.loanEquipmentInsuranceInformation?.phoneNumber?.toString().length ?? 0) > 0;
      let validLendingReferencePhoneNumber = (draft.loanLendingReference?.phoneNumber?.toString().length ?? 0) > 0;
      const isFarmer = !!draft.primaryAgProduct;

      // applicant may be absent at runtime if draft was saved anonymously (PII stripped at save time)
      const safeApplicant = (draft.applicant as Applicant | undefined) ?? this.state.loanApplication.applicant;

      this.setState({ loanApplication: { ...draft, applicant: safeApplicant }, validInsurancePhoneNumber, validLendingReferencePhoneNumber, isFarmer }, () => {
        this.validateStartData();
        this.validateGeneralQuestions();
        if (AllEquipmentLoans.includes(draft.loanType)) this.validateEquipmentInformation();
        this.validateLendingReference();
        this.validateRevenueData();
        this.validateApplicantInfoData();
        if (draft.loanType === LoanType.ProductionLineOfCredit) {
          this.validateCashFlowExpenses();
          this.validateCashFlowIntroduction();
          this.validateCashFlowLineItem();
          this.validateCashFlowLoanPaymentItems();
          this.validateCashFlowOtherExpenseItems();
          this.validateCashFlowOtherIncome();
          this.validateCashFlowProductionIncome();
          this.validateCashFlowProductionPurchases();
          this.validateCashFlowProductionSales();
        }
        toastUtility.showSuccessToast('Your latest draft has been applied!');
      });
    }
  }

  private deleteDraft = async (token: string): Promise<void> => {
    if (this.props.userLoggedIn) {
      await loanApplicationService.DeleteDraft(token);
    } else {
      await loanApplicationService.DeleteDraftPublic(token);
      const tokens = JSON.parse(localStorage.getItem('agcredit_draft_tokens') ?? '[]') as string[];
      localStorage.setItem('agcredit_draft_tokens', JSON.stringify(tokens.filter(t => t !== token)));
    }
    this.setState(prev => ({ availableDrafts: prev.availableDrafts.filter(d => d.accessToken !== token) }));
  }

  private restoreDraft = async (token: string): Promise<void> => {
    try {
      await loanApplicationService.RestoreDraft(token);
      const drafts = await loanApplicationService.GetAllDrafts();
      this.setState({ availableDrafts: drafts });
    } catch (error: any) {
      const message = error?.response?.data || 'Failed to restore draft. Please try again.';
      toastUtility.showErrorToast(message);
    }
  }

  private resumeDraft = async (token: string): Promise<void> => {
    let draft: LoanApplication | null = null;
    if (this.props.userLoggedIn) {
      draft = await loanApplicationService.GetDraftByToken(token);
    } else {
      draft = await loanApplicationService.GetDraftPublic(token);
    }
    if (!draft) return;
    this.applyDraft(draft);
    this.setState({ draftToken: token, isResumingDraft: true });
  }

  resetLoanItems() {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.loanType === LoanType.GapFinancing || +loanApplication.loanType === 0) {
      loanApplication.loanDealerPurchase = undefined;
      loanApplication.loanEquipmentInformation = undefined;
      loanApplication.loanEquipmentInsuranceInformation = undefined;
      loanApplication.loanProductionLineOfCredit = undefined;
      loanApplication.loanAuctionInformation = undefined;

      if (+loanApplication.loanType === 0) {
        loanApplication.loanGapFinancing = undefined;
        loanApplication.loanAmount = 0;
      }

      this.setState({
        loanApplication: loanApplication,
        selectedDealer: {} as Dealer,
        selectedDealerLocation: {} as DealerLocation,
        selectedDealerSalesman: {} as DealerSalesman,
        otherSalesmanSelected: false,
        validOtherPhoneNumber: true,
        validInsurancePhoneNumber: false,
        validCollateral: false,
      });
    } else if (EquipmentOnlyLoans.includes(loanApplication.loanType)) {
      loanApplication.loanGapFinancing = undefined;
      loanApplication.loanProductionLineOfCredit = undefined;
      loanApplication.loanAuctionInformation = undefined;
      loanApplication.loanAmount = 0;

      this.setState({ loanApplication: loanApplication });
    } else if (loanApplication.loanType === LoanType.EquipmentAuctionPurchase) {
      loanApplication.loanGapFinancing = undefined;
      loanApplication.loanProductionLineOfCredit = undefined;
      loanApplication.loanAmount = 0;

      this.setState({ loanApplication: loanApplication });
    } else if (loanApplication.loanType === LoanType.ProductionLineOfCredit) {
      loanApplication.loanGapFinancing = undefined;
      loanApplication.loanAuctionInformation = undefined;
      loanApplication.loanDealerPurchase = undefined;
      loanApplication.loanEquipmentInformation = undefined;
      loanApplication.loanEquipmentInsuranceInformation = undefined;

      this.setState({
        loanApplication: loanApplication,
        selectedDealer: {} as Dealer,
        selectedDealerLocation: {} as DealerLocation,
        selectedDealerSalesman: {} as DealerSalesman,
        otherSalesmanSelected: false,
        validOtherPhoneNumber: true,
        validInsurancePhoneNumber: false,
        validCollateral: false,
      });
    }
  }

  setSelectedProduct(selectedProductId: number, index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    let selectedProduct: EquipmentProduct = this.state.productOptions.find(p => p.id === selectedProductId) ?? {} as EquipmentProduct;

    if (Object.keys(selectedProduct).length > 0) {
      equipment.new = true;
      equipment.equipmentProductId = selectedProduct.id;
      equipment.equipmentProduct = { ...selectedProduct };
      equipment.quantity = equipment.quantity ?? 1;
      equipment.unitPrice = selectedProduct.unitPrice;
      equipment.make = selectedProduct.make;
      equipment.model = selectedProduct.model;
      equipment.year = new Date().getFullYear().toString();

      loanApplication.loanEquipmentInformation = [...allEquipment];

      this.setState({ loanApplication: loanApplication }, () => this.setEquipmentPurchasePriceAmount(index));
    }
  }

  addEquipmentClicked(): void {
    let loanApplication = { ...this.state.loanApplication };
    let equipmentInformation: EquipmentInformation[];

    if (loanApplication.loanEquipmentInformation != undefined) {
      equipmentInformation = [...loanApplication.loanEquipmentInformation ?? []]
    } else {
      equipmentInformation = [];
    }

    equipmentInformation.push({
      index: equipmentInformation.length,
      price: loanApplication.loanType === LoanType.EquipmentAuctionPurchase ? 0 : undefined,
      unitPrice: loanApplication.loanType === LoanType.EquipmentAuctionPurchase ? 0 : undefined,
      totalPrice: loanApplication.loanType === LoanType.EquipmentAuctionPurchase ? 0 : undefined,
      quantity: 1,
      vin: undefined,
      make: undefined,
      model: undefined,
      year: undefined,
      new: false
    } as EquipmentInformation);

    loanApplication.loanEquipmentInformation = [...equipmentInformation];

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);
  }

  removeEquipmentClicked(index: number) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.loanEquipmentInformation != undefined) {
      loanApplication.loanEquipmentInformation.splice(index, 1);
    }

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);
  }

  setEquipmentConditionValue(isNew: boolean, index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    equipment.new = isNew;

    loanApplication.loanEquipmentInformation = [...allEquipment];

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);

  }

  setEquipmentQuantity(amount: number, index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    equipment.quantity = amount;

    loanApplication.loanEquipmentInformation = [...allEquipment];

    this.setValidFormClass(`equipment-quantity-${index}`, amount > 0);

    this.setState({ loanApplication: loanApplication }, () => { this.setEquipmentPurchasePriceAmount(index); this.validateEquipmentInformation(); });
  }

  setEquipmentUnitPriceAmount(amount: number, index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    equipment.unitPrice = amount;

    loanApplication.loanEquipmentInformation = [...allEquipment];

    this.setValidFormClass(`equipment-unit-price-${index}`, amount > 0);

    this.setState({ loanApplication: loanApplication }, () => { this.setEquipmentPurchasePriceAmount(index); this.validateEquipmentInformation(); });
  }

  setEquipmentPurchasePriceAmount(index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    equipment.totalPrice = (equipment.quantity ?? 0) * (equipment.unitPrice ?? 0);

    loanApplication.loanEquipmentInformation = [...allEquipment];

    this.setValidFormClass(`equipment-purchase-price-${index}`, equipment.totalPrice > 0);

    this.setState({ loanApplication: loanApplication }, () => { this.setLoanAmountState(); this.validateEquipmentInformation(); });
  }

  setEquipmentVinSerialValue(value: string, index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    equipment.vin = value;

    loanApplication.loanEquipmentInformation = [...allEquipment];

    this.setValidFormClass(`equipment-vin-${index}`, value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);
  }

  setEquipmentYearSerialValue(value: string, index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    equipment.year = value.substring(0, 4);

    loanApplication.loanEquipmentInformation = [...allEquipment];

    this.setValidFormClass(`equipment-year-${index}`, value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);
  }

  setEquipmentMakeSerialValue(value: string, index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    equipment.make = value;

    loanApplication.loanEquipmentInformation = [...allEquipment];

    this.setValidFormClass(`equipment-make-${index}`, value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);
  }

  setEquipmentModelSerialValue(value: string, index: number): void {
    let loanApplication = { ...this.state.loanApplication };

    let allEquipment = [...loanApplication.loanEquipmentInformation ?? []];
    let equipment = allEquipment[index];

    equipment.model = value;

    loanApplication.loanEquipmentInformation = [...allEquipment];

    this.setValidFormClass(`equipment-model-${index}`, value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);
  }

  setInsuranceAgencyState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let insuranceInfo: EquipmentInsuranceInformation = { ...loanApplication.loanEquipmentInsuranceInformation };

    insuranceInfo.companyName = value;
    loanApplication.loanEquipmentInsuranceInformation = { ...insuranceInfo };

    this.setValidFormClass('insurance-agency', value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);
  }

  setAgentNameState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let insuranceInfo: EquipmentInsuranceInformation = { ...loanApplication.loanEquipmentInsuranceInformation };

    insuranceInfo.agentName = value;
    loanApplication.loanEquipmentInsuranceInformation = { ...insuranceInfo };

    this.setValidFormClass('insurance-agent-name', value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateEquipmentInformation);
  }

  setAgentPhoneNumberState(value: string, data: any, event: any, formattedValue: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let insuranceInfo: EquipmentInsuranceInformation = { ...loanApplication.loanEquipmentInsuranceInformation };
    let validNumber = false;

    validNumber = isValidPhoneNumber(formattedValue);
    insuranceInfo.displayPhoneNumber = formattedValue;
    insuranceInfo.phoneNumber = value.substring(1, 11);
    loanApplication.loanEquipmentInsuranceInformation = { ...insuranceInfo };

    this.setValidFormClass('insurance-phone-number', validNumber);

    this.setState({ loanApplication: loanApplication, validInsurancePhoneNumber: validNumber }, this.validateEquipmentInformation);
  }

  setCustomerHireUseState(isCustomHire: boolean) {
    let loanApplication = { ...this.state.loanApplication };
    let dealerPurchase = { ...loanApplication.loanDealerPurchase };

    dealerPurchase.customHire = isCustomHire;
    loanApplication.loanDealerPurchase = { ...dealerPurchase };

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setDealerPurchaseAssetsState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let dealerPurchase = { ...loanApplication.loanDealerPurchase };

    dealerPurchase.totalAssets = amount;
    loanApplication.loanDealerPurchase = { ...dealerPurchase };

    this.setValidFormClass('total-assets', amount > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setDealerLiabilitiesState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let dealerPurchase = { ...loanApplication.loanDealerPurchase };

    dealerPurchase.totalLiabilities = amount;
    loanApplication.loanDealerPurchase = { ...dealerPurchase };

    this.setValidFormClass('total-liabilities', amount > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setIsFarmer(checked: boolean): void {
    let loanApplication = { ...this.state.loanApplication };

    if (!checked) {
      loanApplication.primaryAgProduct = undefined;
    } else {
      this.setValidFormClass('primary-ag-product', false);
    }

    this.setState({ isFarmer: checked, loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setSelectedPrimaryAgProduct(selectedAgProductCode: string): void {
    let loanApplication = { ...this.state.loanApplication };

    loanApplication.primaryAgProduct = selectedAgProductCode.length > 0 ? selectedAgProductCode : undefined;
    this.setValidFormClass('primary-ag-product', selectedAgProductCode.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setAuctionLotIdState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let auctionInformation = { ...loanApplication.loanAuctionInformation };

    auctionInformation.lotId = value;
    loanApplication.loanAuctionInformation = { ...auctionInformation };

    this.setValidFormClass('auction-lot-id', value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setAuctionEndDateState(value: Date) {
    let loanApplication = { ...this.state.loanApplication };
    let auctionInformation = { ...loanApplication.loanAuctionInformation };

    auctionInformation.auctionEndDate = value;
    loanApplication.loanAuctionInformation = { ...auctionInformation };

    this.setValidFormClass('auction-end-date', isDate(value));

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setAuctionListingURLState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let auctionInformation = { ...loanApplication.loanAuctionInformation };

    auctionInformation.listingUrl = value;
    loanApplication.loanAuctionInformation = { ...auctionInformation };

    this.setValidFormClass('auction-listing-url', value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setAuctionListingNatureState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let auctionInformation = { ...loanApplication.loanAuctionInformation };

    auctionInformation.natureOfBusiness = value;
    loanApplication.loanAuctionInformation = { ...auctionInformation };

    this.setState({ loanApplication: loanApplication });
  }

  setAuctionListingProductsState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let auctionInformation = { ...loanApplication.loanAuctionInformation };

    auctionInformation.products = value;
    loanApplication.loanAuctionInformation = { ...auctionInformation };

    this.setState({ loanApplication: loanApplication });
  }

  setAuctionListingServicesState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let auctionInformation = { ...loanApplication.loanAuctionInformation };

    auctionInformation.services = value;
    loanApplication.loanAuctionInformation = { ...auctionInformation };

    this.setState({ loanApplication: loanApplication });
  }

  setAuctionListingAreasState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let auctionInformation = { ...loanApplication.loanAuctionInformation };

    auctionInformation.geoAreas = value;
    loanApplication.loanAuctionInformation = { ...auctionInformation };

    this.setState({ loanApplication: loanApplication });
  }

  setGapFinancingAgenciesState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let gapFinancing = { ...loanApplication.loanGapFinancing };

    gapFinancing.governmentAgency = value;
    loanApplication.loanGapFinancing = { ...gapFinancing };

    this.setValidFormClass('government-agency', value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setGapFinancingAverageRequestState(value: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let gapFinancing = { ...loanApplication.loanGapFinancing };

    gapFinancing.averageReimbursementAmount = value;
    loanApplication.loanGapFinancing = { ...gapFinancing };

    this.setValidFormClass('average-request', (value ?? 0) > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setGapFinancingAverageReimbursementState(value: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let gapFinancing = { ...loanApplication.loanGapFinancing };

    gapFinancing.averageReimbursementLength = value;
    loanApplication.loanGapFinancing = { ...gapFinancing };

    this.setValidFormClass('reimbursement-time', (value ?? 0) > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setGapFinancingAssetsState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let gapFinancing = { ...loanApplication.loanGapFinancing };

    gapFinancing.totalAssets = amount;
    loanApplication.loanGapFinancing = { ...gapFinancing };

    this.setValidFormClass('total-assets', amount > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  setGapFinancingLiabilitiesState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let gapFinancing = { ...loanApplication.loanGapFinancing };

    gapFinancing.totalLiabilities = amount;
    loanApplication.loanGapFinancing = { ...gapFinancing };

    this.setValidFormClass('total-liabilities', amount > 0);

    this.setState({ loanApplication: loanApplication }, this.validateGeneralQuestions);
  }

  async setCashDownAmountState(amount: number): Promise<void> {
    let loanApplication = { ...this.state.loanApplication };
    let cashDown = { ...loanApplication.collateralEquityCashDown };

    if (amount > 0) {
      cashDown.amount = amount;
      loanApplication.collateralEquityCashDown = { ...cashDown };
    } else {
      // This is to satisfy validation
      loanApplication.collateralEquityCashDown = undefined;
    }

    let validCollateral = this.validateCollateral(loanApplication);
    this.setValidFormClass('collateral-section', validCollateral);
    this.setValidFormClass('collateral-tab', validCollateral);

    await this.setState({ loanApplication: loanApplication, validCollateral: validCollateral }, async () => { await this.setLoanAmountState() });
    return Promise.resolve();
  }

  setTradeDescriptionState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let trade = { ...loanApplication.collateralEquityTrade };

    if (value.length === 0 && (trade.value ?? 0) === 0 && (trade.stillOwe ?? 0) === 0) {
      // This is to satisfy validation
      loanApplication.collateralEquityTrade = undefined;
    } else {
      trade.description = value;
      loanApplication.collateralEquityTrade = { ...trade };
    }

    let validCollateral = this.validateCollateral(loanApplication);
    this.setValidFormClass('collateral-section', validCollateral);
    this.setValidFormClass('collateral-tab', validCollateral);

    this.setState({ loanApplication: loanApplication, validCollateral: validCollateral });
  }

  setTradeAmountState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let trade = { ...loanApplication.collateralEquityTrade };

    if (amount === 0 && (trade.description ?? '').length === 0 && (trade.stillOwe ?? 0) === 0) {
      // This is to satisfy validation
      loanApplication.collateralEquityTrade = undefined;
    } else {
      trade.value = amount;
      loanApplication.collateralEquityTrade = { ...trade };
    }

    let validCollateral = this.validateCollateral(loanApplication);
    this.setValidFormClass('collateral-section', validCollateral);
    this.setValidFormClass('collateral-tab', validCollateral);

    this.setState({ loanApplication: loanApplication, validCollateral: validCollateral }, this.setLoanAmountState);
  }

  setTradeAmountOwedState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let trade = { ...loanApplication.collateralEquityTrade };

    if (amount === 0 && (trade.description ?? '').length === 0 && (trade.value ?? 0) === 0) {
      // This is to satisfy validation
      loanApplication.collateralEquityTrade = undefined;
    } else {
      trade.stillOwe = amount;
      loanApplication.collateralEquityTrade = { ...trade };
    }

    let validCollateral = this.validateCollateral(loanApplication);
    this.setValidFormClass('collateral-section', validCollateral);
    this.setValidFormClass('collateral-tab', validCollateral);

    this.setState({ loanApplication: loanApplication, validCollateral: validCollateral }, this.setLoanAmountState);
  }

  async setLoanAmountState(): Promise<void> {
    // Gap financing doesn't use this auto-calculation
    if (EquipmentOnlyLoans.includes(this.state.loanApplication.loanType)) {
      let loanApplication = { ...this.state.loanApplication };
      let loanAmount = (this.state.loanApplication.loanEquipmentInformation ?? []).reduce((sum: number, item: EquipmentInformation) => sum + (item.totalPrice ?? 0), 0)
      let equityAmount: number = 0;

      if (loanApplication.collateralEquityCashDown != undefined) {
        equityAmount += (loanApplication.collateralEquityCashDown.amount ?? 0);
      }

      if (loanApplication.collateralEquityTrade != undefined) {
        equityAmount += (loanApplication.collateralEquityTrade.value ?? 0) - (loanApplication.collateralEquityTrade.stillOwe ?? 0);
      }

      loanApplication.loanAmount = loanAmount - equityAmount;
      await this.setState({ loanApplication: loanApplication });
      return Promise.resolve();
    }
  }

  setOtherDescriptionState(value: string, index: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let allOther = [...loanApplication.collateralEquityOtherCollateral ?? []];
    let other = allOther[index];

    other.description = value;
    loanApplication.collateralEquityOtherCollateral = [...allOther];

    let validCollateral = this.validateCollateral(loanApplication);
    this.setValidFormClass('collateral-section', validCollateral);
    this.setValidFormClass('collateral-tab', validCollateral);

    this.setState({ loanApplication: loanApplication, validCollateral: validCollateral });
  }

  setOtherAmountState(amount: number, index: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let allOther = [...loanApplication.collateralEquityOtherCollateral ?? []];
    let other = allOther[index];

    other.value = amount;
    loanApplication.collateralEquityOtherCollateral = [...allOther];

    let validCollateral = this.validateCollateral(loanApplication);
    this.setValidFormClass('collateral-section', validCollateral);
    this.setValidFormClass('collateral-tab', validCollateral);

    this.setState({ loanApplication: loanApplication, validCollateral: validCollateral });
  }

  addOtherCollateralClicked(): void {
    let loanApplication = { ...this.state.loanApplication };
    let otherCollateral: CollateralEquityOtherCollateral[];

    if (loanApplication.collateralEquityOtherCollateral != undefined) {
      otherCollateral = [...loanApplication.collateralEquityOtherCollateral ?? []]
    } else {
      otherCollateral = [];
    }

    otherCollateral.push({
      index: otherCollateral.length,
      description: undefined,
      value: undefined
    } as CollateralEquityOtherCollateral);

    loanApplication.collateralEquityOtherCollateral = [...otherCollateral];

    let validCollateral = this.validateCollateral(loanApplication);
    this.setValidFormClass('collateral-section', validCollateral);
    this.setValidFormClass('collateral-tab', validCollateral);

    this.setState({ loanApplication: loanApplication, validCollateral: validCollateral });
  }

  removeOtherCollateralClicked(index: number): void {
    let loanApplication = { ...this.state.loanApplication };
    let otherCollateral = [...loanApplication.collateralEquityOtherCollateral ?? []];

    otherCollateral.splice(index, 1);
    loanApplication.collateralEquityOtherCollateral = otherCollateral.length > 0 ? [...otherCollateral] : undefined;

    let validCollateral = this.validateCollateral(loanApplication);
    this.setValidFormClass('collateral-section', validCollateral);
    this.setValidFormClass('collateral-tab', validCollateral);

    this.setState({ loanApplication: loanApplication, validCollateral: validCollateral });
  }

  setCashFlowHasCurrentLoan(checked: boolean, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let productionLineOfCredit = { ...loanApplication.loanProductionLineOfCredit };

    productionLineOfCredit.hasCurrentLoan = checked;
    if (!checked) productionLineOfCredit.currentLoanBalance = undefined;

    loanApplication.loanProductionLineOfCredit = { ...productionLineOfCredit } as ProductionLineOfCredit;
    this.setValidFormClass(validationId, productionLineOfCredit.hasCurrentLoan != undefined);
    this.setState({ loanApplication: loanApplication }, () => { this.validateGeneralQuestions(); });
  }

  setCashFlowCurrentLoanBalance(validationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let productionLineOfCredit = { ...loanApplication.loanProductionLineOfCredit };

    productionLineOfCredit.currentLoanBalance = value;

    loanApplication.loanProductionLineOfCredit = { ...productionLineOfCredit } as ProductionLineOfCredit;
    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateGeneralQuestions(); });
  }

  setCashFlowCycleStartDate(selectedDate: Date, validationId: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    cashFlow.introductionSection.cycleStart = selectedDate;

    this.setValidFormClass(validationId, selectedDate != undefined);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowIntroduction(); });
  }

  setCashFlowCycleEndDate(selectedDate: Date, validationId: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    cashFlow.introductionSection.cycleEnd = selectedDate;

    this.setValidFormClass(validationId, selectedDate != undefined);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowIntroduction(); });
  }

  setCashFlowCycleAsOfDate(selectedDate: Date, validationId: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    cashFlow.introductionSection.asOfDate = selectedDate;

    this.setValidFormClass(validationId, selectedDate != undefined);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowIntroduction(); });
  }

  setCashFlowTypeState(actual: boolean): void {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    cashFlow.introductionSection.projected = actual;

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowIntroduction(); });
  }

  setCashFlowIncomeType(incomeType: CashFlowIncomeType, checked: boolean) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    if (checked) {
      cashFlow.incomeSection.incomeTypes?.push(incomeType);
      (cashFlow.incomeSection.incomeLineItems ?? []).push({
        incomeType: incomeType
      } as CashFlowProductionIncome);
    } else {
      cashFlow.incomeSection.incomeTypes = cashFlow.incomeSection.incomeTypes?.filter(it => it !== incomeType);
      cashFlow.incomeSection.incomeLineItems = cashFlow.incomeSection.incomeLineItems?.filter(it => it.incomeType !== incomeType);
    }

    this.setState({ loanApplication: loanApplication }, () => { this.setValidationFlags(incomeType, checked); });
  }

  setValidationFlags(incomeType: CashFlowIncomeType, checked: boolean) {
    switch (incomeType) {
      case CashFlowIncomeType.CropProduction:
        this.setState({ validTopLevelLineItemData: !checked, validCashFlowProductionIncomeData: !checked }, this.validateCashFlowLineItem);
        break;

      case CashFlowIncomeType.LivestockAndPoultryRaised:
        this.setState({ validTopLevelLineItemData: !checked, validCashFlowProductionSaleData: !checked }, this.validateCashFlowLineItem);
        break;

      case CashFlowIncomeType.LivestockAndPoultryPurchaseSale:
      case CashFlowIncomeType.DairyLivestock:
        this.setState({ validTopLevelLineItemData: !checked, validCashFlowProductionPurchaseData: !checked }, this.validateCashFlowLineItem);
        break;

      case CashFlowIncomeType.MilkProduction:
      case CashFlowIncomeType.LivestockProduct:
        this.setState({ validTopLevelLineItemData: !checked, validCashFlowProductionSaleData: !checked }, this.validateCashFlowLineItem);
        break;

      default:
        break;
    }
  }

  addCashFlowIncomeLineItem(incomeType: CashFlowIncomeType) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    (cashFlow.incomeSection.incomeLineItems ?? []).push({
      incomeType: incomeType
    } as CashFlowIncomeLineItem);

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLineItem(); });
  }

  removeCashFlowIncomeType(incomeType: CashFlowIncomeType, index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    cashFlow.incomeSection.incomeLineItems?.splice(index, 1);

    if ((cashFlow.incomeSection.incomeLineItems ?? []).findIndex(li => li.incomeType === incomeType) === -1) {
      cashFlow.incomeSection.incomeTypes = cashFlow.incomeSection.incomeTypes?.filter(it => it !== incomeType);
    }

    this.setState({ loanApplication: loanApplication }, () => { this.setValidationFlags(incomeType, false); });
  }

  setCashFlowLineItemDescription(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionIncome = incomeLineItems[index] ?? {};
    productionIncome.description = value;

    this.setValidFormClass(validationId, value?.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLineItem(); });
  }

  setCashFlowLineItemType(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionIncome = incomeLineItems[index] ?? {};
    productionIncome.type = value;

    this.setValidFormClass(validationId, value?.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLineItem(); });
  }

  setCashFlowLineItemLocation(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionIncome = incomeLineItems[index] ?? {};
    productionIncome.location = value;

    //this.setValidFormClass(validationId, value?.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLineItem(); });
  }

  setCashFlowLineItemPurchaseSaleType(type: CashFlowLineItemPurchaseSaleType, index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionIncome = incomeLineItems[index] ?? {};
    productionIncome.purchaseSaleType = type;

    switch (type) {
      case CashFlowLineItemPurchaseSaleType.PurchaseOnly:
        if (productionIncome.productionPurchase != undefined) {
          productionIncome.productionPurchase.saleDollarPerUnit = undefined;
          productionIncome.productionPurchase.saleWeightPerUnit = undefined;
          productionIncome.productionPurchase.saleTotalAmount = undefined;
          productionIncome.productionPurchase.netTotalAmount = undefined;
        }
        break;

      case CashFlowLineItemPurchaseSaleType.SaleOnly:
        if (productionIncome.productionPurchase != undefined) {
          productionIncome.productionPurchase.purchaseDollarPerUnit = undefined;
          productionIncome.productionPurchase.purchaseWeightPerUnit = undefined;
          productionIncome.productionPurchase.purchaseTotalAmount = undefined;
          productionIncome.productionPurchase.netTotalAmount = productionIncome.productionPurchase.saleTotalAmount;
        }
        break;

      default:
        break;
    }

    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalProductionIncome(this.validateCashFlowProductionPurchases); });
  }

  setCashFlowProductionUnitOfMeasure(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionIncome != undefined) {
      incomeLineItem.productionIncome.unitOfMeasure = value;
    } else {
      incomeLineItem.productionIncome = {
        unitOfMeasure: value,
        percentageOwned: 100 //defaulting
      } as CashFlowProductionIncome;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowProductionIncome(); });
  }

  setCashFlowProductionIncomeAcres(value: number, index: number, validationId: string, totalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionIncome != undefined) {
      incomeLineItem.productionIncome.acres = value;
    } else {
      incomeLineItem.productionIncome = {
        acres: value,
        percentageOwned: 100 //defaulting
      } as CashFlowProductionIncome;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionIncomeUnits(index, totalValidationId); });
  }

  setCashFlowProductionIncomeYield(value: number, index: number, validationId: string, totalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionIncome != undefined) {
      incomeLineItem.productionIncome.yield = value;
    } else {
      incomeLineItem.productionIncome = {
        yield: value,
        percentageOwned: 100 //defaulting
      } as CashFlowProductionIncome;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionIncomeUnits(index, totalValidationId); });
  }

  setCashFlowProductionIncomeUnits(index: number, totalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];

    let productionIncome = incomeLineItems[index].productionIncome ?? {};
    productionIncome.numberOfUnits = (productionIncome.acres ?? 1) * (productionIncome.yield ?? 1);

    this.setValidFormClass(totalValidationId, productionIncome.numberOfUnits > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionIncomeTotalShareUnits(index); });
  }

  setCashFlowProductionIncomeSharedPercentage(index: number, validationId: string, value?: number,) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionIncome != undefined) {
      incomeLineItem.productionIncome.percentageOwned = value;
    } else {
      incomeLineItem.productionIncome = {
        percentageOwned: value
      } as CashFlowProductionIncome;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) >= 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionIncomeTotalShareUnits(index); });
  }

  setCashFlowProductionIncomeTotalShareUnits(index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    let shareOfUnitsValue: number = (incomeLineItem.productionIncome?.numberOfUnits ?? 0) * ((incomeLineItem.productionIncome?.percentageOwned ?? 100) / 100);
    if (incomeLineItem.productionIncome != undefined) {
      incomeLineItem.productionIncome.shareOfUnits = shareOfUnitsValue;
    }

    this.setValidFormClass(`crop-production-percentage-my-share-${index}`, shareOfUnitsValue >= 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowProductionIncome(); });
  }

  setCashFlowProductionIncomeAmountForFarmUse(index: number, validationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionIncome != undefined) {
      incomeLineItem.productionIncome.amountFarmUse = value;
    }

    this.setValidFormClass(validationId, (value ?? 0) >= 0 && (value ?? 0) <= (incomeLineItem.productionIncome?.shareOfUnits ?? 0));
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowProductionIncome(); this.setCashFlowProductionSaleAutoFillFromFarmUse(index); });
  }

  setCashFlowProductionSaleAutoFillFromFarmUse(index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionIncome != undefined) {
      let amountFarmUse = (incomeLineItem.productionIncome.amountFarmUse ?? 0);
      let shareOfUnits = (incomeLineItem.productionIncome.shareOfUnits ?? 0);

      if (amountFarmUse < shareOfUnits) {
        if (incomeLineItem.productionSale != undefined) {
          incomeLineItem.productionSale.numberOfUnits = shareOfUnits - amountFarmUse;
        } else {
          incomeLineItem.productionSale = {
            numberOfUnits: shareOfUnits - amountFarmUse
          } as CashFlowProductionSale;

          incomeLineItems[index] = { ...incomeLineItem };
          if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
        }
      } else {
        if (incomeLineItem.productionSale != undefined) {
          incomeLineItem.productionSale.numberOfUnits = 0;
          incomeLineItem.productionSale.pricePerUnit = undefined;
          incomeLineItem.productionSale.totalAmount = undefined;
        }
      }
    }

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowProductionSales(); });
  }

  setCashFlowProductionPurchaseWeight(index: number, validationId: string, totalValidationId: string, netTotalValidationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionPurchase != undefined) {
      incomeLineItem.productionPurchase.purchaseWeightPerUnit = value;
    } else {
      incomeLineItem.productionPurchase = {
        purchaseWeightPerUnit: value
      } as CashFlowProductionPurchase;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionPurchaseTotalAmount(index, totalValidationId, netTotalValidationId); });
  }

  setCashFlowProductionPurchaseUnits(index: number, validationId: string, totalValidationId: string, netTotalValidationId: string, value?: number,) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionPurchase != undefined) {
      incomeLineItem.productionPurchase.numberOfUnits = value;
    } else {
      incomeLineItem.productionPurchase = {
        numberOfUnits: value
      } as CashFlowProductionPurchase;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionPurchaseTotalAmount(index, totalValidationId, netTotalValidationId); });
  }

  setCashFlowProductionPurchaseDollarPerUnit(value: number, index: number, validationId: string, totalValidationId: string, netTotalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionPurchase != undefined) {
      incomeLineItem.productionPurchase.purchaseDollarPerUnit = value;
    } else {
      incomeLineItem.productionPurchase = {
        purchaseDollarPerUnit: value
      } as CashFlowProductionPurchase;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionPurchaseTotalAmount(index, totalValidationId, netTotalValidationId); });
  }

  setCashFlowProductionPurchaseTotalAmount(index: number, totalValidationId: string, netTotalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionPurchase = incomeLineItems[index].productionPurchase ?? {};
    productionPurchase.purchaseTotalAmount = (productionPurchase.numberOfUnits ?? 0) * (productionPurchase.purchaseWeightPerUnit ?? 0) * (productionPurchase.purchaseDollarPerUnit ?? 0);


    this.setValidFormClass(totalValidationId, productionPurchase.purchaseTotalAmount > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionPurchaseNetTotalAmount(index, netTotalValidationId); });
  }

  setCashFlowProductionPurchaseSaleDollarPerUnit(value: number, index: number, validationId: string, totalValidationId: string, netTotalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionPurchase != undefined) {
      incomeLineItem.productionPurchase.saleDollarPerUnit = value;
    } else {
      incomeLineItem.productionPurchase = {
        saleDollarPerUnit: value
      } as CashFlowProductionPurchase;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionPurchaseSaleTotalAmount(index, totalValidationId, netTotalValidationId); });
  }

  setCashFlowProductionPurchaseSaleWeight(index: number, validationId: string, totalValidationId: string, netTotalValidationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionPurchase != undefined) {
      incomeLineItem.productionPurchase.saleWeightPerUnit = value;
    } else {
      incomeLineItem.productionPurchase = {
        saleWeightPerUnit: value
      } as CashFlowProductionPurchase;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionPurchaseSaleTotalAmount(index, totalValidationId, netTotalValidationId); });
  }

  setCashFlowProductionPurchaseSaleTotalAmount(index: number, totalValidationId: string, netTotalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionPurchase = incomeLineItems[index].productionPurchase ?? {};
    productionPurchase.saleTotalAmount = (productionPurchase.numberOfUnits ?? 0) * (productionPurchase.saleWeightPerUnit ?? 0) * (productionPurchase.saleDollarPerUnit ?? 0);

    this.setValidFormClass(totalValidationId, productionPurchase.saleTotalAmount > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionPurchaseNetTotalAmount(index, netTotalValidationId); });
  }

  setCashFlowProductionPurchaseNetTotalAmount(index: number, netTotalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionPurchase = incomeLineItems[index].productionPurchase ?? {};
    productionPurchase.netTotalAmount = (productionPurchase.saleTotalAmount ?? 0) - (productionPurchase.purchaseTotalAmount ?? 0);

    this.setValidFormClass(netTotalValidationId, productionPurchase.netTotalAmount != undefined);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalProductionIncome(this.validateCashFlowProductionPurchases) });
  }

  setCashFlowProductionSaleCommodityProduced(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.commodityProduced = value;
    } else {
      incomeLineItem.productionSale = {
        commodityProduced: value
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value?.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowProductionSales(); });
  }

  setCashFlowProductionSaleCommodityMeasure(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.commodityMeasure = value;
    } else {
      incomeLineItem.productionSale = {
        commodityMeasure: value
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value?.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowProductionSales(); });
  }

  setCashFlowProductionSaleWeight(index: number, validationId: string, totalValidationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.weightPerUnit = value;
    } else {
      incomeLineItem.productionSale = {
        weightPerUnit: value,
        percentageOwned: 100
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionSaleTotalAmount(index, totalValidationId); });
  }

  setCashFlowProductionSaleUnits(index: number, validationId: string, totalValidationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.numberOfUnits = value;
    } else {
      incomeLineItem.productionSale = {
        numberOfUnits: value,
        percentageOwned: 100
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionSaleTotalAmount(index, totalValidationId); });
  }

  setCashFlowProductionSalePricePerUnit(value: number, index: number, validationId: string, totalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.pricePerUnit = value;
    } else {
      incomeLineItem.productionSale = {
        pricePerUnit: value,
        percentageOwned: 100
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionSaleTotalAmount(index, totalValidationId); });
  }

  setCashFlowProductionSaleTotalAmount(index: number, totalValidationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionSale = incomeLineItems[index].productionSale ?? {};
    productionSale.totalAmount = ((productionSale.weightPerUnit ?? 1) * (productionSale.numberOfUnits ?? 1)) * ((productionSale?.percentageOwned ?? 100) / 100) * (productionSale.pricePerUnit ?? 1);

    this.setValidFormClass(totalValidationId, productionSale.totalAmount > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalProductionIncome(this.validateCashFlowProductionSales) });
  }

  setCashFlowProductionSaleSharedPercentage(index: number, validationId: string, totalValidationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.percentageOwned = value;
    } else {
      incomeLineItem.productionSale = {
        percentageOwned: value
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionSaleTotalAmount(index, totalValidationId); });
  }

  setCashFlowProductionSaleHead(index: number, validationId: string, totalValidationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.numberOfHead = value;
    } else {
      incomeLineItem.productionSale = {
        numberOfHead: value
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionSaleTotalProduction(index, totalValidationId); });
  }

  setCashFlowProductionSaleProductionPerHead(index: number, validationId: string, totalValidationId: string, value?: number,) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.productionPerHead = value;
    } else {
      incomeLineItem.productionSale = {
        productionPerHead: value
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionSaleTotalProduction(index, totalValidationId); });
  }

  setCashFlowProductionSaleTotalProduction(index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeLineItems ?? []];

    let productionSale = incomeLineItems[index].productionSale ?? {};
    productionSale.totalProduction = (productionSale.productionPerHead ?? 0) * (productionSale.numberOfHead ?? 0);

    this.setValidFormClass(validationId, productionSale.totalProduction > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionSaleTotalSalesAmount(index); });
  }

  setCashFlowProductionSaleMarketPrice(value: number, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];
    let incomeLineItem = { ...incomeLineItems[index] };

    if (incomeLineItem.productionSale != undefined) {
      incomeLineItem.productionSale.marketPrice = value;
    } else {
      incomeLineItem.productionSale = {
        marketPrice: value
      } as CashFlowProductionSale;

      incomeLineItems[index] = { ...incomeLineItem };
      if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems = incomeLineItems;
    }

    this.setValidFormClass(validationId, value > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowProductionSaleTotalSalesAmount(index); });
  }

  setCashFlowProductionSaleTotalSalesAmount(index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];

    let productionSale = incomeLineItems[index].productionSale ?? {};
    productionSale.totalAmount = (productionSale.totalProduction ?? 0) * (productionSale.marketPrice ?? 0);

    this.setValidFormClass(`milk-sale-total-amount-${index}`, productionSale.totalAmount > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalProductionIncome(this.validateCashFlowProductionSales) });
  }

  setCashFlowTotalProductionIncome(validationCallback: () => void) {
    let loanApplication = { ...this.state.loanApplication };
    let incomeLineItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow.incomeSection.incomeLineItems ?? []];

    let totalProductionIncome = incomeLineItems?.reduce((subTotal, li) => {
      return subTotal + ((li.productionPurchase?.netTotalAmount ?? 0) + (li.productionSale?.totalAmount ?? 0))
    }, 0);

    if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.totalProductionIncome = totalProductionIncome;
    this.setState({ loanApplication: loanApplication }, validationCallback);
  }

  setCashFlowOtherIncomeType(incomeType: CashFlowIncomeType, checked: boolean) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    if (checked) {
      cashFlow.incomeSection.otherIncomeTypes?.push(incomeType);

      switch (incomeType) {
        case CashFlowIncomeType.OtherFarmIncome:
          (cashFlow.incomeSection.otherFarmIncome ?? []).push({
            incomeType: incomeType
          } as CashFlowOtherFarmIncome)
          break;

        case CashFlowIncomeType.NonFarmIncome:
          (cashFlow.incomeSection.nonFarmIncome ?? []).push({
            incomeType: incomeType
          } as CashFlowNonFarmIncome)
          break;

        case CashFlowIncomeType.CapitalSaleIncome:
          (cashFlow.incomeSection.capitalSalesIncome ?? []).push({
            incomeType: incomeType
          } as CashFlowCapitalSalesIncome)
          break;

        default:
          break;
      }
    } else {
      cashFlow.incomeSection.otherIncomeTypes = cashFlow.incomeSection.otherIncomeTypes?.filter(it => it !== incomeType);

      switch (incomeType) {
        case CashFlowIncomeType.OtherFarmIncome:
          cashFlow.incomeSection.otherFarmIncome = cashFlow.incomeSection.otherFarmIncome?.filter(it => it.incomeType !== incomeType);
          break;

        case CashFlowIncomeType.NonFarmIncome:
          cashFlow.incomeSection.nonFarmIncome = cashFlow.incomeSection.nonFarmIncome?.filter(it => it.incomeType !== incomeType);
          break;

        case CashFlowIncomeType.CapitalSaleIncome:
          cashFlow.incomeSection.capitalSalesIncome = cashFlow.incomeSection.capitalSalesIncome?.filter(it => it.incomeType !== incomeType);
          break;

        default:
          break;
      }

    }

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  addCashFlowOtherIncomeItem(incomeType: CashFlowIncomeType) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    switch (incomeType) {
      case CashFlowIncomeType.OtherFarmIncome:
        (cashFlow.incomeSection.otherFarmIncome ?? []).push({
          incomeType: incomeType
        }) as CashFlowOtherFarmIncome;
        break;

      case CashFlowIncomeType.NonFarmIncome:
        (cashFlow.incomeSection.nonFarmIncome ?? []).push({
          incomeType: incomeType
        }) as CashFlowNonFarmIncome;
        break;

      case CashFlowIncomeType.CapitalSaleIncome:
        (cashFlow.incomeSection.capitalSalesIncome ?? []).push({
          incomeType: incomeType
        }) as CashFlowCapitalSalesIncome;
        break;

      default:
        break;
    }

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  removeCashFlowOtherIncomeType(incomeType: CashFlowIncomeType, index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    switch (incomeType) {
      case CashFlowIncomeType.OtherFarmIncome:
        cashFlow.incomeSection.otherFarmIncome?.splice(index, 1);

        if ((cashFlow.incomeSection.otherFarmIncome ?? []).findIndex(pi => pi.incomeType === incomeType) === -1) {
          cashFlow.incomeSection.otherIncomeTypes = cashFlow.incomeSection.otherIncomeTypes?.filter(it => it !== incomeType);
        }
        break;

      case CashFlowIncomeType.NonFarmIncome:
        cashFlow.incomeSection.nonFarmIncome?.splice(index, 1);

        if ((cashFlow.incomeSection.nonFarmIncome ?? []).findIndex(pi => pi.incomeType === incomeType) === -1) {
          cashFlow.incomeSection.otherIncomeTypes = cashFlow.incomeSection.otherIncomeTypes?.filter(it => it !== incomeType);
        }
        break;

      case CashFlowIncomeType.CapitalSaleIncome:
        cashFlow.incomeSection.capitalSalesIncome?.splice(index, 1);

        if ((cashFlow.incomeSection.capitalSalesIncome ?? []).findIndex(pi => pi.incomeType === incomeType) === -1) {
          cashFlow.incomeSection.otherIncomeTypes = cashFlow.incomeSection.otherIncomeTypes?.filter(it => it !== incomeType);
        }
        break;

      default:
        break;
    }

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  setCashFlowOtherFarmIncomeType(otherFarmIncomeType: OtherFarmIncomeType, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let otherFarmIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherFarmIncome ?? []];

    let otherFarmIncome = otherFarmIncomes[index];
    otherFarmIncome.otherIncomeType = otherFarmIncomeType;

    this.setValidFormClass(validationId, true);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  setCashFlowOtherFarmIncomeDescription(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let otherFarmIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherFarmIncome ?? []];

    let otherFarmIncome = otherFarmIncomes[index];
    otherFarmIncome.description = value;

    this.setValidFormClass(validationId, value?.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  setCashFlowOtherFarmIncomeAmount(index: number, validationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let otherFarmIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherFarmIncome ?? []];

    let otherFarmIncome = otherFarmIncomes[index];
    otherFarmIncome.totalAmount = value;

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalOtherFarmIncomeAmount(this.validateCashFlowOtherIncome) });
  }

  setCashFlowTotalOtherFarmIncomeAmount(validationCallback: () => void) {
    let loanApplication = { ...this.state.loanApplication };
    let otherFarmIncomeItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherFarmIncome ?? []];

    let totalOtherFarmIncome = otherFarmIncomeItems?.reduce((subTotal, ofi) => {
      return subTotal + (ofi.totalAmount ?? 0)
    }, 0);

    if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.totalOtherFarmIncome = totalOtherFarmIncome;
    this.setState({ loanApplication: loanApplication }, validationCallback);
  }

  setCashFlowNonFarmIncomeType(nonFarmIncomeType: NonFarmIncomeType, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let nonFarmIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.nonFarmIncome ?? []];

    let nonFarmIncome = nonFarmIncomes[index];
    nonFarmIncome.nonFarmIncomeType = nonFarmIncomeType;

    this.setValidFormClass(validationId, true);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  setCashFlowNonFarmIncomeDescription(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let nonFarmIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.nonFarmIncome ?? []];

    let nonFarmIncome = nonFarmIncomes[index];
    nonFarmIncome.description = value;

    this.setValidFormClass(validationId, value?.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  setCashFlowNonFarmIncomeAmount(index: number, validationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let nonFarmIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.nonFarmIncome ?? []];

    let nonFarmIncome = nonFarmIncomes[index];
    nonFarmIncome.totalAmount = value;

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalNonFarmIncomeAmount(this.validateCashFlowOtherIncome) });
  }

  setCashFlowTotalNonFarmIncomeAmount(validationCallback: () => void) {
    let loanApplication = { ...this.state.loanApplication };
    let nonFarmIncomeItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.nonFarmIncome ?? []];

    let totalNonFarmIncome = nonFarmIncomeItems?.reduce((subTotal, nfi) => {
      return subTotal + (nfi.totalAmount ?? 0)
    }, 0);

    if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.totalNonFarmIncome = totalNonFarmIncome;
    this.setState({ loanApplication: loanApplication }, validationCallback);
  }

  setCashFlowCapitalSaleIncomeType(capitalSaleIncomeType: CapitalSalesIncomeType, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let capitalSaleIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.capitalSalesIncome ?? []];

    let capitalSaleIncome = capitalSaleIncomes[index];
    capitalSaleIncome.capitalSalesIncomeType = capitalSaleIncomeType;

    this.setValidFormClass(validationId, true);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  setCashFlowCapitalSaleIncomeDescription(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let capitalSaleIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.capitalSalesIncome ?? []];

    let capitalSaleIncome = capitalSaleIncomes[index];
    capitalSaleIncome.description = value;

    this.setValidFormClass(validationId, value?.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherIncome(); });
  }

  setCashFlowCapitalSaleIncomeAmount(index: number, validationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let capitalSaleIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.capitalSalesIncome ?? []];

    let capitalSaleIncome = capitalSaleIncomes[index];
    capitalSaleIncome.totalAmount = value;

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalCapitalSaleIncomeAmount(this.validateCashFlowOtherIncome) });
  }

  setCashFlowTotalCapitalSaleIncomeAmount(validationCallback: () => void) {
    let loanApplication = { ...this.state.loanApplication };
    let capitalSaleIncomes = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.capitalSalesIncome ?? []];


    let totalCapitalSaleIncome = capitalSaleIncomes?.reduce((subTotal, csi) => {
      return subTotal + (csi.totalAmount ?? 0)
    }, 0);

    if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.totalCapitalSalesIncome = totalCapitalSaleIncome;
    this.setState({ loanApplication: loanApplication }, validationCallback);
  }

  setCashFlowExpenseType(expenseType: CashFlowExpenseType, checked: boolean) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    if (checked) {
      cashFlow.expensesSection.expenseTypes?.push(expenseType);
      (cashFlow.expensesSection.expenses ?? []).push({
        expenseType: expenseType
      } as CashFlowExpense)
    } else {
      cashFlow.expensesSection.expenseTypes = cashFlow.expensesSection.expenseTypes?.filter(it => it !== expenseType);
      cashFlow.expensesSection.expenses = cashFlow.expensesSection.expenses?.filter(it => it.expenseType !== expenseType);
    }

    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalExpenseAmount(this.validateCashFlowExpenses); });
  }

  setCashFlowExpenseAmount(expenseType: CashFlowExpenseType, validationId: string, amount?: number,) {
    let loanApplication = { ...this.state.loanApplication };
    let expenses = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses ?? []];

    let expense = expenses.find(e => e.expenseType === expenseType) ?? {};
    expense.totalAmount = amount;

    this.setValidFormClass(validationId, (amount ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalExpenseAmount(this.validateCashFlowExpenses) });
  }

  setCashFlowTotalExpenseAmount(validationCallback: () => void) {
    let loanApplication = { ...this.state.loanApplication };
    let expenses = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses ?? []];

    let totalExpenses = expenses?.reduce((subTotal, e) => {
      return subTotal + (e.totalAmount ?? 0)
    }, 0);

    if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.expensesSection.totalExpenseAmount = totalExpenses;
    this.setState({ loanApplication: loanApplication }, validationCallback);
  }

  setCashFlowOtherExpenseType(otherExpenseType: CashFlowOtherExpenseType, checked: boolean) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    if (checked) {
      cashFlow.otherExpenseSection.otherExpenseTypes?.push(otherExpenseType);
      (cashFlow.otherExpenseSection.otherExpenseItems ?? []).push({
        otherExpenseType: otherExpenseType
      } as CashFlowOtherExpense)
    } else {
      cashFlow.otherExpenseSection.otherExpenseTypes = cashFlow.otherExpenseSection.otherExpenseTypes?.filter(ot => ot !== otherExpenseType);
      cashFlow.otherExpenseSection.otherExpenseItems = cashFlow.otherExpenseSection.otherExpenseItems?.filter(ot => ot.otherExpenseType !== otherExpenseType);
    }

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherExpenseItems(); });
  }

  addCashFlowOtherExpenseItem(otherExpenseType: CashFlowOtherExpenseType) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    (cashFlow.otherExpenseSection.otherExpenseItems ?? []).push({
      otherExpenseType: otherExpenseType
    } as CashFlowOtherExpense);

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherExpenseItems(); });
  }

  removeCashFlowOtherExpenseType(otherExpenseType: CashFlowOtherExpenseType, index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    cashFlow.otherExpenseSection.otherExpenseItems?.splice(index, 1);

    if ((cashFlow.otherExpenseSection.otherExpenseItems ?? []).findIndex(oei => oei.otherExpenseType === otherExpenseType) === -1) {
      cashFlow.otherExpenseSection.otherExpenseTypes = cashFlow.otherExpenseSection.otherExpenseTypes?.filter(oet => oet !== otherExpenseType);
    }

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherExpenseItems(); });
  }

  setCashFlowOtherExpenseDescription(index: number, validationId: string, value: string) {
    let loanApplication = { ...this.state.loanApplication };
    let otherExpenseItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseItems ?? []];

    let otherExpenseItem = otherExpenseItems[index];
    otherExpenseItem.description = value;

    this.setValidFormClass(validationId, value.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowOtherExpenseItems(); });
  }

  setCashFlowOtherExpenseAmount(index: number, validationId: string, amount?: number,) {
    let loanApplication = { ...this.state.loanApplication };
    let otherExpenseItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseItems ?? []];

    let otherExpenseItem = otherExpenseItems[index];
    otherExpenseItem.totalAmount = amount;

    this.setValidFormClass(validationId, (amount ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalOtherExpenseAmount(this.validateCashFlowOtherExpenseItems) });
  }

  setCashFlowTotalOtherExpenseAmount(validationCallback: () => void) {
    let loanApplication = { ...this.state.loanApplication };
    let otherExpenses = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseItems ?? []];

    let totalOtherExpenses = otherExpenses?.reduce((subTotal, e) => {
      return subTotal + (e.totalAmount ?? 0)
    }, 0);

    if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.otherExpenseSection.totalOtherExpenseAmount = totalOtherExpenses;
    this.setState({ loanApplication: loanApplication }, validationCallback);
  }

  addCashFlowLoanPaymentItem() {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    (cashFlow.loanPaymentsSection.loanPaymentItems ?? []).push({
      // types may be added in here eventually
    } as CashFlowLoanPayment);

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLoanPaymentItems(); });
  }

  removeCashFlowLoanPaymentItem(index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow ?? {} as CashFlow };

    cashFlow.loanPaymentsSection.loanPaymentItems?.splice(index, 1);

    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLoanPaymentItems(); });
  }

  setCashFlowLoanPaymentCreditor(index: number, validationId: string, value: string) {
    let loanApplication = { ...this.state.loanApplication };
    let loanPaymentItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection?.loanPaymentItems ?? []];

    let loanPaymentItem = loanPaymentItems[index];
    loanPaymentItem.creditor = value;

    this.setValidFormClass(validationId, value.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLoanPaymentItems(); });
  }

  setCashFlowLoanPaymentPurpose(index: number, validationId: string, value: string) {
    let loanApplication = { ...this.state.loanApplication };
    let loanPaymentItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection?.loanPaymentItems ?? []];

    let loanPaymentItem = loanPaymentItems[index];
    loanPaymentItem.purpose = value;

    this.setValidFormClass(validationId, value.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLoanPaymentItems(); });
  }

  setCashFlowLoanPaymentAmount(index: number, validationId: string, value?: number) {
    let loanApplication = { ...this.state.loanApplication };
    let loanPaymentItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection?.loanPaymentItems ?? []];

    let loanPaymentItem = loanPaymentItems[index];
    loanPaymentItem.paymentAmount = value;

    this.setValidFormClass(validationId, (value ?? 0) > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.setCashFlowTotalLoanPaymentsAmount(this.validateCashFlowLoanPaymentItems) });
  }

  setCashFlowTotalLoanPaymentsAmount(validationCallback: () => void) {
    let loanApplication = { ...this.state.loanApplication };
    let loanPayments = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection?.loanPaymentItems ?? []];

    let totalLoanPaymentsAmount = loanPayments?.reduce((subTotal, lp) => {
      return subTotal + (lp.paymentAmount ?? 0)
    }, 0);

    if (loanApplication.loanProductionLineOfCredit != undefined && loanApplication.loanProductionLineOfCredit.cashFlow != undefined) loanApplication.loanProductionLineOfCredit.cashFlow.loanPaymentsSection.totalLoanPaymentsAmount = totalLoanPaymentsAmount;
    this.setState({ loanApplication: loanApplication }, validationCallback);
  }

  setCashFlowLoanPaymentFrequency(index: number, validationId: string, value: string) {
    let loanApplication = { ...this.state.loanApplication };
    let loanPaymentItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection?.loanPaymentItems ?? []];

    let loanPaymentItem = loanPaymentItems[index];
    loanPaymentItem.frequency = value;

    this.setValidFormClass(validationId, value.length > 0);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLoanPaymentItems(); });
  }

  setCashFlowLoanPaymentDate(index: number, validationId: string, value?: Date) {
    let loanApplication = { ...this.state.loanApplication };
    let loanPaymentItems = [...loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection?.loanPaymentItems ?? []];

    let loanPaymentItem = loanPaymentItems[index];
    loanPaymentItem.nextPaymentDate = value;

    this.setValidFormClass(validationId, value != undefined);
    this.setState({ loanApplication: loanApplication }, () => { this.validateCashFlowLoanPaymentItems(); });
  }

  setLendingReferenceBankState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let lendingReference = { ...loanApplication.loanLendingReference };

    lendingReference.bankName = value;
    loanApplication.loanLendingReference = { ...lendingReference };

    this.setValidFormClass('lending-bank-name', value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateLendingReference);
  }

  setLendingReferenceNameState(value: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let lendingReference = { ...loanApplication.loanLendingReference };

    lendingReference.contactName = value;
    loanApplication.loanLendingReference = { ...lendingReference };

    this.setValidFormClass('lending-contact-name', value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateLendingReference);
  }

  setLendingReferencePhoneNumberState(value: string, data: any, event: any, formattedValue: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let lendingReference = { ...loanApplication.loanLendingReference };
    let validNumber = false;

    validNumber = isValidPhoneNumber(formattedValue);
    lendingReference.displayPhoneNumber = formattedValue;
    lendingReference.phoneNumber = value.substring(1, 11);
    loanApplication.loanLendingReference = { ...lendingReference };

    this.setValidFormClass('lending-phone-number', validNumber);

    this.setState({ loanApplication: loanApplication, validLendingReferencePhoneNumber: validNumber }, this.validateLendingReference);
  }

  setProjectedFarmRevenuesAmountState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.projectedGrossRevenues == undefined) {
      loanApplication.projectedGrossRevenues = {};
    }

    loanApplication.projectedGrossRevenues.farmRevenues = amount;

    this.setValidFormClass('projected-gross-revenues', amount > 0);

    this.setState({ loanApplication: loanApplication }, this.validateRevenueData);
  }

  setProjectedOffFarmRevenuesAmountState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.projectedGrossRevenues == undefined) {
      loanApplication.projectedGrossRevenues = {};
    }

    loanApplication.projectedGrossRevenues.offFarmRevenues = amount;

    this.setState({ loanApplication: loanApplication }, this.validateRevenueData);
  }

  setPriorFarmRevenuesAmountState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.priorGrossRevenues == undefined) {
      loanApplication.priorGrossRevenues = {};
    }

    loanApplication.priorGrossRevenues.farmRevenues = amount;

    this.setState({ loanApplication: loanApplication }, this.validateRevenueData);
  }

  setPriorOffFarmRevenuesAmountState(amount: number): void {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.priorGrossRevenues == undefined) {
      loanApplication.priorGrossRevenues = {};
    }

    loanApplication.priorGrossRevenues.offFarmRevenues = amount;

    this.setState({ loanApplication: loanApplication }, this.validateRevenueData);
  }

  setApplicantEmailState(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.emailAddress = value;
    applicant.validEmail = globalUtility.ValidateEmailAddress(value);
    applicant.validationAccountExists = false;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-email`, applicant.validEmail);
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-email-joint`, applicant.validEmail);
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantPhoneNumberState(value: string, data: any, event: any, formattedValue: string, applicantType: ApplicantType): void {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;
    let validNumber = false;

    validNumber = isValidPhoneNumber(formattedValue);
    applicant.displayPhoneNumber = formattedValue;
    applicant.phoneNumber = value.substring(1, 11);
    applicant.validPhoneNumber = validNumber;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-phone-number`, validNumber);
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-phone-number-joint`, validNumber);
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantFirstNameState(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.firstName = value;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-first-name`, value?.length > 0);
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-first-name-joint`, value?.length > 0);
    }

    this.setState({ loanApplication: loanApplication }, () => { if (applicantType === ApplicantType.Primary) this.setApplicantDisplayName(); this.validateApplicantInfoData(); });
  }

  setApplicantLastNameState(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.lastName = value;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-last-name`, value?.length > 0);
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-last-name-joint`, value?.length > 0);
    }

    this.setState({ loanApplication: loanApplication }, () => { if (applicantType === ApplicantType.Primary) this.setApplicantDisplayName(); this.validateApplicantInfoData(); });
  }

  setApplicantSuffixState(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.suffix = value;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
    }

    this.setState({ loanApplication: loanApplication }, () => { if (applicantType === ApplicantType.Primary) this.setApplicantDisplayName(); this.validateApplicantInfoData(); });
  }

  setApplicantDisplayName() {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = loanApplication.applicant;
    applicant.displayName = `${applicant.firstName?.trim()} ${applicant.lastName?.trim()}${applicant.suffix != undefined && applicant.suffix.length > 0 ? ` ${applicant.suffix.trim()}` : ''}`;
    loanApplication.applicant = { ...loanApplication.applicant }
    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantAddressLine1State(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.address = value;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-address`, value?.length > 0);
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-address-joint`, value?.length > 0);
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantAddressLine2State(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.addressLine2 = value;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantCityState(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.city = value;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-city`, value?.length > 0);
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-city-joint`, value?.length > 0);
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantStateValueState(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.state = value;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-state`, value?.length > 0 && value !== "-1");
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-state-joint`, value?.length > 0 && value !== "-1");
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantZipCodeState(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.zipCode = value.substring(0, 5); // max 5 digit code

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-zip`, value?.length > 0);
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-zip-joint`, value?.length > 0);
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantDOBState(value: Date, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.dateOfBirth = value;

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-dob`, isDate(value));
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-dob-joint`, isDate(value));
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setApplicantSSNState(value: string, applicantType: ApplicantType) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = applicantType === ApplicantType.Primary ? loanApplication.applicant : loanApplication.jointApplicant ?? {} as JointApplicant;

    applicant.ssn = value;
    applicant.validSSN = globalUtility.ValidateSSN(value);

    if (applicantType === ApplicantType.Primary) {
      loanApplication.applicant = { ...loanApplication.applicant };
      this.setValidFormClass(`customer-ssn`, applicant.validSSN);
    } else {
      loanApplication.jointApplicant = { ...loanApplication.jointApplicant ?? {} as JointApplicant };
      this.setValidFormClass(`customer-ssn-joint`, applicant.validSSN);
    }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setBusinessNameState(value: string) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = loanApplication.applicant;

    applicant.businessName = value;
    loanApplication.applicant = { ...loanApplication.applicant };

    this.setValidFormClass(`business-name`, value?.length > 0);

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setYearsManagingFarmState(value: string) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = loanApplication.applicant;
    let validEntry = !isNaN(+value);

    applicant.farmingStartYear = validEntry ? +value : undefined;
    loanApplication.applicant = { ...loanApplication.applicant };

    this.setValidFormClass(`managing-farm`, validEntry);

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setAccountPassword(password: string) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant: Applicant = loanApplication.applicant;

    applicant.password = password;
    applicant.validPassword = inputValidators.IsValidPassword(password);
    applicant.validConfirmPassword = applicant.password === applicant.confirmPassword;
    this.setValidFormClass(`password`, applicant.validPassword);
    this.setValidFormClass(`confirm-password`, applicant.validConfirmPassword);

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setAccountConfirmPassword(password: string) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant: Applicant = loanApplication.applicant;

    applicant.confirmPassword = password;
    applicant.validConfirmPassword = password?.length > 0 && password === applicant.password;
    this.setValidFormClass(`confirm-password`, applicant.validConfirmPassword);

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setCreateAccountAgreedState(agreed: boolean) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = loanApplication.applicant;

    applicant.createAccountAgreed = agreed;
    loanApplication.applicant = { ...loanApplication.applicant }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setExperianAgreedState(agreed: boolean) {
    let loanApplication = { ...this.state.loanApplication };
    let applicant = loanApplication.applicant;

    applicant.experianAgreed = agreed;
    loanApplication.applicant = { ...loanApplication.applicant }

    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  addJointApplicantButtonClicked() {
    let loanApplication = { ...this.state.loanApplication };
    loanApplication.jointApplicant = {} as JointApplicant;
    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  removeJointApplicantClicked() {
    let loanApplication = { ...this.state.loanApplication };
    loanApplication.jointApplicant = undefined;

    let accountSelectOptions = [...this.state.accountSelectOptions];
    let accountOptions = [...this.state.accountOptions];

    // accountSelectOptions[index] = [];
    // accountOptions[index] = [];

    this.setState({ loanApplication: loanApplication, accountSelectOptions: accountSelectOptions, accountOptions: accountOptions }, this.validateApplicantInfoData);
  }

  addEntityButtonClicked() {
    let loanApplication = { ...this.state.loanApplication };
    loanApplication.entityApplicant = {
      extraDataObject: {
        isBusinessFormedInUsa: false,
        isBusinessInvolvedWithCannabis: false,
        isBusinessExchangeDigitalCurrency: false,
        isBusinessCasino: false,
        isBusinessInInternetGambling: false,
        isBusinessPubliclyTraded: false,
        principalOwnershipInformation: [
          {} as PrincipalOwnerInformation
        ]
      } as EntityApplicantExtraData
    } as EntityApplicant;
    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  removeEntityClicked() {
    let loanApplication = { ...this.state.loanApplication };
    loanApplication.entityApplicant = undefined;
    this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
  }

  setEntityNameState(value: string) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.entityApplicant != undefined) {
      loanApplication.entityApplicant.organizationName = value;

      this.setValidFormClass('entity-name', value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setEntityDateOrganizedState(value: Date) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.entityApplicant != undefined) {
      loanApplication.entityApplicant.dateOrganized = value;

      this.setValidFormClass('entity-date', isDate(value));
      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setEntityEINState(value: string) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.entityApplicant != undefined) {
      loanApplication.entityApplicant.ein = value;

      let validEIN = globalUtility.ValidateEIN(value);
      loanApplication.entityApplicant.validEIN = validEIN;
      this.setValidFormClass('entity-ein', validEIN);
      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setEntityAddressState(value: string) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.entityApplicant != undefined) {
      loanApplication.entityApplicant.address = value;
      this.setValidFormClass('entity-address', value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setEntityCityState(value: string) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.entityApplicant != undefined) {
      loanApplication.entityApplicant.city = value;
      this.setValidFormClass('entity-city', value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setEntityStateValueState(value: string) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.entityApplicant != undefined) {
      loanApplication.entityApplicant.state = value;
      this.setValidFormClass('entity-state', value?.length > 0 && value !== "-1");

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setEntityZipCodeState(value: string) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.entityApplicant != undefined) {
      loanApplication.entityApplicant.zipCode = value.substring(0, 5);
      this.setValidFormClass('entity-zip', value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setEntityExtraQuestion(checked: boolean, property: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection: EntityApplicant = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject != undefined) {
      const propertyName: keyof EntityApplicantExtraData = property as keyof EntityApplicantExtraData;

      if (propertyName != undefined) {
        entityApplicantSection.extraDataObject = this.setEntityApplicantKeyValue(entityApplicantSection.extraDataObject, propertyName, checked);
        loanApplication.entityApplicant = { ...entityApplicantSection };
        this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
      }
    }
  }

  setEntityApplicantKeyValue<ObjType extends EntityApplicantExtraData, KeyType extends keyof ObjType>(
    object: ObjType,
    key: KeyType,
    value: ObjType[KeyType]
  ): ObjType {
    object[key] = value;
    return object;
  }

  addPrincipalOwnerButtonClicked() {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation.push({} as PrincipalOwnerInformation);
      loanApplication.entityApplicant = { ...entityApplicantSection };
      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  removePrincipalOwnerButtonClicked(index: number) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation.splice(index, 1);
      loanApplication.entityApplicant = { ...entityApplicantSection };
      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setPrincipalOwnerFirstNameState(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].principalOwnerFirstName = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setPrincipalOwnerLastNameState(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].principalOwnerLastName = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setPrincipalSSNTaxIdState(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].ssnTaxId = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setPrincipalAddressState(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].physicalAddress = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setPrincipalCityState(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].city = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, value?.length > 0);

      this.setState({ loanApplication: loanApplication });
    }
  }

  setPrincipalStateState(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].state = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, value?.length > 0);

      this.setState({ loanApplication: loanApplication });
    }
  }

  setPrincipalZipCodeState(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].zipCode = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, value?.length > 0);

      this.setState({ loanApplication: loanApplication });
    }
  }

  setPrincipalDOBState(value: Date, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].dateOfBirth = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, isDate(value));

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setPrincipalPhoneNumberState(value: string, formattedValue: string, index: number, validationId: string): void {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };
    let validNumber = false;

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      validNumber = isValidPhoneNumber(formattedValue);
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].displayPhoneNumber = formattedValue;
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].phoneNumber = value.substring(1, 11);
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].validPhoneNumber = validNumber;

      this.setValidFormClass(validationId, validNumber);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setPrincipalPercentage(value: number, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].percentageOwned = value;

      this.setValidFormClass(validationId, value > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setPrincipalTitleState(value: string, index: number, validationId: string) {
    let loanApplication = { ...this.state.loanApplication };
    let entityApplicantSection = { ...loanApplication.entityApplicant };

    if (entityApplicantSection != undefined && entityApplicantSection.extraDataObject?.principalOwnershipInformation != undefined) {
      entityApplicantSection.extraDataObject.principalOwnershipInformation[index].title = value;
      loanApplication.entityApplicant = { ...entityApplicantSection };

      this.setValidFormClass(validationId, value?.length > 0);

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  setEntityExperianAgreedState(agreed: boolean) {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.entityApplicant != undefined) {
      loanApplication.entityApplicant.experianAgreed = agreed;

      this.setState({ loanApplication: loanApplication }, this.validateApplicantInfoData);
    }
  }

  getCashCollateralText(): string {
    switch (this.state.loanApplication.loanType) {
      case LoanType.DealerPurchase:
      case LoanType.EquipmentRefinance:
      case LoanType.EquipmentAuctionPurchase:
        return 'How much cash down is being provided?';

      case LoanType.GapFinancing:
        return 'How much cash do you have on hand? (Checking Accounts, Savings Accounts, etc)';
      default:
        return '';
    }
  }

  getOtherCollateralText(): string {
    switch (this.state.loanApplication.loanType) {
      case LoanType.DealerPurchase:
      case LoanType.EquipmentRefinance:
        return 'This can include things such as assets owned, equipment owned, etc';

      case LoanType.GapFinancing:
        return 'This can include things such as accounts receivable, equipment, etc';

      default:
        return '';
    }
  }

  validateCollateral(loanApplication: LoanApplication): boolean {
    let validCollateral: boolean = true;

    if (this.state.loanApplication != undefined) {
      let atLeastOne: boolean = true, validCashDown: boolean = true, validTrade: boolean = true, validOther: boolean = true;

      atLeastOne = !(loanApplication.collateralEquityCashDown == undefined && loanApplication.collateralEquityTrade == undefined && loanApplication.collateralEquityOtherCollateral == undefined);

      validCashDown = (loanApplication.collateralEquityCashDown == undefined || (loanApplication.collateralEquityCashDown.amount != undefined && loanApplication.collateralEquityCashDown.amount > 0));

      if (loanApplication.collateralEquityOtherCollateral != undefined) {
        if (loanApplication.collateralEquityOtherCollateral.length > 0) {
          loanApplication.collateralEquityOtherCollateral?.some(o => {
            validOther = o.description != undefined && o.description.length > 0
              && o.value != undefined && o.value > 0;

            validCollateral = !validOther;
          })
        } else {
          validCollateral = false;
        }
      }

      if (EquipmentOnlyLoans.includes(loanApplication.loanType)) {
        validTrade = (loanApplication.collateralEquityTrade == undefined || (loanApplication.collateralEquityTrade.description != undefined && loanApplication.collateralEquityTrade.description.length > 0 && loanApplication.collateralEquityTrade.value != undefined && loanApplication.collateralEquityTrade.value > 0));
      }

      validCollateral = atLeastOne && validCashDown && validTrade && validOther
    } else {
      validCollateral = false;
    }

    return validCollateral;
  }

  validateStartData() {
    let validStartData: boolean = true;
    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };

      // Ensuring a loan type is set
      if (loanApplication.loanType != undefined && loanApplication.loanType > 0) {
        // Loan type is selected
        validStartData = true;
      } else {
        validStartData = false;
      }
    } else {
      validStartData = false;
    }

    this.setValidFormClass('start-loan-tab', validStartData);
    this.setState({ validStartData: validStartData });
  }

  validateCashFlowIntroduction() {
    let validIntroData: boolean = true;
    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      // Ensuring a loan type is set
      if (cashFlow != undefined && cashFlow.introductionSection != undefined) {
        let validCycleStart: boolean, validCycleEnd: boolean, validAsOfDate: boolean, validPlanType: boolean;

        validCycleStart = cashFlow.introductionSection.cycleStart != undefined;
        validCycleEnd = cashFlow.introductionSection.cycleEnd != undefined;
        validAsOfDate = cashFlow.introductionSection.asOfDate != undefined;
        validPlanType = cashFlow.introductionSection.projected != undefined;

        validIntroData = validCycleStart && validCycleEnd && validAsOfDate && validPlanType;
      } else {
        validIntroData = false;
      }
    } else {
      validIntroData = false;
    }

    this.setValidFormClass('cash-flow-intro-tab', validIntroData);
    this.setState({ validCashFlowIntroData: validIntroData });
  }

  validateCashFlowLineItem() {
    let validTopLevelLineItemData: boolean = true;
    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      // Ensuring a loan type is set
      if (cashFlow != undefined && cashFlow.incomeSection != undefined) {
        if (cashFlow.incomeSection.incomeLineItems != undefined && cashFlow.incomeSection.incomeLineItems.length > 0) {
          cashFlow.incomeSection.incomeLineItems?.some(li => {
            validTopLevelLineItemData = li.description != undefined && li.description.length > 0;

            return !validTopLevelLineItemData;
          })
        } else {
          validTopLevelLineItemData = false;
        }
      } else {
        validTopLevelLineItemData = false;
      }
    } else {
      validTopLevelLineItemData = false;
    }

    //if (!validTopLevelLineItemData) this.setValidFormClass('cash-flow-production-income-tab', validTopLevelLineItemData);
    this.setState({ validTopLevelLineItemData: validTopLevelLineItemData }, this.setValidIncomeTab);
  }

  validateCashFlowProductionIncome() {
    let validProductionIncomeData: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      // Ensuring a loan type is set
      if (cashFlow != undefined && cashFlow.incomeSection != undefined) {
        validProductionIncomeData = cashFlow.incomeSection.incomeLineItems != undefined && cashFlow.incomeSection.incomeLineItems.length > 0;

        if (validProductionIncomeData) {
          cashFlow.incomeSection.incomeLineItems?.some(li => {
            switch (li.incomeType) {
              case CashFlowIncomeType.CropProduction:
                validProductionIncomeData = li.productionIncome?.unitOfMeasure != undefined && li.productionIncome.unitOfMeasure.length > 0
                  && li.productionIncome?.acres != undefined && li.productionIncome.acres > 0
                  && li.productionIncome.yield != undefined && li.productionIncome.yield > 0
                  && li.productionIncome.numberOfUnits != undefined && li.productionIncome.numberOfUnits > 0
                  && li.productionIncome.percentageOwned != undefined && li.productionIncome.percentageOwned >= 0
                  && li.productionIncome.shareOfUnits != undefined && li.productionIncome.shareOfUnits >= 0
                  && li.productionIncome.amountFarmUse != undefined && li.productionIncome.amountFarmUse >= 0 && li.productionIncome.amountFarmUse <= li.productionIncome.shareOfUnits;
                break;

              default:
                break;
            }

            return !validProductionIncomeData;
          })
        }
      } else {
        validProductionIncomeData = false;
      }
    } else {
      validProductionIncomeData = false;
    }

    //this.setValidFormClass('cash-flow-production-income-tab', validIncomeData);
    this.setState({ validCashFlowProductionIncomeData: validProductionIncomeData }, this.setValidIncomeTab);
  }

  validateCashFlowProductionPurchases() {
    let validPurchaseData: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      // Ensuring a loan type is set
      if (cashFlow != undefined && cashFlow.incomeSection != undefined) {
        validPurchaseData = cashFlow.incomeSection.incomeLineItems != undefined && cashFlow.incomeSection.incomeLineItems.length > 0;

        if (validPurchaseData) {
          cashFlow.incomeSection.incomeLineItems?.some(li => {
            switch (li.incomeType) {
              case CashFlowIncomeType.LivestockAndPoultryPurchaseSale:
              case CashFlowIncomeType.DairyLivestock:
                if (li.purchaseSaleType != undefined) {
                  let validPurchaseInfo: boolean = true, validSaleInfo: boolean = true;

                  if (li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseAndSale || li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseOnly) {
                    validPurchaseInfo = li.productionPurchase?.numberOfUnits != undefined && li.productionPurchase.numberOfUnits > 0
                      && li.productionPurchase.purchaseWeightPerUnit != undefined && li.productionPurchase.purchaseWeightPerUnit > 0
                      && li.productionPurchase.purchaseDollarPerUnit != undefined && li.productionPurchase.purchaseDollarPerUnit > 0
                      && li.productionPurchase.purchaseTotalAmount != undefined;
                  }

                  if (li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseAndSale || li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.SaleOnly) {
                    validSaleInfo = li.productionPurchase?.numberOfUnits != undefined && li.productionPurchase.numberOfUnits > 0
                      && li.productionPurchase.saleWeightPerUnit != undefined && li.productionPurchase.saleWeightPerUnit > 0
                      && li.productionPurchase.saleDollarPerUnit != undefined && li.productionPurchase.saleDollarPerUnit > 0
                      && li.productionPurchase.saleTotalAmount != undefined
                      && li.productionPurchase.netTotalAmount != undefined
                  }

                  validPurchaseData = validPurchaseInfo && validSaleInfo;
                } else {
                  validPurchaseData = false;
                }
                break;

              default:
                break;
            }

            return !validPurchaseData;
          })
        }
      } else {
        validPurchaseData = false;
      }
    } else {
      validPurchaseData = false;
    }

    //this.setValidFormClass('cash-flow-production-purchases-tab', validPurchaseData);
    this.setState({ validCashFlowProductionPurchaseData: validPurchaseData }, this.setValidIncomeTab);
  }

  validateCashFlowProductionSales() {
    let validSaleData: boolean = true;
    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      // Ensuring a loan type is set
      if (cashFlow != undefined && cashFlow.incomeSection != undefined) {
        validSaleData = cashFlow.incomeSection.incomeLineItems != undefined && cashFlow.incomeSection.incomeLineItems.length > 0;

        if (validSaleData) {
          cashFlow.incomeSection.incomeLineItems?.some(li => {
            switch (li.incomeType) {
              case CashFlowIncomeType.CropProduction:
                validSaleData = li.productionIncome != undefined && (li.productionIncome.shareOfUnits === li.productionIncome.amountFarmUse
                  || (li.productionSale != undefined &&
                    li.productionSale.numberOfUnits != undefined && li.productionSale.numberOfUnits > 0
                    && li.productionSale.pricePerUnit != undefined && li.productionSale.pricePerUnit > 0
                    && li.productionSale.totalAmount != undefined && li.productionSale.totalAmount > 0));
                break;

              case CashFlowIncomeType.LivestockAndPoultryPurchaseSale:
              case CashFlowIncomeType.DairyLivestock:
                validSaleData = true; // Sale data is optional or not used for these
                break;

              case CashFlowIncomeType.LivestockAndPoultryRaised:
                validSaleData =
                  li.productionSale?.weightPerUnit != undefined && li.productionSale.weightPerUnit > 0
                  && li.productionSale?.numberOfUnits != undefined && li.productionSale.numberOfUnits > 0
                  && li.productionSale?.pricePerUnit != undefined && li.productionSale.pricePerUnit > 0
                  && li.productionSale?.totalAmount != undefined && li.productionSale.totalAmount > 0;
                break;

              case CashFlowIncomeType.MilkProduction:
                validSaleData = li.productionSale?.numberOfHead != undefined && li.productionSale.numberOfHead > 0
                  && li.productionSale.productionPerHead != undefined && li.productionSale.productionPerHead > 0
                  && li.productionSale.totalProduction != undefined && li.productionSale.totalProduction > 0
                  && li.productionSale.marketPrice != undefined && li.productionSale.marketPrice > 0
                  && li.productionSale.totalAmount != undefined && li.productionSale.totalAmount > 0;
                break;

              case CashFlowIncomeType.LivestockProduct:
                validSaleData = li.productionSale?.commodityProduced != undefined && li.productionSale.commodityProduced.length > 0
                  && li.productionSale.commodityMeasure != undefined && li.productionSale.commodityMeasure.length > 0
                  && li.productionSale.numberOfUnits != undefined && li.productionSale.numberOfUnits > 0
                  && li.productionSale.pricePerUnit != undefined && li.productionSale.pricePerUnit > 0
                  && li.productionSale.totalAmount != undefined && li.productionSale.totalAmount > 0;
                break;

              default:
                break;
            }

            return !validSaleData;
          })
        }
      } else {
        validSaleData = false;
      }
    } else {
      validSaleData = false;
    }

    //this.setValidFormClass('cash-flow-production-sales-tab', validSaleData);
    this.setState({ validCashFlowProductionSaleData: validSaleData }, this.setValidIncomeTab);
  }

  setValidIncomeTab() {
    let validIncomeData: boolean = this.state.validTopLevelLineItemData && this.state.validCashFlowProductionIncomeData && this.state.validCashFlowProductionPurchaseData && this.state.validCashFlowProductionSaleData;
    this.setValidFormClass('cash-flow-income-tab', validIncomeData);
    this.setState({ validAllCashFlowIncomeData: validIncomeData });
  }

  validateCashFlowOtherIncome() {
    let validOtherIncome: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      // Ensuring a loan type is set
      if (cashFlow != undefined && cashFlow.incomeSection != undefined) {
        let validOtherFarmIncome: boolean = true;
        let validNonFarmIncome: boolean = true;
        let validCapitalSaleIncome: boolean = true;

        if (cashFlow.incomeSection.otherFarmIncome != undefined && cashFlow.incomeSection.otherFarmIncome.length > 0) {
          cashFlow.incomeSection.otherFarmIncome?.some(oi => {
            validOtherFarmIncome = oi.description != undefined && oi.description.length > 0
              && oi.totalAmount != undefined && oi.totalAmount > 0;

            return !validOtherFarmIncome;
          })
        }

        if (cashFlow.incomeSection.nonFarmIncome != undefined && cashFlow.incomeSection.nonFarmIncome.length > 0) {
          cashFlow.incomeSection.nonFarmIncome?.some(oi => {
            validNonFarmIncome = oi.description != undefined && oi.description.length > 0
              && oi.totalAmount != undefined && oi.totalAmount > 0;

            return !validNonFarmIncome;
          })
        }

        if (cashFlow.incomeSection.capitalSalesIncome != undefined && cashFlow.incomeSection.capitalSalesIncome.length > 0) {
          cashFlow.incomeSection.capitalSalesIncome?.some(oi => {
            validCapitalSaleIncome = oi.description != undefined && oi.description.length > 0
              && oi.totalAmount != undefined && oi.totalAmount > 0;

            return !validCapitalSaleIncome;
          })
        }

        validOtherIncome = validOtherFarmIncome && validNonFarmIncome && validCapitalSaleIncome;
      } else {
        validOtherIncome = false;
      }
    } else {
      validOtherIncome = false;
    }

    this.setValidFormClass('cash-flow-other-income-tab', validOtherIncome);
    this.setState({ validCashFlowOtherIncomeData: validOtherIncome });
  }

  validateCashFlowExpenses() {
    let validExpenses: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      if (cashFlow != undefined && cashFlow.expensesSection != undefined) {
        validExpenses = cashFlow.expensesSection.expenses != undefined && cashFlow.expensesSection.expenses.length >= 0;

        if (validExpenses) {
          cashFlow.expensesSection.expenses?.some(oi => {
            validExpenses = oi.totalAmount != undefined && oi.totalAmount > 0;

            return !validExpenses;
          })
        }
      } else {
        validExpenses = false;
      }
    } else {
      validExpenses = false;
    }

    this.setValidFormClass('cash-flow-expenses-tab', validExpenses);
    this.setState({ validCashFlowExpensesData: validExpenses });
  }

  validateCashFlowOtherExpenseItems() {
    let validOtherExpenseItems: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      if (cashFlow != undefined && cashFlow.otherExpenseSection != undefined) {
        if (cashFlow.otherExpenseSection.otherExpenseItems != undefined && cashFlow.otherExpenseSection.otherExpenseItems.length > 0) {
          // If they checked an item, we will ensure they have an amount set
          // Otherwise, they are good
          cashFlow.otherExpenseSection.otherExpenseItems?.some(oi => {
            validOtherExpenseItems = oi.totalAmount != undefined && oi.totalAmount > 0
              && oi.description != undefined && oi.description.length > 0;

            return !validOtherExpenseItems;
          })
        }
      } else {
        validOtherExpenseItems = false;
      }
    } else {
      validOtherExpenseItems = false;
    }

    this.setValidFormClass('cash-flow-other-expenses-tab', validOtherExpenseItems);
    this.setState({ validCashFlowOtherExpensesData: validOtherExpenseItems });
  }

  validateCashFlowLoanPaymentItems() {
    let validLoanPaymentItems: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let cashFlow = { ...loanApplication.loanProductionLineOfCredit?.cashFlow };

      if (cashFlow != undefined && cashFlow.loanPaymentsSection != undefined) {
        if (cashFlow.loanPaymentsSection.loanPaymentItems != undefined && cashFlow.loanPaymentsSection.loanPaymentItems.length > 0) {
          // If they added an item, we will ensure they have the correct data added
          // Otherwise, they are good
          cashFlow.loanPaymentsSection.loanPaymentItems?.some(lpi => {
            validLoanPaymentItems = lpi.creditor != undefined && lpi.creditor.length > 0
              && lpi.purpose != undefined && lpi.purpose.length > 0
              && lpi.paymentAmount != undefined && lpi.paymentAmount > 0
              && lpi.frequency != undefined && lpi.frequency.length > 0
              && lpi.nextPaymentDate != undefined;

            return !validLoanPaymentItems;
          })
        }
      } else {
        validLoanPaymentItems = false;
      }
    } else {
      validLoanPaymentItems = false;
    }

    this.setValidFormClass('cash-flow-loan-payments-tab', validLoanPaymentItems);
    this.setState({ validCashFlowLoanPaymentData: validLoanPaymentItems });
  }

  validatePurchaseInformation() {
    let validPurchaseInformation: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };

      if (loanApplication.loanDealerPurchase != undefined) {
        let validDealer: boolean, validOtherSalesman: boolean, validPurchaseAmount: boolean;

        if (this.state.otherSalesmanSelected) {
          validDealer = true;

          validOtherSalesman = loanApplication.loanDealerPurchase.dealerOther != undefined &&
            (loanApplication.loanDealerPurchase.dealerOther.location != undefined && loanApplication.loanDealerPurchase.dealerOther.location.length > 0) &&
            (loanApplication.loanDealerPurchase.dealerOther.name != undefined && loanApplication.loanDealerPurchase.dealerOther.name.length > 0) &&
            (this.state.validOtherPhoneNumber && loanApplication.loanDealerPurchase.dealerOther.phoneNumber != undefined && loanApplication.loanDealerPurchase.dealerOther.phoneNumber.length > 0)
        } else {
          validOtherSalesman = true;

          validDealer = loanApplication.loanDealerPurchase.dealerSalesmanId != undefined && loanApplication.loanDealerPurchase.dealerSalesmanId > 0
            && loanApplication.loanDealerPurchase.dealerLocationId != undefined && loanApplication.loanDealerPurchase.dealerLocationId > 0
            && loanApplication.loanDealerPurchase.dealerId != undefined && loanApplication.loanDealerPurchase.dealerId > 0;
        }

        validPurchaseAmount = loanApplication.loanDealerPurchase.purchaseAmount != undefined && loanApplication.loanDealerPurchase.purchaseAmount > 0;

        validPurchaseInformation = validDealer && validOtherSalesman && validPurchaseAmount;
      } else {
        validPurchaseInformation = false;
      }
    } else {
      validPurchaseInformation = false;
    }

    this.setValidFormClass('purchase-info-tab', validPurchaseInformation);
    this.setState({ validPurchaseInformation: validPurchaseInformation });
  }

  validateEquipmentInformation() {
    let validEquipmentInformation: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let validEquipmentData: boolean, validInsuranceInformation: boolean

      validEquipmentData = loanApplication.loanEquipmentInformation != undefined && loanApplication.loanEquipmentInformation.length > 0;

      if (validEquipmentData) {
        loanApplication.loanEquipmentInformation?.some(e => {
          validEquipmentData = e.make != undefined && e.make.length > 0
            && e.model != undefined && e.model.length > 0
            && e.year != undefined && e.year.length > 0
            && e.new != undefined
            && (loanApplication.loanType === LoanType.EquipmentAuctionPurchase || (e.totalPrice != undefined && e.totalPrice > 0));

          return !validEquipmentData;
        })
      }

      validInsuranceInformation = (loanApplication.loanEquipmentInsuranceInformation != undefined && this.state.validInsurancePhoneNumber
        && loanApplication.loanEquipmentInsuranceInformation.agentName != undefined && loanApplication.loanEquipmentInsuranceInformation.agentName.length > 0
        && loanApplication.loanEquipmentInsuranceInformation.companyName != undefined && loanApplication.loanEquipmentInsuranceInformation.companyName.length > 0);

      validEquipmentInformation = validEquipmentData && validInsuranceInformation
    } else {
      validEquipmentInformation = false;
    }

    this.setValidFormClass('equipment-info-tab', validEquipmentInformation);
    this.setState({ validEquipmentInformation: validEquipmentInformation });
  }

  validateGeneralQuestions() {
    let validGeneralData: boolean = true;
    let validCustomHire: boolean = true;

    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };

      if (loanApplication.loanType === LoanType.GapFinancing) {
        if (loanApplication.loanGapFinancing != undefined) {
          let validAmountRequested: boolean, validGovernmentAgency: boolean, validAverageRequest: boolean, validAverageReimbursement: boolean,
            validAssets: boolean, validLiabilities: boolean;

          validAmountRequested = loanApplication.loanAmount != undefined && loanApplication.loanAmount > 0;

          validGovernmentAgency = (loanApplication.loanGapFinancing.governmentAgency ?? '').length > 0;
          validAverageRequest = (loanApplication.loanGapFinancing.averageReimbursementAmount ?? 0) > 0;
          validAverageReimbursement = (loanApplication.loanGapFinancing.averageReimbursementLength ?? 0) > 0;

          validAssets = (loanApplication.loanGapFinancing?.totalAssets ?? 0) > 0;
          validLiabilities = (loanApplication.loanGapFinancing?.totalLiabilities ?? 0) > 0;

          validGeneralData = validAmountRequested && validGovernmentAgency && validAverageRequest
            && validAverageReimbursement && validAssets && validLiabilities;
        } else {
          validGeneralData = false;
        }
      } else if (loanApplication.loanType == LoanType.EquipmentAuctionPurchase || EquipmentOnlyLoans.includes(loanApplication.loanType)) {
        validCustomHire = loanApplication.loanDealerPurchase?.customHire != undefined;

        let validAssets: boolean = true, validLiabilities: boolean = true, validLotId: boolean = true, validEndDate: boolean = true, validURL: boolean = true;

        let validPrimaryAgProduct: boolean = !this.state.isFarmer || (loanApplication.primaryAgProduct != undefined && loanApplication.primaryAgProduct.length > 0);

        if (loanApplication.loanType === LoanType.EquipmentAuctionPurchase) {
          validLotId = (loanApplication.loanAuctionInformation?.lotId?.length ?? 0) > 0;
          validEndDate = loanApplication.loanAuctionInformation?.auctionEndDate != undefined && new Date(loanApplication.loanAuctionInformation?.auctionEndDate).toDateString().length > 0;
          validURL = (loanApplication.loanAuctionInformation?.listingUrl?.length ?? 0) > 0;
        }

        validAssets = (loanApplication.loanDealerPurchase?.totalAssets ?? 0) > 0;
        validLiabilities = (loanApplication.loanDealerPurchase?.totalLiabilities ?? 0) > 0;

        validGeneralData = validAssets && validLiabilities && validLotId && validEndDate && validURL && validPrimaryAgProduct;
      } else if (loanApplication.loanType === LoanType.ProductionLineOfCredit) {
        validGeneralData = loanApplication.loanAmount != undefined && loanApplication.loanAmount > 0
          && loanApplication.loanProductionLineOfCredit != undefined
          && loanApplication.loanProductionLineOfCredit.hasCurrentLoan != undefined
          && (loanApplication.loanProductionLineOfCredit.hasCurrentLoan === false
            || (loanApplication.loanProductionLineOfCredit.hasCurrentLoan
              && (loanApplication.loanProductionLineOfCredit.currentLoanBalance ?? 0) > 0));
      }
      validGeneralData = validGeneralData && validCustomHire;
    } else {
      validGeneralData = false;
    }

    this.setValidFormClass('general-questions-tab', validGeneralData);
    this.setState({ validGeneralData: validGeneralData });
  }

  validateLendingReference() {
    let validLendingReferenceData: boolean = true;
    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };

      validLendingReferenceData = loanApplication.loanLendingReference != undefined && this.state.validLendingReferencePhoneNumber
        && loanApplication.loanLendingReference.bankName != undefined && loanApplication.loanLendingReference.bankName.length > 0
        && loanApplication.loanLendingReference.contactName != undefined && loanApplication.loanLendingReference.contactName.length > 0;
    } else {
      validLendingReferenceData = false;
    }

    this.setValidFormClass('lending-reference-tab', validLendingReferenceData);
    this.setState({ validLendingReferenceData: validLendingReferenceData });
  }

  validateRevenueData() {
    let validRevenueData: boolean = true;
    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };

      validRevenueData = loanApplication.projectedGrossRevenues?.farmRevenues != undefined && loanApplication.projectedGrossRevenues.farmRevenues > 0;
    } else {
      validRevenueData = false;
    }

    this.setValidFormClass('revenue-tab', validRevenueData);
    this.setState({ validRevenueData: validRevenueData });
  }

  validateApplicantInfoData() {
    let validApplicantData: boolean = true;
    if (this.state.loanApplication != undefined) {
      let loanApplication = { ...this.state.loanApplication };
      let validApplicant: boolean, validJointApplicant: boolean, validEntity: boolean, validPrincipalOwnerInfo: boolean;

      validApplicant = loanApplication.applicant != undefined && Object.keys(loanApplication.applicant).length > 0;

      if (validApplicant) {
        let a = { ...loanApplication.applicant };

        validApplicant = a.emailAddress != undefined && a.emailAddress.length > 0
          && a.firstName != undefined && a.firstName.length > 0
          && a.lastName != undefined && a.lastName.length > 0
          && a.address != undefined && a.address.length > 0
          && a.city != undefined && a.city.length > 0
          && a.state != undefined && a.state.length > 0 && a.state !== '-1'
          && a.zipCode != undefined && a.zipCode.length > 0
          && a.dateOfBirth != undefined && a.dateOfBirth.toDateString().length > 0
          && a.validSSN && a.ssn != undefined && a.ssn.length > 0
          && a.validPhoneNumber && a.phoneNumber != undefined && a.phoneNumber.length > 0
          && a.experianAgreed
          && a.farmingStartYear != undefined && a.farmingStartYear > 0;
      }

      validJointApplicant = loanApplication.jointApplicant == undefined ||
        (loanApplication.jointApplicant.emailAddress != undefined && loanApplication.jointApplicant.emailAddress.length > 0
          && loanApplication.jointApplicant.firstName != undefined && loanApplication.jointApplicant.firstName.length > 0
          && loanApplication.jointApplicant.lastName != undefined && loanApplication.jointApplicant.lastName.length > 0
          && loanApplication.jointApplicant.address != undefined && loanApplication.jointApplicant.address.length > 0
          && loanApplication.jointApplicant.city != undefined && loanApplication.jointApplicant.city.length > 0
          && loanApplication.jointApplicant.state != undefined && loanApplication.jointApplicant.state.length > 0 && loanApplication.jointApplicant.state !== '-1'
          && loanApplication.jointApplicant.zipCode != undefined && loanApplication.jointApplicant.zipCode.length > 0
          && loanApplication.jointApplicant.dateOfBirth != undefined && loanApplication.jointApplicant.dateOfBirth.toDateString().length > 0
          && loanApplication.jointApplicant.validSSN && loanApplication.jointApplicant.ssn != undefined && loanApplication.jointApplicant.ssn.length > 0
          && loanApplication.jointApplicant.validPhoneNumber && loanApplication.jointApplicant.phoneNumber != undefined && loanApplication.jointApplicant.phoneNumber.toString().length > 0);

      validEntity = loanApplication.entityApplicant == undefined ||
        (loanApplication.entityApplicant.organizationName != undefined && loanApplication.entityApplicant.organizationName.length > 0
          && loanApplication.entityApplicant.dateOrganized != undefined && loanApplication.entityApplicant.dateOrganized.toDateString().length > 0
          && loanApplication.entityApplicant.ein != undefined && loanApplication.entityApplicant.ein.length > 0 && (loanApplication.entityApplicant.validEIN ?? false)
          && loanApplication.entityApplicant.address != undefined && loanApplication.entityApplicant.address.length > 0
          && loanApplication.entityApplicant.city != undefined && loanApplication.entityApplicant.city.length > 0
          && loanApplication.entityApplicant.state != undefined && loanApplication.entityApplicant.state.length > 0 && loanApplication.entityApplicant.state !== '-1'
          && loanApplication.entityApplicant.zipCode != undefined && loanApplication.entityApplicant.zipCode.length > 0
          && (loanApplication.entityApplicant.experianAgreed ?? false)
        );

      validPrincipalOwnerInfo = loanApplication.entityApplicant == undefined ||
        (loanApplication.entityApplicant != undefined && loanApplication.entityApplicant.extraDataObject?.principalOwnershipInformation != undefined
          && loanApplication.entityApplicant.extraDataObject.principalOwnershipInformation.length > 0);

      if (validPrincipalOwnerInfo) {
        loanApplication.entityApplicant?.extraDataObject?.principalOwnershipInformation?.some(po => {
          validPrincipalOwnerInfo = po.principalOwnerFirstName != undefined && po.principalOwnerFirstName.length > 0
            && po.principalOwnerLastName != undefined && po.principalOwnerLastName.length > 0
            && po.ssnTaxId != undefined && po.ssnTaxId.length > 0
            && po.physicalAddress != undefined && po.physicalAddress.length > 0
            && po.city != undefined && po.city.length > 0
            && po.state != undefined && po.state.length > 0
            && po.zipCode != undefined && po.zipCode.length > 0
            && po.dateOfBirth != undefined && new Date(po.dateOfBirth).toDateString().length > 0
            && po.validPhoneNumber && po.phoneNumber != undefined && po.phoneNumber.length > 0
            && po.percentageOwned != undefined && po.percentageOwned > 0
            && po.title != undefined && po.title.length > 0;

          return !validPrincipalOwnerInfo;
        })
      }

      validApplicantData = validApplicant && validJointApplicant && validEntity && validPrincipalOwnerInfo;
    } else {
      validApplicantData = false;
    }

    this.setValidFormClass('applicant-info-tab', validApplicantData);
    this.setState({ validApplicantInfo: validApplicantData });
  }

  getTabHTML(text: string, tabId: string) {
    return <span id={tabId}>{text}</span>
  }

  getNextButton(nextTab: string, validData: boolean) {
    return (
      <>
        {!this.props.userLoggedIn && this.state.draftEmailOptInVisible && (
          <Form.Group className="mb-3">
            <Form.Label><strong>Resume on another device</strong></Form.Label>
            <Form.Text className="d-block mb-2">
              To resume this application on a different device, enter your email:
            </Form.Text>
            <Row>
              <Col>
                <Form.Control
                  type="email"
                  placeholder="your@email.com"
                  value={this.state.draftMagicLinkEmail}
                  onChange={(e) => this.setState({ draftMagicLinkEmail: e.target.value })}
                />
              </Col>
              <Col xs="auto">
                <PrimaryButton
                  buttonText="Send Link"
                  onClick={async () => {
                    const { draftToken, draftMagicLinkEmail } = this.state;
                    if (draftToken && draftMagicLinkEmail) {
                      const sent = await loanApplicationService.SendDraftMagicLink(draftToken, draftMagicLinkEmail, this.props.sqId);
                      if (sent) {
                        toastUtility.showSuccessToast('Resume link sent! Check your email.');
                        this.setState({ draftEmailOptInVisible: false });
                      }
                    }
                  }}
                  disabled={!this.state.draftMagicLinkEmail}
                />
              </Col>
              <Col xs="auto">
                <SecondaryButton
                  buttonText="Dismiss"
                  onClick={() => this.setState({ draftEmailOptInVisible: false })}
                />
              </Col>
            </Row>
          </Form.Group>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          {!this.props.userLoggedIn && (
            <SecondaryButton
              buttonText="Resume on Different Device"
              onClick={() => this.setState({ draftEmailOptInVisible: !this.state.draftEmailOptInVisible })}
            />
          )}
          <SecondaryButton
            buttonText="Save Draft"
            onClick={() => this.saveDraft(true)}
          />
          <PrimaryButton
            buttonText="Next"
            onClick={() => {
              this.saveDraft(); // fire-and-forget
              this.setState({ activeTabKey: nextTab });
            }}
            disabled={!validData}
          />
        </div>
      </>
    )
  }

  checkForValidTabData(validTabData: boolean, tabId: string) {
    this.setValidFormClass(tabId, validTabData);
  }

  checkForValidApplication(): boolean {
    switch (this.state.loanApplication.loanType) {
      case LoanType.DealerPurchase:
      case LoanType.EquipmentRefinance:
        return this.state.validStartData && this.state.validPurchaseInformation
          && this.state.validEquipmentInformation && this.state.validGeneralData
          && this.state.validCollateral && this.state.validLendingReferenceData
          && this.state.validRevenueData && this.state.validApplicantInfo;

      case LoanType.ProductionLineOfCredit:
        return this.state.validStartData && this.state.validGeneralData
          && this.state.validCashFlowIntroData && this.state.validAllCashFlowIncomeData
          && this.state.validCashFlowOtherIncomeData && this.state.validCashFlowExpensesData
          && this.state.validCashFlowOtherExpensesData && this.state.validCashFlowLoanPaymentData
          && this.state.validLendingReferenceData && this.state.validApplicantInfo;

      case LoanType.EquipmentAuctionPurchase:
        return this.state.validStartData && this.state.validEquipmentInformation
          && this.state.validGeneralData && this.state.validLendingReferenceData
          && this.state.validRevenueData && this.state.validApplicantInfo;

      default:
        return false;

    }
  }

  checkForDev(): boolean {
    return window.location.host.includes('localhost') || window.location.host.includes('qa');
  }

  devPrefillApplication(): void {
    let loanApplication = { ...this.state.loanApplication };

    // TODO: Add items for each loan type
    loanApplication.loanType = LoanType.DealerPurchase;

    switch (loanApplication.loanType) {
      case LoanType.DealerPurchase:
      case LoanType.EquipmentRefinance:
        loanApplication.loanDealerPurchase = {
          purchaseAmount: 75000,
          customHire: false,
          totalAssets: 650000,
          totalLiabilities: 450000
        } as DealerPurchase;

        loanApplication.loanEquipmentInformation = [
          {
            index: 0,
            quantity: 1,
            unitPrice: 50000,
            totalPrice: 50000,
            vin: '1Z0346EBAGJ278775',
            make: 'John Deere',
            model: '6120E',
            year: '2024',
            new: true
          } as EquipmentInformation,
          {
            index: 1,
            quantity: 1,
            unitPrice: 25000,
            totalPrice: 25000,
            vin: '1T0326EBAGJ296618',
            make: 'John Deere',
            model: '326E',
            year: '2015',
            new: false
          } as EquipmentInformation
        ];

        loanApplication.loanEquipmentInsuranceInformation = {
          companyName: 'State Farm',
          agentName: 'James Smith',
          phoneNumber: '3085643298',
          displayPhoneNumber: '+1 (308)-564-3298'
        } as EquipmentInsuranceInformation;

        loanApplication.collateralEquityTypes = [CollateralEquityTypes.CashDown];

        loanApplication.collateralEquityCashDown = {
          amount: 25000
        } as CollateralEquityCashDown;
        break;

      default:
        break;
    }

    loanApplication.loanAmount = 50000;
    loanApplication.projectedGrossRevenues = {
      farmRevenues: 62000,
      offFarmRevenues: 36000
    } as GrossRevenue;

    loanApplication.loanLendingReference = {
      bankName: 'State Bank',
      contactName: 'James Smith',
      phoneNumber: '3085644523',
      displayPhoneNumber: '+1 (308)-564-4523'
    } as LendingReference;



    this.setState({
      loanApplication: loanApplication,
      validInsurancePhoneNumber: true,
      validLendingReferencePhoneNumber: true,
      validCollateral: true
    }, () => {
      this.validateStartData();
      this.validatePurchaseInformation();
      this.validateEquipmentInformation();
      this.validateGeneralQuestions();
      // Add these for collateral section
      this.setValidFormClass('collateral-section', true);
      this.setValidFormClass('collateral-tab', true);
      this.validateLendingReference();
      this.validateRevenueData();
      this.validateApplicantInfoData();
    })
  }

  async submitApplication(): Promise<void> {
    let loanApplication = { ...this.state.loanApplication };

    if (loanApplication.loanType === LoanType.ProductionLineOfCredit && loanApplication.loanProductionLineOfCredit != undefined) {
      loanApplication.loanProductionLineOfCredit.cashFlowData = JSON.stringify(loanApplication.loanProductionLineOfCredit.cashFlow);
    }

    const success = await this.props.submitCallback(loanApplication);
    if (success && this.state.draftToken) {
      this.deleteDraft(this.state.draftToken).catch(() => { });
    }
  }

  render() {
    function AccordionToggle(props: any): JSX.Element {
      const currentEventKey = useContext(AccordionContext);
      const isCurrentEventKey = currentEventKey === props.eventKey;

      if (props.hasData) {
        return (
          <Accordion.Toggle eventKey={props.eventKey} as={Button} variant="link" style={{ color: 'black' }}>
            <FontAwesomeIcon icon={isCurrentEventKey ? 'chevron-up' : 'chevron-down'} color="black" size="sm" />
          </Accordion.Toggle>
        );
      } else {
        return <></>;
      }
    }

    return (
      <div className="d-flex" style={{ marginTop: 15, marginBottom: 15, width: '100%' }}>

        <Row className="w-100">
          <Form className="w-100">
            <h1>Loan Pre-Qualification</h1>
            <div style={{ fontStyle: 'italic' }}>
              * Subject to credit approval/qualification. Applicable closing costs may apply.
            </div>
            {this.props.customerAccountInfo != undefined && <>
              <div style={{ fontSize: '0.85rem', color: '#6c757d', marginTop: '4px' }}>
                Your progress is saved automatically when you advance to the next tab. You can also use the <strong>Save Draft</strong> button at any time to save your progress.
              </div>
              {this.checkForDev() &&
                <div>
                  <SecondaryButton
                    buttonText="DEV: Pre-Fill"
                    onClick={this.devPrefillApplication.bind(this)}
                  />
                </div>
              }
            </>}

            {this.props.customerAccountInfo == undefined
              ? <AccountGateTab postLoginPath={this.props.sqId ? `/dealer/${this.props.sqId}/financing` : '/loan/create'} />
              : <Tabs
                //id="controlled-tab-example"
                activeKey={this.state.activeTabKey}
                onSelect={(k) => this.setState({ activeTabKey: k ?? '' })}
                className="mb-3"
                fill
              >
                <Tab eventKey="start"
                  title={this.getTabHTML('Start Loan', 'start-loan-tab')}
                  tabClassName={'tab-title'}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  onExit={() => this.checkForValidTabData(this.state.validStartData, 'start-loan-tab')}>
                  {!this.state.newApplication &&
                    <Form.Group className="mb-3">
                      <h5>Your Saved Drafts</h5>
                      {this.state.availableDrafts.length > 0 && !this.state.isResumingDraft && (
                        <div className="mb-4">
                          {this.state.availableDrafts.filter(d => !d.isExpired).length >= 5 && (
                            <Alert variant="warning" className="mb-2">
                              You have 5 saved drafts. Your oldest draft will be automatically deleted when you save a new one.
                            </Alert>
                          )}
                          {this.state.availableDrafts.map(draft => (
                            <Card key={draft.accessToken} className="mb-2">
                              <Card.Body className="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>{loanApplicationUtility.GetLoanTypeText(draft.loanType ?? 0)}</strong>
                                  {draft.loanAmount != null && (
                                    <span> · {draft.loanAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span>
                                  )}
                                  <br />
                                  <small className="text-muted">
                                    {draft.isExpired
                                      ? <>Expired {globalUtility.FormatRelativeDate(draft.expiresAt)} · Permanently deleted {globalUtility.FormatRelativeDate(draft.deletionDate!)}</>
                                      : <>Updated {globalUtility.FormatRelativeDate(draft.updatedAt)} · Expires {globalUtility.FormatRelativeDate(draft.expiresAt)}</>
                                    }
                                  </small>
                                </div>
                                <div>
                                  {draft.isExpired
                                    ? (
                                      <Button variant="warning" size="sm" className="me-2 mr-2"
                                        onClick={() => this.restoreDraft(draft.accessToken)}>
                                        Restore
                                      </Button>
                                    )
                                    : (
                                      <Button variant="primary" size="sm" className="me-2 mr-2"
                                        disabled={(this.props.defaultLoanType != undefined && draft.loanType !== this.props.defaultLoanType)}
                                        onClick={() => this.resumeDraft(draft.accessToken)}>
                                        Resume
                                      </Button>
                                    )
                                  }
                                  <Button variant="outline-danger" size="sm"
                                    onClick={() => {
                                      if (window.confirm('Delete this draft?')) {
                                        this.deleteDraft(draft.accessToken);
                                      }
                                    }}>
                                    Delete
                                  </Button>
                                </div>
                              </Card.Body>
                            </Card>
                          ))}
                        </div>
                      )}

                      {this.state.availableDrafts.length === 0 &&
                        <Alert variant="warning" className="mb-2">
                          You don't have any saved drafts. Click "Start New Application" to get started.
                        </Alert>
                      }

                      <Button variant="outline-primary" className="mt-2"
                        onClick={() => this.setState({ newApplication: true, isResumingDraft: false, draftToken: undefined })}>
                        + Start New Application
                      </Button>
                    </Form.Group>
                  }

                  {(this.state.isResumingDraft || this.state.newApplication) &&
                    <>
                      <Form.Group className="mb-3">
                        {(this.props.loanTypesToShow != undefined && this.props.loanTypesToShow.includes(LoanType.EquipmentAuctionPurchase)) &&
                          <>
                            <div className="mb-3" style={{ fontStyle: 'italic', fontWeight: 'bold', fontSize: 14 }}>
                              NOTE: This is an application for financing on a specific auction item. Only proceed if you are actively planning to bid on an auction item.
                            </div>
                          </>
                        }
                        <Form.Label className="mb-3" id={`loan-type`}>{<h5>Loan Type*</h5>}</Form.Label>
                        <Form.Group className="mb-3">
                          {(this.props.loanTypesToShow == undefined || this.props.loanTypesToShow.includes(LoanType.DealerPurchase)) &&
                            <Form.Check
                              type="checkbox"
                              className={'custom-checkbox'}
                              style={{ fontSize: 18 }}
                              label={loanApplicationUtility.GetLoanTypeText(LoanType.DealerPurchase)}
                              checked={this.state.loanApplication.loanType === LoanType.DealerPurchase}
                              onChange={(event) => this.setLoanTypeState(LoanType.DealerPurchase, event.target.checked)}
                              disabled={this.state.isResumingDraft}
                            />
                          }

                          {(this.props.loanTypesToShow == undefined || this.props.loanTypesToShow.includes(LoanType.EquipmentRefinance)) &&
                            <Form.Check
                              type="checkbox"
                              className={'custom-checkbox'}
                              style={{ fontSize: 18 }}
                              label={loanApplicationUtility.GetLoanTypeText(LoanType.EquipmentRefinance)}
                              checked={this.state.loanApplication.loanType === LoanType.EquipmentRefinance}
                              onChange={(event) => this.setLoanTypeState(LoanType.EquipmentRefinance, event.target.checked)}
                              disabled={this.state.isResumingDraft}
                            />
                          }

                          {/* {(this.props.loanTypesToShow == undefined || this.props.loanTypesToShow.includes(LoanType.GapFinancing)) &&
                      <Form.Check
                        type="checkbox"
                        className={'custom-checkbox'}
                        style={{ fontSize: 18 }}
                        label={loanApplicationUtility.GetLoanTypeText(LoanType.GapFinancing)}
                        checked={this.state.loanApplication.loanType === LoanType.GapFinancing}
                        onChange={(event) => this.setLoanTypeState(LoanType.GapFinancing, event.target.checked)}
                      />
                    } */}

                          {(this.props.loanTypesToShow == undefined || this.props.loanTypesToShow.includes(LoanType.ProductionLineOfCredit)) &&
                            <Form.Check
                              type="checkbox"
                              className={'custom-checkbox'}
                              style={{ fontSize: 18 }}
                              label={loanApplicationUtility.GetLoanTypeText(LoanType.ProductionLineOfCredit)}
                              checked={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit}
                              onChange={(event) => this.setLoanTypeState(LoanType.ProductionLineOfCredit, event.target.checked)}
                              disabled={this.state.isResumingDraft}
                            />
                          }

                          {((this.props.loanTypesToShow != undefined && this.props.loanTypesToShow.includes(LoanType.EquipmentAuctionPurchase)) || (this.state.isResumingDraft && this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase)) &&
                            <Form.Check
                              type="checkbox"
                              className={'custom-checkbox'}
                              style={{ fontSize: 18 }}
                              label={loanApplicationUtility.GetLoanTypeText(LoanType.EquipmentAuctionPurchase)}
                              checked={this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase}
                              onChange={(event) => this.setLoanTypeState(LoanType.EquipmentAuctionPurchase, event.target.checked)}
                              disabled={this.state.isResumingDraft}
                            />
                          }
                          {this.state.isResumingDraft && (
                            <Form.Text className="text-muted">
                              Loan type is locked to match your selected draft.
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Form.Group>

                      {this.props.userLoggedIn &&
                        <>
                          {/* Pre-fill question — only shown after a loan type is selected and a previous app exists */}
                          <Form.Label className="mb-3">{<h5>Pre-Fill Application</h5>}</Form.Label>
                          {!this.state.prefillLoading ?
                            <>
                              {(this.state.previousApplication !== undefined &&
                                this.state.previousApplication !== null) ?
                                <>
                                  <Form.Group className="mb-3">
                                    <Form.Label className="mb-3">
                                      Would you like to pre-fill information from your most recent application? This may override any currently entered information.
                                    </Form.Label>
                                    {(this.state.loanApplication.loanType !== undefined &&
                                      this.state.loanApplication.loanType > 0)
                                      ?
                                      <Form.Group className="mb-3">
                                        <Form.Check
                                          type="checkbox"
                                          label="Yes - Pre-Fill"
                                          checked={this.state.wantsPrefill === true}
                                          onChange={(event) => {
                                            if (event.target.checked) {
                                              this.setState({ wantsPrefill: true }, () => this.applyPrefill());
                                            }
                                          }}
                                        />
                                      </Form.Group>
                                      :
                                      <Form.Text className="text-muted">
                                        * Please select a loan type to choose.
                                      </Form.Text>
                                    }
                                  </Form.Group>
                                </>
                                :
                                <>
                                  <Form.Text className="text-muted">
                                    * No previous applications to pre-fill from.
                                  </Form.Text>
                                </>
                              }
                            </>
                            :
                            <>
                              <Form.Text className="text-muted">
                                * Pre-Fill information loading...
                              </Form.Text>
                            </>
                          }
                        </>
                      }
                    </>
                  }

                  {this.getNextButton(
                    this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase
                      ? 'equipment-info'
                      : EquipmentOnlyLoans.includes(this.state.loanApplication.loanType)
                        ? 'purchase-info'
                        : 'general',
                    this.state.validStartData && (!this.state.prefillLoading || !this.props.userLoggedIn) && !this.state.draftsLoading
                  )}
                </Tab>

                <Tab eventKey="purchase-info"
                  title={this.getTabHTML('Purchase Information', 'purchase-info-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={EquipmentOnlyLoans.includes(this.state.loanApplication.loanType) ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validPurchaseInformation, 'purchase-info-tab')}>
                  <>
                    {this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase ?
                      <>
                        <h3>Auction Information</h3>
                        <Form.Group className="mb-3">
                          <Form.Label id="total-purchase-amount">Estimated Purchase Amount*</Form.Label>
                          <NumericFormat
                            value={this.state.loanApplication.loanDealerPurchase?.purchaseAmount}
                            placeholder="Estimated Final Purchase Amount"
                            className="form-control"
                            thousandSeparator
                            prefix="$"
                            decimalScale={2}
                            fixedDecimalScale={true}
                            onValueChange={(values) => this.setPurchaseAmountState(values.floatValue ?? 0)}
                          />
                        </Form.Group>
                      </>
                      :
                      <>
                        {/* Equipment Purchase/Refinance Information */}
                        <h3>Sale Information</h3>
                        <Form.Group className="mb-3">
                          <Form.Label id="dealer-select" >Dealer Information*</Form.Label>
                          <p style={{ fontStyle: 'italic' }}>If the dealership you're purchasing from isn't listed, please select "Manually Add Dealer/Salesman" below.</p>
                          <Form.Control
                            disabled={this.state.otherSalesmanSelected}
                            as="select"
                            onChange={(event) => this.setDealerState(+event.target.value)}
                            value={this.state.loanApplication.loanDealerPurchase?.dealerId}>
                            <option value={-1}>Select a dealer below...</option>
                            {this.props.dealers.map(d => {
                              return (
                                <option value={d.id}>{`${d.name} - ${d.city}, ${d.state}`}</option>
                              )
                            })}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label id="dealer-location-select" >Dealer Location Information*</Form.Label>
                          <Form.Control
                            as="select"
                            disabled={this.state.otherSalesmanSelected}
                            onChange={(event) => this.setDealerLocationState(+event.target.value)}
                            value={this.state.loanApplication.loanDealerPurchase?.dealerLocationId}>
                            <option value={-1}>Select a location below...</option>
                            {this.state.selectedDealer.dealerLocations?.map(dl => {
                              return (
                                <option value={dl.id}>{`${dl.displayName ?? this.state.selectedDealer.name} - ${dl.city}, ${dl.state} (#${dl.id})`}</option>
                              )
                            })}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label id="salesman-select" >Salesman Information*</Form.Label>
                          <Form.Control
                            as="select"
                            disabled={this.state.otherSalesmanSelected}
                            onChange={(event) => this.setDealerSalesmanState(+event.target.value)}
                            value={this.state.loanApplication.loanDealerPurchase?.dealerSalesmanId}>
                            <option value={-1}>Select a salesman below...</option>
                            {this.state.selectedDealerLocation.dealerSalesmen?.map(ds => {
                              return (
                                <option value={ds.id}>{`${ds.firstName} ${ds.lastName} (#${ds.id})`}</option>
                              )
                            })}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Group className="mb-3" >
                            <Form.Check type="checkbox" style={{ fontWeight: 'bold' }} label={'Manually Add Dealer/Salesman'} checked={this.state.otherSalesmanSelected} onChange={(event) => this.setOtherSalesmanSelected(event.target.checked)} />
                          </Form.Group>
                        </Form.Group>

                        {this.state.otherSalesmanSelected &&
                          <Row className="mb-3">
                            <Form.Group as={Col}>
                              <Form.Label id="other-salesman-location">Location*</Form.Label>
                              <Form.Control type="text" placeholder="Dealer Name - City, State" value={this.state.loanApplication.loanDealerPurchase?.dealerOther?.location} defaultValue={''} onChange={(event) => this.setOtherLocation(event.target.value)} />
                            </Form.Group>

                            <Form.Group as={Col}>
                              <Form.Label id="other-salesman-name">Salesman Name*</Form.Label>
                              <Form.Control type="text" placeholder="First and Last" value={this.state.loanApplication.loanDealerPurchase?.dealerOther?.name} defaultValue={''} onChange={(event) => this.setOtherName(event.target.value)} />
                            </Form.Group>

                            <Form.Group as={Col}>
                              <Form.Label id="other-salesman-phone">Salesman Phone Number*</Form.Label>
                              <PhoneInput
                                specialLabel=""
                                inputClass="form-control"
                                country={'us'}
                                onlyCountries={['us']}
                                value={this.state.loanApplication.loanDealerPurchase?.dealerOther?.displayPhoneNumber}
                                onChange={this.setOtherPhoneNumber.bind(this)}
                              />
                            </Form.Group>
                          </Row>
                        }

                        <Form.Group className="mb-3">
                          <Form.Label id="total-purchase-amount">Total Purchase Amount*</Form.Label>
                          <NumericFormat
                            value={this.state.loanApplication.loanDealerPurchase?.purchaseAmount}
                            placeholder="Purchase Amount"
                            className="form-control"
                            thousandSeparator
                            prefix="$"
                            decimalScale={2}
                            fixedDecimalScale={true}
                            onValueChange={(values) => this.setPurchaseAmountState(values.floatValue ?? 0)}
                          />
                        </Form.Group>
                      </>
                    }




                    {this.getNextButton('equipment-info', this.state.validPurchaseInformation)}
                  </>
                </Tab>

                <Tab eventKey="equipment-info"
                  title={this.getTabHTML('Equipment Information', 'equipment-info-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase || EquipmentOnlyLoans.includes(this.state.loanApplication.loanType) ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validEquipmentInformation, 'equipment-info-tab')}>
                  <div>
                    <h3>Equipment Information</h3>
                    {this.state.loanApplication.loanEquipmentInformation != undefined ?
                      <>
                        {this.state.loanApplication.loanEquipmentInformation.map((le, index) => {
                          return (
                            <>
                              <h5>{`Equipment Item #${index + 1}`}
                                {index > 0 &&
                                  <span>
                                    <Button variant="link" onClick={() => this.removeEquipmentClicked(index)} >
                                      <FontAwesomeIcon icon="minus" color="red" />
                                    </Button>
                                  </span>
                                }
                              </h5>

                              {this.state.loanApplication.loanType !== LoanType.EquipmentAuctionPurchase &&
                                <>
                                  <Form.Group className="mb-3" controlId="formDealerSelect">
                                    <Form.Label>Product Select (if applicable)</Form.Label>
                                    <Form.Control as="select" onChange={(event) => this.setSelectedProduct(+event.target.value, index)} value={le.equipmentProductId}>
                                      <option value={-1}>Select a product below...</option>
                                      {this.state.productOptions.map(p => {
                                        return (
                                          <option value={p.id}>{`${p.itemNumber} - ${p.make} ${p.model}`}</option>
                                        )
                                      })}
                                    </Form.Control>
                                    <p style={{ fontStyle: 'italic', marginTop: 10 }}>If your product is not listed, please manually add it below.</p>
                                  </Form.Group>
                                </>
                              }

                              <Form.Group className="ml-3">
                                <Row className="mb-3">
                                  <Form.Group as={Col}>
                                    <Form.Label className="mb-3">New/Used*</Form.Label>
                                    <Form.Check type="checkbox" label="New" checked={le.new} onChange={(event) => this.setEquipmentConditionValue(event.target.checked ? true : false, index)} />
                                    <Form.Check type="checkbox" label="Used" checked={!le.new} onChange={(event) => this.setEquipmentConditionValue(event.target.checked ? false : true, index)} />
                                  </Form.Group>

                                  {this.state.loanApplication.loanType !== LoanType.EquipmentAuctionPurchase &&
                                    <>
                                      <Form.Group as={Col}>
                                        <Form.Label id={`equipment-quantity-${index}`}>Quantity*</Form.Label>
                                        <Form.Control
                                          type="number"
                                          placeholder="Enter quantity"
                                          value={le.quantity}
                                          onChange={(event) => this.setEquipmentQuantity(+event.target.value, index)}
                                        />
                                      </Form.Group>
                                    </>
                                  }
                                </Row>

                                {/* We are not showing this for auction applications, as we will get that based on the equipment value */}
                                {this.state.loanApplication.loanType !== LoanType.EquipmentAuctionPurchase &&
                                  <>
                                    <Row className="mb-3">
                                      <Form.Group as={Col}>
                                        <Form.Label id={`equipment-unit-price-${index}`}>{`Item #${index + 1} ${this.state.loanApplication.loanType === LoanType.EquipmentRefinance ? 'Market' : 'Unit'} Price*`}</Form.Label>
                                        <NumericFormat
                                          value={le.unitPrice}
                                          placeholder="Unit Price"
                                          className="form-control"
                                          thousandSeparator
                                          prefix="$"
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                          onValueChange={(values) => this.setEquipmentUnitPriceAmount(values.floatValue ?? 0, index)}
                                        />
                                      </Form.Group>

                                      <Form.Group as={Col}>
                                        <Form.Label id={`equipment-purchase-price-${index}`}>{`Item #${index + 1} ${this.state.loanApplication.loanType === LoanType.EquipmentRefinance ? 'Market' : 'Purchase'} Amount (Calculated)*`}</Form.Label>
                                        <NumericFormat
                                          value={le.totalPrice}
                                          placeholder="Total Purchase Amount"
                                          className="form-control"
                                          thousandSeparator
                                          prefix="$"
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                          disabled={true}
                                        />
                                      </Form.Group>
                                    </Row>
                                  </>
                                }

                                <Row className="mb-3">
                                  <Form.Group as={Col}>
                                    <Form.Label id={`equipment-vin-${index}`}>Vin/Serial # (Optional)</Form.Label>
                                    <Form.Control type="text" placeholder="Enter vin/serial#" value={le.vin} defaultValue={''} onChange={(event) => this.setEquipmentVinSerialValue(event.target.value, index)} />
                                  </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                  <Form.Group as={Col}>
                                    <Form.Label id={`equipment-year-${index}`}>Year*</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter year"
                                      value={le.year} defaultValue={''}
                                      onChange={(event) => this.setEquipmentYearSerialValue(event.target.value, index)}
                                    />
                                  </Form.Group>

                                  <Form.Group as={Col}>
                                    <Form.Label id={`equipment-make-${index}`}>Make*</Form.Label>
                                    <Form.Control type="text" placeholder="Enter make" value={le.make} defaultValue={''} onChange={(event) => this.setEquipmentMakeSerialValue(event.target.value, index)} />
                                  </Form.Group>

                                  <Form.Group as={Col}>
                                    <Form.Label id={`equipment-model-${index}`}>Model*</Form.Label>
                                    <Form.Control type="text" placeholder="Enter model" value={le.model} defaultValue={''} onChange={(event) => this.setEquipmentModelSerialValue(event.target.value, index)} />
                                  </Form.Group>
                                </Row>
                              </Form.Group>
                            </>
                          )
                        })
                        }
                      </>
                      :
                      <div className="mb-3">Please add equipment information.</div>
                    }
                    <div className="mb-3">
                      <SecondaryButton
                        buttonText="Add Equipment"
                        onClick={this.addEquipmentClicked.bind(this)}
                      />
                    </div>
                  </div>

                  <div>
                    <h3>Equipment Insurance Information</h3>
                    <Row className="mb-3">
                      <Form.Group as={Col}>
                        <Form.Label id="insurance-agency">Insurance Agency*</Form.Label>
                        <Form.Control type="text" placeholder="Enter agency name" value={this.state.loanApplication.loanEquipmentInsuranceInformation?.companyName} defaultValue={''} onChange={(event) => this.setInsuranceAgencyState(event.target.value)} />
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Label id="insurance-agent-name">Agent*</Form.Label>
                        <Form.Control type="text" placeholder="Enter agent name" value={this.state.loanApplication.loanEquipmentInsuranceInformation?.agentName} defaultValue={''} onChange={(event) => this.setAgentNameState(event.target.value)} />
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Label id="insurance-phone-number">Agent Phone Number*</Form.Label>
                        <PhoneInput
                          specialLabel=""
                          inputClass="form-control"
                          country={'us'}
                          onlyCountries={['us']}
                          value={this.state.loanApplication.loanEquipmentInsuranceInformation?.displayPhoneNumber}
                          onChange={this.setAgentPhoneNumberState.bind(this)}
                        />
                      </Form.Group>
                    </Row>
                  </div>

                  {this.getNextButton('general', this.state.validEquipmentInformation)}
                </Tab>

                <Tab eventKey="general"
                  title={this.getTabHTML('General Questions', 'general-questions-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  onExit={() => this.checkForValidTabData(this.state.validGeneralData, 'general-questions-tab')}>
                  {/* Equipment Financing General Questions Section */}
                  {(this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase || EquipmentOnlyLoans.includes(this.state.loanApplication.loanType)) &&
                    <>
                      <div>
                        <h3>General Questions</h3>
                        <Form.Label className="mb-3">Is This Purchase For Custom Hire Use?*</Form.Label>
                        <Form.Group className="mb-3" >
                          <Form.Check type="checkbox" label="Yes" checked={this.state.loanApplication.loanDealerPurchase?.customHire} onChange={(event) => this.setCustomerHireUseState(event.target.checked ? true : false)} />
                          <Form.Check type="checkbox" label="No" checked={!this.state.loanApplication.loanDealerPurchase?.customHire} onChange={(event) => this.setCustomerHireUseState(event.target.checked ? false : true)} />
                        </Form.Group>


                        <Row className="mb-3">
                          <Form.Group as={Col}>
                            <Form.Label id="total-assets">Total Assets*</Form.Label>
                            <NumericFormat
                              value={this.state.loanApplication.loanDealerPurchase?.totalAssets}
                              placeholder="Enter total assets"
                              className="form-control"
                              thousandSeparator
                              prefix="$"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              onValueChange={(values) => this.setDealerPurchaseAssetsState(values.floatValue ?? 0)}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label id="total-liabilities">Total Liabilities*</Form.Label>
                            <NumericFormat
                              value={this.state.loanApplication.loanDealerPurchase?.totalLiabilities}
                              placeholder="Enter total liabilities"
                              className="form-control"
                              thousandSeparator
                              prefix="$"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              onValueChange={(values) => this.setDealerLiabilitiesState(values.floatValue ?? 0)}
                            />
                          </Form.Group>
                        </Row>

                        <Row>
                          <Form.Group as={Col} >
                            <Form.Check type="checkbox"
                              label={'Are you a Farmer/Rancher or will the equipment be used for farm related services?'}
                              checked={this.state.isFarmer}
                              onChange={(event) => this.setIsFarmer(event.target.checked)}
                            />
                          </Form.Group>
                        </Row>
                        {this.state.isFarmer &&
                          <Row>
                            <Form.Group as={Col}>
                              <Form.Label id="primary-ag-product">Primary Ag Product</Form.Label>
                              <Form.Control as="select" onChange={(event) => this.setSelectedPrimaryAgProduct(event.target.value)} value={this.state.loanApplication.primaryAgProduct}>
                                <option value={''}>Select a product below...</option>
                                {this.state.agProductOptions.map(so => {
                                  return (
                                    <option value={so.value}>{`${so.value} - ${so.label}`}</option>
                                  )
                                })}
                              </Form.Control>
                            </Form.Group>
                          </Row>
                        }

                        {this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase &&
                          <>
                            <Row className="mb-3">
                              <Form.Group as={Col}>
                                <Form.Label id="auction-lot-id">Lot ID*</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter the lot ID #"
                                  value={this.state.loanApplication.loanAuctionInformation?.lotId}
                                  defaultValue={''}
                                  onChange={(event) => this.setAuctionLotIdState(event.target.value)} />
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label id="auction-end-date">Auction End Date*</Form.Label>
                                <DatePicker
                                  selected={isValid(this.state.loanApplication.loanAuctionInformation?.auctionEndDate) ? this.state.loanApplication.loanAuctionInformation?.auctionEndDate : undefined}
                                  placeholderText={"Enter the date when the auction ends"}
                                  onChange={(value: Date) => this.setAuctionEndDateState(value)}
                                  customInput={
                                    <Form.Control />
                                  }
                                />
                              </Form.Group>
                            </Row>

                            <Row className="mb-3">
                              <Form.Group as={Col}>
                                <Form.Label id="auction-listing-url">Listing URL*</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter the URL to the listing"
                                  value={this.state.loanApplication.loanAuctionInformation?.listingUrl}
                                  defaultValue={''}
                                  onChange={(event) => this.setAuctionListingURLState(event.target.value)} />
                              </Form.Group>
                            </Row>

                            {/* <span style={{ fontStyle: 'italic', fontWeight: 'bold' }}>Business Questions (Optional):</span>
                          <Row>
                            <Form.Group as={Col}>
                              <Form.Label>What is the nature of your business?</Form.Label>
                              <Form.Control
                                id="auction-lot-id"
                                type="text"
                                placeholder="Examples: Farming, Construction"
                                value={this.state.loanApplication.loanAuctionInformation?.natureOfBusiness}
                                defaultValue={''}
                                onChange={(event) => this.setAuctionListingNatureState(event.target.value)} />
                            </Form.Group>

                            <Form.Group as={Col}>
                              <Form.Label>What Products Do You Sell?</Form.Label>
                              <Form.Control
                                id="auction-listing-url"
                                type="text"
                                placeholder="Examples: Crops, Livestock, Building Materials"
                                value={this.state.loanApplication.loanAuctionInformation?.products}
                                defaultValue={''}
                                onChange={(event) => this.setAuctionListingProductsState(event.target.value)} />
                            </Form.Group>
                          </Row>

                          <Row>
                            <Form.Group as={Col}>
                              <Form.Label>What Services Do You Provide?</Form.Label>
                              <Form.Control
                                id="auction-lot-id"
                                type="text"
                                placeholder="Examples: Custom Harvesting, Excavation, Freight Hauling"
                                value={this.state.loanApplication.loanAuctionInformation?.services}
                                defaultValue={''}
                                onChange={(event) => this.setAuctionListingServicesState(event.target.value)} />
                            </Form.Group>

                            <Form.Group as={Col}>
                              <Form.Label>What Geographical Area(s) Do You Serve?</Form.Label>
                              <Form.Control
                                id="auction-listing-url"
                                type="text"
                                placeholder="Examples: Local Community, Multi-County Region, Statewide, Multi-State, Nationwide"
                                value={this.state.loanApplication.loanAuctionInformation?.geoAreas}
                                defaultValue={''}
                                onChange={(event) => this.setAuctionListingAreasState(event.target.value)} />
                            </Form.Group>
                          </Row> */}
                          </>
                        }
                      </div>

                      {this.getNextButton((this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase) ? 'lending-reference' : 'collateral', this.state.validGeneralData)}
                    </>
                  }

                  {/* Gap Financing General Questions Section */}
                  {this.state.loanApplication.loanType === LoanType.GapFinancing &&
                    <>
                      <div>
                        <h3>General Questions</h3>
                        <Row className="mb-3">
                          <Form.Group as={Col}>
                            <Form.Label id="total-request-amount">Amount Requested*</Form.Label>
                            <NumericFormat
                              value={this.state.loanApplication.loanDealerPurchase?.purchaseAmount}
                              placeholder="Enter Amount"
                              className="form-control"
                              thousandSeparator
                              prefix="$"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              onValueChange={(values) => this.setRequestAmountState(values.floatValue ?? 0)}
                            />
                          </Form.Group>
                        </Row>

                        <Row className="mb-3">
                          <Form.Group as={Col}>
                            <Form.Label id="government-agency">Which government agencies do you contract with?*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter agency name"
                              value={this.state.loanApplication.loanGapFinancing?.governmentAgency}
                              defaultValue={''}
                              onChange={(event) => this.setGapFinancingAgenciesState(event.target.value)} />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label id="average-request">What is your average request amount for reimbursement?*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter average request amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanGapFinancing?.averageReimbursementAmount}
                              onValueChange={(values) => this.setGapFinancingAverageRequestState(values?.floatValue ?? 0)}
                              className="form-control"
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label id="reimbursement-time">How long does it normally take you to get reimbursed? (months)*</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Enter amount of months"
                              defaultValue={''}
                              value={this.state.loanApplication.loanGapFinancing?.averageReimbursementLength ?? ''}
                              onChange={(event) => this.setGapFinancingAverageReimbursementState(+event.target.value)}
                              className="form-control"
                            />
                          </Form.Group>
                        </Row>
                        <Row className="mb-3">
                          <Form.Group as={Col}>
                            <Form.Label id="total-assets">Total Assets*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter total assets"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanGapFinancing?.totalAssets}
                              onValueChange={(values) => this.setGapFinancingAssetsState(values?.floatValue ?? 0)}
                              className="form-control"
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label id="total-liabilities">Total Liabilities*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter total liabilities"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanGapFinancing?.totalLiabilities}
                              onValueChange={(values) => this.setGapFinancingLiabilitiesState(values?.floatValue ?? 0)}
                              className="form-control"
                            />
                          </Form.Group>
                        </Row>
                      </div>

                      {this.getNextButton('collateral', this.state.validGeneralData)}
                    </>
                  }

                  {/* Production Line of Credit */}
                  {this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit &&
                    <>
                      <div>
                        <h3>General Questions</h3>
                        <div style={{ fontStyle: 'italic', fontSize: 12 }}>
                          <ul>
                            <li>This application is for a production line of credit</li>
                            <li>The production plan projects the value of your annual agricultural production</li>
                            <li>Your production is used to repay the production line of credit loan you are requesting</li>
                          </ul>
                        </div>
                        <Row className="mb-3">
                          <Form.Group as={Col}>
                            <Form.Label id="total-request-amount">Amount Requested*</Form.Label>
                            <NumericFormat
                              value={this.state.loanApplication.loanAmount}
                              placeholder="Enter Amount"
                              className="form-control"
                              thousandSeparator
                              prefix="$"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              onValueChange={(values) => this.setRequestAmountState(values.floatValue ?? 0)}
                            />
                          </Form.Group>
                        </Row>

                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label id={`current-production-loan`}>Do you currently have a production (operating) loan now?*</Form.Label>
                            <Form.Group>
                              <Form.Check type="checkbox" label={'Yes'} checked={this.state.loanApplication.loanProductionLineOfCredit?.hasCurrentLoan ?? false} onChange={(event) => this.setCashFlowHasCurrentLoan(true, 'current-production-loan')} />
                              <Form.Check type="checkbox" label={'No'} checked={!(this.state.loanApplication.loanProductionLineOfCredit?.hasCurrentLoan ?? true)} onChange={(event) => this.setCashFlowHasCurrentLoan(false, 'current-production-loan')} />
                            </Form.Group>
                          </Form.Group>
                        </Row>

                        {this.state.loanApplication.loanProductionLineOfCredit?.hasCurrentLoan &&
                          <>
                            <Row style={{ paddingLeft: 15 }}>
                              <Form.Group as={Col}>
                                <Form.Label id="current-production-loan-amount">Current Balance*</Form.Label>
                                <NumericFormat
                                  value={this.state.loanApplication.loanProductionLineOfCredit?.currentLoanBalance}
                                  placeholder="Enter current balance amount"
                                  className="form-control"
                                  thousandSeparator
                                  prefix="$"
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  onValueChange={(values) => this.setCashFlowCurrentLoanBalance('current-production-loan-amount', values.floatValue ?? 0)}
                                />
                              </Form.Group>
                            </Row>
                          </>
                        }
                      </div>

                      {this.getNextButton('cash-flow-introduction', this.state.validGeneralData)}
                    </>
                  }
                </Tab>

                <Tab eventKey="collateral"
                  title={this.getTabHTML('Collateral Information', 'collateral-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType !== LoanType.ProductionLineOfCredit && this.state.loanApplication.loanType !== LoanType.EquipmentAuctionPurchase ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validCollateral, 'collateral-tab')}>
                  <div>
                    <h3>Collateral Information</h3>
                    <div className="mb-3" id="collateral-section">
                      <div style={{ fontStyle: 'italic' }}>At least one section below is required*</div>
                      {EquipmentOnlyLoans.includes(this.state.loanApplication.loanType) &&
                        <div style={{ fontStyle: 'italic' }}>Final Asking Loan Amount: <span style={{ color: 'green' }}>{loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanAmount)}</span></div>
                      }
                      {this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase &&
                        <>
                          <div style={{ fontStyle: 'italic', fontWeight: 'bold' }}>** Auto-calculated to 20% for auction listings. Final % may be lower upon review.</div>
                        </>
                      }
                    </div>

                    <h5>Cash</h5>
                    <Form.Group>
                      <Form.Label id="cash-down">{this.getCashCollateralText()}</Form.Label>
                      <NumericFormat
                        prefix="$"
                        placeholder="Enter cash down amount"
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator
                        value={this.state.loanApplication.collateralEquityCashDown?.amount}
                        onValueChange={(values) => this.setCashDownAmountState(values?.floatValue ?? 0)}
                        className="form-control"
                      />
                    </Form.Group>

                    {this.state.loanApplication.loanType !== LoanType.EquipmentAuctionPurchase &&
                      <>
                        {EquipmentOnlyLoans.includes(this.state.loanApplication.loanType) &&
                          <>
                            <h5>Trade Information</h5>
                            <Row className="mb-3">
                              <Form.Group as={Col}>
                                <Form.Label>Description</Form.Label>
                                <Form.Control type="text" placeholder="Describe the trade" value={this.state.loanApplication.collateralEquityTrade?.description} defaultValue={''} onChange={(event) => this.setTradeDescriptionState(event.target.value)} />
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label id="cash-down">Trade Value</Form.Label>
                                <NumericFormat
                                  prefix="$"
                                  placeholder="Enter the value of the trade"
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator
                                  value={this.state.loanApplication.collateralEquityTrade?.value}
                                  onValueChange={(values) => this.setTradeAmountState(values?.floatValue ?? 0)}
                                  className="form-control"
                                />
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label id="cash-down">Any Amount Owed?</Form.Label>
                                <NumericFormat
                                  prefix="$"
                                  placeholder="Enter any amount still owed"
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator
                                  value={this.state.loanApplication.collateralEquityTrade?.stillOwe}
                                  onValueChange={(values) => this.setTradeAmountOwedState(values?.floatValue ?? 0)}
                                  className="form-control"
                                />
                              </Form.Group>
                            </Row>
                          </>
                        }

                        <h5>Other Collateral Information</h5>
                        <Form.Label id="cash-down">{this.getOtherCollateralText()}</Form.Label>
                        {this.state.loanApplication.collateralEquityOtherCollateral?.map((oc, index) => {
                          return (
                            <Row className="mb-3">
                              <Form.Group as={Col}>
                                <Form.Label>Description</Form.Label>
                                <Form.Control type="text" placeholder="Describe the other collateral" value={oc.description} defaultValue={''} onChange={(event) => this.setOtherDescriptionState(event.target.value, index)} />
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Form.Label id="cash-down">Value</Form.Label>
                                <NumericFormat
                                  prefix="$"
                                  placeholder="Enter the value of the other collateral"
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator
                                  value={oc.value}
                                  onValueChange={(values) => this.setOtherAmountState(values?.floatValue ?? 0, index)}
                                  className="form-control"
                                />
                              </Form.Group>

                              <Form.Group as={Col}>
                                <Row>
                                  <Form.Label id="cash-down">&nbsp;</Form.Label>
                                </Row>
                                <Row>
                                  <DangerButton
                                    buttonText="Delete Item"
                                    onClick={() => this.removeOtherCollateralClicked(index)}
                                  />
                                </Row>

                              </Form.Group>
                            </Row>
                          )
                        })}

                        <div className="mb-3">
                          <SecondaryButton
                            buttonText="Add Other Collateral"
                            onClick={this.addOtherCollateralClicked.bind(this)}
                          />
                        </div>
                      </>
                    }

                    {this.getNextButton('lending-reference', this.state.validCollateral)}
                  </div>
                </Tab>

                <Tab eventKey="cash-flow-introduction"
                  title={this.getTabHTML('Production Plan - Introduction', 'cash-flow-intro-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validCashFlowIntroData, 'cash-flow-intro-tab')}>
                  <>
                    <Row className="mb-3">
                      <Form.Group as={Col}>
                        <Form.Label id="production-cycle-start">Production Cycle Start Date*</Form.Label>
                        <DatePicker
                          placeholderText="Enter start date"
                          selected={
                            isValid(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.cycleStart) ?
                              this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.cycleStart :
                              this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.cycleStart != undefined ?
                                new Date(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.cycleStart) :
                                undefined
                          }
                          onChange={(selectedDate: Date) => this.setCashFlowCycleStartDate(selectedDate, 'production-cycle-start')}
                        />
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Label id="production-cycle-end">Production Cycle End Date*</Form.Label>
                        <DatePicker
                          placeholderText="Enter end date"
                          selected={
                            isValid(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.cycleEnd) ?
                              this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.cycleEnd :
                              this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.cycleEnd != undefined ?
                                new Date(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.cycleEnd) :
                                undefined
                          }
                          onChange={(selectedDate: Date) => this.setCashFlowCycleEndDate(selectedDate, 'production-cycle-end')}
                        />
                      </Form.Group>
                    </Row>

                    <Row className="mb-3">
                      <Form.Group as={Col}>
                        <Form.Label id="production-as-of-date">As Of Date*</Form.Label>
                        <DatePicker
                          placeholderText="Enter date the plan is to be completed"
                          selected={
                            isValid(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.asOfDate) ?
                              this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.asOfDate :
                              this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.asOfDate != undefined ?
                                new Date(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.asOfDate) :
                                undefined
                          }
                          onChange={(selectedDate: Date) => this.setCashFlowCycleAsOfDate(selectedDate, 'production-as-of-date')}
                        />
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Label id={`business-plan-type`}>Business Plan Type*</Form.Label>
                        <Form.Group>
                          <Form.Check type="checkbox" label={'Projected'} checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.projected} onChange={(event) => this.setCashFlowTypeState(true)} />
                          <Form.Check type="checkbox" label={'Actual'} checked={!this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.introductionSection?.projected} onChange={(event) => this.setCashFlowTypeState(false)} />
                        </Form.Group>
                      </Form.Group>
                    </Row>

                    {this.getNextButton('cash-flow-income', this.state.validCashFlowIntroData)}
                  </>
                </Tab>

                <Tab eventKey="cash-flow-income"
                  title={this.getTabHTML('Production Plan - Production Income', 'cash-flow-income-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validAllCashFlowIncomeData, 'cash-flow-income-tab')}>
                  <>
                    <div style={{ fontStyle: 'italic' }}>
                      Please select all income sources from production that apply. Estimate values when necessary.
                    </div>

                    {/* Crop Production */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="crop-production">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Crop Production | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.CropProduction)
                                      .reduce((subTotal, li) => {
                                        return subTotal + ((li.productionPurchase?.netTotalAmount ?? 0) + (li.productionSale?.totalAmount ?? 0))
                                      }, 0))}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.CropProduction)}
                                  onChange={(event) => this.setCashFlowIncomeType(CashFlowIncomeType.CropProduction, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="crop-production" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.CropProduction)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'crop-production'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.CropProduction) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.map((li, i) => {
                                  return (
                                    <>
                                      {li.incomeType === CashFlowIncomeType.CropProduction &&
                                        <>
                                          <div style={{ marginLeft: 15, marginRight: 15 }}>
                                            <h3>
                                              {`Income Item #${i + 1}`}
                                              <span>
                                                <FontAwesomeIcon icon={'trash'} title={'Remove income item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowIncomeType(CashFlowIncomeType.CropProduction, i)} />
                                              </span>
                                            </h3>
                                            <h5>Crop Production</h5>
                                            <>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-description-${i}`}>Description*</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter crop type (corn, soybeans, etc)"
                                                    value={li.description}
                                                    onChange={(event) => this.setCashFlowLineItemDescription(event.target.value, i, `crop-production-description-${i}`)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-location-${i}`}>Location</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter general location where produced"
                                                    value={li.location}
                                                    onChange={(event) => this.setCashFlowLineItemLocation(event.target.value, i, `crop-production-location-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-uom-${i}`}>Unit of Measure*</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Example: Bushels, Tons, etc"
                                                    value={li.productionIncome?.unitOfMeasure}
                                                    onChange={(event) => this.setCashFlowProductionUnitOfMeasure(event.target.value, i, `crop-production-uom-${i}`)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-acres-${i}`}>Number of Acres*</Form.Label>
                                                  <NumericFormat
                                                    prefix=""
                                                    placeholder="Enter the number of acres planned or actually produced"
                                                    decimalScale={2}
                                                    thousandSeparator
                                                    value={li.productionIncome?.acres}
                                                    onValueChange={(values) => this.setCashFlowProductionIncomeAcres(values?.floatValue ?? 0, i, `crop-production-acres-${i}`, `crop-production-number-of-units-${i}`)}
                                                    className="form-control"
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-yield-${i}`}>Yield Per Acre*</Form.Label>
                                                  <NumericFormat
                                                    prefix=""
                                                    placeholder="Enter the projected or actual yield per acre"
                                                    decimalScale={2}
                                                    thousandSeparator
                                                    value={li.productionIncome?.yield}
                                                    onValueChange={(values) => this.setCashFlowProductionIncomeYield(values?.floatValue ?? 0, i, `crop-production-yield-${i}`, `crop-production-number-of-units-${i}`)}
                                                    className="form-control"
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-number-of-units-${i}`}>Number of Units Produced*</Form.Label>
                                                  <NumericFormat
                                                    prefix=""
                                                    thousandSeparator
                                                    disabled={true}
                                                    placeholder="Enter number of units produced"
                                                    value={li.productionIncome?.numberOfUnits}
                                                    className="form-control"
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-percentage-share-${i}`}>Ownership Percentage*</Form.Label>
                                                  <NumericFormat
                                                    value={li.productionIncome?.percentageOwned}
                                                    placeholder="Enter the share percent of ownership"
                                                    className="form-control"
                                                    thousandSeparator
                                                    suffix="%"
                                                    onValueChange={(values) => this.setCashFlowProductionIncomeSharedPercentage(i, `crop-production-percentage-share-${i}`, values.floatValue)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-percentage-my-share-${i}`}>My Share Of Units</Form.Label>
                                                  <NumericFormat
                                                    value={li.productionIncome?.shareOfUnits}
                                                    placeholder="Enter the share percent of ownership"
                                                    className="form-control"
                                                    thousandSeparator
                                                    decimalScale={0}
                                                    disabled={true} />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`crop-production-farm-use-${i}`}>Number of units retained for farm use*</Form.Label>
                                                  <NumericFormat
                                                    value={li.productionIncome?.amountFarmUse}
                                                    placeholder="Enter unit amount retained for use on farm"
                                                    className="form-control"
                                                    thousandSeparator
                                                    onValueChange={(values) => this.setCashFlowProductionIncomeAmountForFarmUse(i, `crop-production-farm-use-${i}`, values.floatValue)}
                                                    disabled={(li.productionIncome?.shareOfUnits ?? 0) <= 0}
                                                  />
                                                </Form.Group>
                                              </Row>
                                            </>

                                            <>
                                              <h5>Crop Sales</h5>
                                              <div style={{ fontSize: 14, paddingLeft: 5 }}>Sales are calculated based on the number of units <b>NOT</b> being retained for farm use.</div>
                                              {(li.productionIncome?.amountFarmUse != undefined && (li.productionIncome?.amountFarmUse < (li.productionIncome?.shareOfUnits ?? 0)))
                                                ?
                                                <>
                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`crop-sale-number-of-units-${i}`}>Number of Units Selling</Form.Label>
                                                      <NumericFormat
                                                        value={li.productionSale?.numberOfUnits}
                                                        placeholder="Enter the number of units to be sold"
                                                        className="form-control"
                                                        thousandSeparator
                                                        decimalScale={0}
                                                        onValueChange={(values) => this.setCashFlowProductionSaleUnits(i, `crop-sale-number-of-units-${i}`, `crop-sale-total-amount-${i}`, values.floatValue)}
                                                        disabled={true}
                                                      />
                                                    </Form.Group>
                                                  </Row>

                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`crop-sale-dollar-per-units-${i}`}>Dollar Per Unit</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        placeholder="Enter the price per unit for each crop to be sold"
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        value={li.productionSale?.pricePerUnit}
                                                        onValueChange={(values) => this.setCashFlowProductionSalePricePerUnit((values?.floatValue ?? 0), i, `crop-sale-dollar-per-units-${i}`, `crop-sale-total-amount-${i}`)}
                                                        className="form-control"
                                                        disabled={(li.productionSale?.numberOfUnits ?? 0) === 0}
                                                      />
                                                    </Form.Group>
                                                  </Row>

                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`crop-sale-total-amount-${i}`}>Total Amount of Sales</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        disabled={true}
                                                        thousandSeparator
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        placeholder="Enter the total amount for each crop to be sold or sold"
                                                        value={li.productionSale?.totalAmount}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>
                                                  </Row>
                                                </>
                                                :
                                                <>
                                                  <div style={{ fontSize: 14, paddingLeft: 5, marginTop: 5 }}>
                                                    There is currently nothing to sell because there is either not enough information provided above, or all units produced are being retained for farm use.
                                                  </div>
                                                </>
                                              }
                                            </>
                                          </div>
                                        </>
                                      }
                                    </>
                                  )
                                })
                                }

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Crop Production Item"
                                    onClick={() => { this.addCashFlowIncomeLineItem(CashFlowIncomeType.CropProduction) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {/* Livestock and Poultry Raised */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="livestock-and-poultry-raised">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Livestock & Poultry - Raised | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.LivestockAndPoultryRaised)
                                      .reduce((subTotal, li) => {
                                        return subTotal + ((li.productionPurchase?.netTotalAmount ?? 0) + (li.productionSale?.totalAmount ?? 0))
                                      }, 0))}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockAndPoultryRaised)}
                                  onChange={(event) => this.setCashFlowIncomeType(CashFlowIncomeType.LivestockAndPoultryRaised, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="livestock-and-poultry-raised" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockAndPoultryRaised)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'livestock-and-poultry-raised'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockAndPoultryRaised) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.map((li, i) => {
                                  return (
                                    <>
                                      {li.incomeType === CashFlowIncomeType.LivestockAndPoultryRaised &&
                                        <>
                                          <div style={{ marginLeft: 15, marginRight: 15 }}>
                                            <h3>
                                              {`Income Item #${i + 1}`}
                                              <span>
                                                <FontAwesomeIcon icon={'trash'} title={'Remove income item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowIncomeType(CashFlowIncomeType.LivestockAndPoultryRaised, i)} />
                                              </span>
                                            </h3>

                                            <h5>Livestock & Poultry Raised</h5>
                                            <>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-description-${i}`}>
                                                    {<>
                                                      <div>Description*</div>
                                                      <div style={{ fontSize: 12, fontStyle: 'italic' }}>Stocker Cattle, Finishing Pigs, Broiler Chickens, etc</div>
                                                    </>}
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter description"
                                                    value={li.description}
                                                    onChange={(event) => this.setCashFlowLineItemDescription(event.target.value, i, `livestock-poultry-raised-description-${i}`)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-type-${i}`}>
                                                    {<>
                                                      <div>Type*</div>
                                                      <div style={{ fontSize: 12, fontStyle: 'italic' }}>Steer, Heifer, Cull Cow, Hen, Barrow, etc</div>
                                                    </>}
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter type"
                                                    value={li.type}
                                                    onChange={(event) => this.setCashFlowLineItemType(event.target.value, i, `livestock-poultry-raised-type-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-location-${i}`}>Location</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter general location where produced"
                                                    value={li.location}
                                                    onChange={(event) => this.setCashFlowLineItemLocation(event.target.value, i, `livestock-poultry-raised-location-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>
                                            </>

                                            <h5>Livestock & Poultry Raised Sales</h5>
                                            <>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-sale-number-of-units-${i}`}>Number of Units Selling*</Form.Label>
                                                  <NumericFormat
                                                    value={li.productionSale?.numberOfUnits}
                                                    placeholder="Enter the number of units of livestock to be sold"
                                                    className="form-control"
                                                    thousandSeparator
                                                    onValueChange={(values) => this.setCashFlowProductionSaleUnits(i, `livestock-poultry-raised-sale-number-of-units-${i}`, `livestock-poultry-raised-sale-total-amount-${i}`, values.floatValue)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-sale-weight-${i}`}>Sales Weight Amount (Per Unit)*</Form.Label>
                                                  <NumericFormat
                                                    value={li.productionSale?.weightPerUnit}
                                                    placeholder="Enter the average weight per unit of livestock to be sold"
                                                    className="form-control"
                                                    thousandSeparator
                                                    onValueChange={(values) => this.setCashFlowProductionSaleWeight(i, `livestock-poultry-raised-sale-weight-${i}`, `livestock-poultry-raised-sale-total-amount-${i}`, values.floatValue)}
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-sale-weight-${i}`}>Total Sales Weight*</Form.Label>
                                                  <NumericFormat
                                                    value={(li.productionSale?.weightPerUnit ?? 0) * (li.productionSale?.numberOfUnits ?? 0)}
                                                    placeholder="Enter the average weight per unit of livestock to be sold"
                                                    className="form-control"
                                                    thousandSeparator
                                                    decimalScale={0}
                                                    disabled={true}
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-percentage-share-${i}`}>Ownership Percentage*</Form.Label>
                                                  <NumericFormat
                                                    value={li.productionSale?.percentageOwned}
                                                    placeholder="Enter the share percent of ownership"
                                                    className="form-control"
                                                    thousandSeparator
                                                    suffix="%"
                                                    onValueChange={(values) => this.setCashFlowProductionSaleSharedPercentage(i, `livestock-poultry-raised-percentage-share-${i}`, `livestock-poultry-raised-sale-total-amount-${i}`, values.floatValue)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-percentage-my-share-${i}`}>My Sales Weight</Form.Label>
                                                  <NumericFormat
                                                    value={((li.productionSale?.weightPerUnit ?? 0) * (li.productionSale?.numberOfUnits ?? 0)) * ((li.productionSale?.percentageOwned ?? 100) / 100)}
                                                    className="form-control"
                                                    thousandSeparator
                                                    decimalScale={0}
                                                    disabled={true} />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-sale-dollar-per-units-${i}`}>Sale $ Per Lb*</Form.Label>
                                                  <NumericFormat
                                                    prefix="$"
                                                    placeholder="Enter the dollar per pound per unit for each livestock to be sold"
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator
                                                    value={li.productionSale?.pricePerUnit}
                                                    onValueChange={(values) => this.setCashFlowProductionSalePricePerUnit(values?.floatValue ?? 0, i, `livestock-poultry-raised-sale-dollar-per-units-${i}`, `livestock-raised-poultry-sale-total-amount-${i}`)}
                                                    className="form-control"
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-raised-sale-total-amount-${i}`}>Total Amount of Sales*</Form.Label>
                                                  <NumericFormat
                                                    prefix="$"
                                                    disabled={true}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator
                                                    placeholder="Enter the total amount for each livestock to be sold"
                                                    value={li.productionSale?.totalAmount}
                                                    className="form-control"
                                                  />
                                                </Form.Group>
                                              </Row>
                                            </>

                                          </div>
                                        </>
                                      }
                                    </>
                                  )
                                })
                                }

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Livestock and Poultry Raised Item"
                                    onClick={() => { this.addCashFlowIncomeLineItem(CashFlowIncomeType.LivestockAndPoultryRaised) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {/* Livestock and Poultry Purchases and Sales */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="livestock-and-poultry-purchased">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Livestock & Poultry - Purchased & Sold | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.LivestockAndPoultryPurchaseSale)
                                      .reduce((subTotal, li) => {
                                        return subTotal + ((li.productionPurchase?.netTotalAmount ?? 0) + (li.productionSale?.totalAmount ?? 0))
                                      }, 0))}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockAndPoultryPurchaseSale)}
                                  onChange={(event) => this.setCashFlowIncomeType(CashFlowIncomeType.LivestockAndPoultryPurchaseSale, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="livestock-and-poultry-purchased" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockAndPoultryPurchaseSale)}></AccordionToggle>
                                </div>
                              </Form.Group>

                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'livestock-and-poultry-purchased'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockAndPoultryPurchaseSale) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.map((li, i) => {
                                  return (
                                    <>
                                      {li.incomeType === CashFlowIncomeType.LivestockAndPoultryPurchaseSale &&
                                        <>
                                          <div style={{ marginLeft: 15, marginRight: 15 }}>
                                            <h3>
                                              {`Income Item #${i + 1}`}
                                              <span>
                                                <FontAwesomeIcon icon={'trash'} title={'Remove income item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowIncomeType(CashFlowIncomeType.LivestockAndPoultryPurchaseSale, i)} />
                                              </span>
                                            </h3>

                                            <h5>Livestock & Poultry</h5>
                                            <>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-purchase-description-${i}`}>
                                                    {<>
                                                      <div>Description*</div>
                                                      <div style={{ fontSize: 12, fontStyle: 'italic' }}>Stocker Cattle, Finishing Pigs, Broiler Chickens, etc</div>
                                                    </>}
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter description"
                                                    value={li.description}
                                                    onChange={(event) => this.setCashFlowLineItemDescription(event.target.value, i, `livestock-poultry-purchase-description-${i}`)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-purchase-type-${i}`}>
                                                    {<>
                                                      <div>Type*</div>
                                                      <div style={{ fontSize: 12, fontStyle: 'italic' }}>Steer, Heifer, Cull Cow, Hen, Barrow, etc</div>
                                                    </>}
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter livestock/poultry type"
                                                    value={li.type}
                                                    onChange={(event) => this.setCashFlowLineItemType(event.target.value, i, `livestock-poultry-purchase-type-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-purchase-location-${i}`}>Location</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter general location where produced"
                                                    value={li.location}
                                                    onChange={(event) => this.setCashFlowLineItemLocation(event.target.value, i, `livestock-poultry-purchase-location-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>
                                            </>

                                            {/* Purchase/Sale Units and Checkboxes */}
                                            <>
                                              <Row>
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`livestock-poultry-purchase-number-of-units-${i}`}>Number of Units Purchased And/Or Sold*</Form.Label>
                                                  <NumericFormat
                                                    value={li.productionPurchase?.numberOfUnits}
                                                    placeholder="Enter number of units purchased/sold"
                                                    className="form-control"
                                                    thousandSeparator
                                                    onValueChange={(values) => this.setCashFlowProductionPurchaseUnits(i, `livestock-poultry-purchase-number-of-units-${i}`, `livestock-poultry-purchase-total-amount-${i}`, `livestock-poultry-sale-net-amount-${i}`, values.floatValue)}
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row>
                                                <Form.Group as={Col}>
                                                  <Form.Check type="checkbox"
                                                    className={'custom-checkbox'}
                                                    style={{ fontSize: 16 }}
                                                    label={<span>These units will be purchased and sold in this production cycle</span>}
                                                    checked={li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseAndSale}
                                                    onChange={(event) => this.setCashFlowLineItemPurchaseSaleType(CashFlowLineItemPurchaseSaleType.PurchaseAndSale, i)}
                                                  >
                                                  </Form.Check>
                                                </Form.Group>
                                              </Row>

                                              <Row>
                                                <Form.Group as={Col}>
                                                  <Form.Check type="checkbox"
                                                    className={'custom-checkbox'}
                                                    style={{ fontSize: 16 }}
                                                    label={<span>These units will be purchased but <u><i>not</i></u> sold in this production cycle</span>}
                                                    checked={li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseOnly}
                                                    onChange={(event) => this.setCashFlowLineItemPurchaseSaleType(CashFlowLineItemPurchaseSaleType.PurchaseOnly, i)}
                                                  >
                                                  </Form.Check>
                                                </Form.Group>
                                              </Row>

                                              <Row>
                                                <Form.Group as={Col}>
                                                  <Form.Check type="checkbox"
                                                    className={'custom-checkbox'}
                                                    style={{ fontSize: 16 }}
                                                    label={<span>These units were purchased in a previous production cycle to sell in this production cycle</span>}
                                                    checked={li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.SaleOnly}
                                                    onChange={(event) => this.setCashFlowLineItemPurchaseSaleType(CashFlowLineItemPurchaseSaleType.SaleOnly, i)}
                                                  >
                                                  </Form.Check>
                                                </Form.Group>
                                              </Row>
                                            </>

                                            {(li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseAndSale || li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseOnly) &&
                                              <>
                                                <h5>Purchase Information</h5>
                                                <>
                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-purchase-weight-${i}`}>Purchase Weight (Per Unit)*</Form.Label>
                                                      <NumericFormat
                                                        value={li.productionPurchase?.purchaseWeightPerUnit}
                                                        placeholder="Enter the average weight per unit of livestock to be purchased"
                                                        className="form-control"
                                                        thousandSeparator
                                                        onValueChange={(values) => this.setCashFlowProductionPurchaseWeight(i, `livestock-poultry-purchase-weight-${i}`, `livestock-poultry-purchase-total-amount-${i}`, `livestock-poultry-sale-net-amount-${i}`, values.floatValue)}
                                                      />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-total-purchase-weight-${i}`}>Total Purchase Weight*</Form.Label>
                                                      <NumericFormat
                                                        value={(li.productionPurchase?.purchaseWeightPerUnit ?? 0) * (li.productionPurchase?.numberOfUnits ?? 0)}
                                                        placeholder="Enter the average weight per unit of livestock to be purchased"
                                                        className="form-control"
                                                        thousandSeparator
                                                        decimalScale={0}
                                                        disabled={true}
                                                      />
                                                    </Form.Group>
                                                  </Row>

                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-purchase-dollar-per-units-${i}`}>Purchase $ Per Lb*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        placeholder="Enter the dollar per unit for each type of livestock to be purchased"
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        value={li.productionPurchase?.purchaseDollarPerUnit}
                                                        onValueChange={(values) => this.setCashFlowProductionPurchaseDollarPerUnit(values?.floatValue ?? 0, i, `livestock-poultry-purchase-dollar-per-units-${i}`, `livestock-poultry-purchase-total-amount-${i}`, `livestock-poultry-sale-net-amount-${i}`)}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-purchase-total-amount-${i}`}>Total Amount of Purchase*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        disabled={true}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        placeholder="Enter the total amount for each type of livestock to be purchased"
                                                        value={li.productionPurchase?.purchaseTotalAmount}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>
                                                  </Row>
                                                </>
                                              </>
                                            }

                                            {(li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseAndSale || li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.SaleOnly) &&
                                              <>
                                                <h5>Sale Information</h5>
                                                <>
                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-sale-weight-${i}`}>Sale Weight Amount (Per Unit)</Form.Label>
                                                      <NumericFormat
                                                        value={li.productionPurchase?.saleWeightPerUnit}
                                                        placeholder="Enter the average weight per unit of livestock to be sold"
                                                        className="form-control"
                                                        thousandSeparator
                                                        onValueChange={(values) => this.setCashFlowProductionPurchaseSaleWeight(i, `livestock-poultry-sale-weight-${i}`, `livestock-poultry-sale-total-amount-${i}`, `livestock-poultry-sale-net-amount-${i}`, values.floatValue)}
                                                      />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-total-sale-weight-${i}`}>Total Sale Weight*</Form.Label>
                                                      <NumericFormat
                                                        value={(li.productionPurchase?.numberOfUnits ?? 0) * (li.productionPurchase?.saleWeightPerUnit ?? 0)}
                                                        className="form-control"
                                                        thousandSeparator
                                                        decimalScale={0}
                                                        disabled={true}
                                                      />
                                                    </Form.Group>
                                                  </Row>

                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-sale-dollar-per-units-${i}`}>Sale $ Per Lb*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        placeholder="Enter the dollar per pound per unit for each livestock to be sold"
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        value={li.productionPurchase?.saleDollarPerUnit}
                                                        onValueChange={(values) => this.setCashFlowProductionPurchaseSaleDollarPerUnit(values?.floatValue ?? 0, i, `livestock-poultry-sale-dollar-per-units-${i}`, `livestock-poultry-sale-total-amount-${i}`, `livestock-poultry-sale-net-amount-${i}`)}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-sale-total-amount-${i}`}>Total Amount of Sales*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        disabled={true}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        value={li.productionPurchase?.saleTotalAmount}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>
                                                  </Row>

                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`livestock-poultry-sale-net-amount-${i}`}>Net Amount of Sales*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        disabled={true}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        placeholder="Enter the total amount for each livestock to be sold"
                                                        value={li.productionPurchase?.netTotalAmount}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>
                                                  </Row>
                                                </>
                                              </>
                                            }
                                          </div>
                                        </>
                                      }
                                    </>
                                  )
                                })
                                }

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Livestock and Poultry Purchase/Sale Item"
                                    onClick={() => { this.addCashFlowIncomeLineItem(CashFlowIncomeType.LivestockAndPoultryPurchaseSale) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {/* Dairy Livestock Production and Sales */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="dairy-livestock-production">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Dairy Market Livestock - Purchased & Sold | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.DairyLivestock)
                                      .reduce((subTotal, li) => {
                                        return subTotal + ((li.productionPurchase?.netTotalAmount ?? 0) + (li.productionSale?.totalAmount ?? 0))
                                      }, 0))}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.DairyLivestock)}
                                  onChange={(event) => this.setCashFlowIncomeType(CashFlowIncomeType.DairyLivestock, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="dairy-livestock-production" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.DairyLivestock)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'dairy-livestock-production'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.DairyLivestock) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.map((li, i) => {
                                  return (
                                    <>
                                      {li.incomeType === CashFlowIncomeType.DairyLivestock &&
                                        <>
                                          <div style={{ marginLeft: 15, marginRight: 15 }}>
                                            <h3>
                                              {`Production Item #${i + 1}`}
                                              <span>
                                                <FontAwesomeIcon icon={'trash'} title={'Remove production item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowIncomeType(CashFlowIncomeType.DairyLivestock, i)} />
                                              </span>
                                            </h3>

                                            <h5>Dairy Market Livestock</h5>
                                            <>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`dairy-livestock-production-description-${i}`}>
                                                    {<>
                                                      <div>Description*</div>
                                                      <div style={{ fontSize: 12, fontStyle: 'italic' }}>Dairy Cattle, Dairy Goats, Dairy Sheep, etc</div>
                                                    </>}
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter description"
                                                    value={li.description}
                                                    onChange={(event) => this.setCashFlowLineItemDescription(event.target.value, i, `dairy-livestock-production-description-${i}`)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`dairy-livestock-production-type-${i}`}>
                                                    {<>
                                                      <div>Breed*</div>
                                                      <div style={{ fontSize: 12, fontStyle: 'italic' }}>Holstein, Jersey, Nubian, East Friesian, etc</div>
                                                    </>}
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter dairy livestock breed"
                                                    value={li.type}
                                                    onChange={(event) => this.setCashFlowLineItemType(event.target.value, i, `dairy-livestock-production-type-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`dairy-livestock-production-location-${i}`}>Location</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter general location"
                                                    value={li.location}
                                                    onChange={(event) => this.setCashFlowLineItemLocation(event.target.value, i, `dairy-livestock-production-location-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>
                                            </>

                                            {/* Purchase/Sale Units and Checkboxes */}
                                            <>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`dairy-purchase-number-of-units-${i}`}>Number of Head Purchased And/Or Sold*</Form.Label>
                                                  <NumericFormat
                                                    value={li.productionPurchase?.numberOfUnits}
                                                    placeholder="Enter number of head purchased"
                                                    className="form-control"
                                                    thousandSeparator
                                                    onValueChange={(values) => this.setCashFlowProductionPurchaseUnits(i, `dairy-purchase-number-of-units-${i}`, `dairy-purchase-total-amount-${i}`, `dairy-sale-net-amount-${i}`, values.floatValue)}
                                                  />
                                                </Form.Group>
                                              </Row>

                                              <Row>
                                                <Form.Group as={Col}>
                                                  <Form.Check type="checkbox"
                                                    className={'custom-checkbox'}
                                                    style={{ fontSize: 16 }}
                                                    label={<span>These units will be purchased and sold in this production cycle</span>}
                                                    checked={li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseAndSale}
                                                    onChange={(event) => this.setCashFlowLineItemPurchaseSaleType(CashFlowLineItemPurchaseSaleType.PurchaseAndSale, i)}
                                                  >
                                                  </Form.Check>
                                                </Form.Group>
                                              </Row>

                                              <Row>
                                                <Form.Group as={Col}>
                                                  <Form.Check type="checkbox"
                                                    className={'custom-checkbox'}
                                                    style={{ fontSize: 16 }}
                                                    label={<span>These units will be purchased but <u><i>not</i></u> sold in this production cycle</span>}
                                                    checked={li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseOnly}
                                                    onChange={(event) => this.setCashFlowLineItemPurchaseSaleType(CashFlowLineItemPurchaseSaleType.PurchaseOnly, i)}
                                                  >
                                                  </Form.Check>
                                                </Form.Group>
                                              </Row>

                                              <Row>
                                                <Form.Group as={Col}>
                                                  <Form.Check type="checkbox"
                                                    className={'custom-checkbox'}
                                                    style={{ fontSize: 16 }}
                                                    label={<span>These units were purchased in a previous production cycle to sell in this production cycle</span>}
                                                    checked={li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.SaleOnly}
                                                    onChange={(event) => this.setCashFlowLineItemPurchaseSaleType(CashFlowLineItemPurchaseSaleType.SaleOnly, i)}
                                                  >
                                                  </Form.Check>
                                                </Form.Group>
                                              </Row>
                                            </>

                                            {(li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseAndSale || li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseOnly) &&
                                              <>
                                                <h5>Purchase Information</h5>
                                                <>
                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-purchase-weight-${i}`}>Purchase Weight (Per Head)*</Form.Label>
                                                      <NumericFormat
                                                        value={li.productionPurchase?.purchaseWeightPerUnit}
                                                        placeholder="Enter the average weight per head of dairy livestock to be purchased"
                                                        className="form-control"
                                                        thousandSeparator
                                                        onValueChange={(values) => this.setCashFlowProductionPurchaseWeight(i, `dairy-purchase-weight-${i}`, `dairy-purchase-total-amount-${i}`, `dairy-sale-net-amount-${i}`, values.floatValue)}
                                                      />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-total-purchase-weight-${i}`}>Total Purchase Weight*</Form.Label>
                                                      <NumericFormat
                                                        value={(li.productionPurchase?.purchaseWeightPerUnit ?? 0) * (li.productionPurchase?.numberOfUnits ?? 0)}
                                                        className="form-control"
                                                        thousandSeparator
                                                        decimalScale={0}
                                                        disabled={true}
                                                      />
                                                    </Form.Group>
                                                  </Row>

                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-purchase-dollar-per-units-${i}`}>Purchase $ Per Lb*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        placeholder="Enter the dollar per head for each dairy livestock type to be purchased"
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        value={li.productionPurchase?.purchaseDollarPerUnit}
                                                        onValueChange={(values) => this.setCashFlowProductionPurchaseDollarPerUnit(values?.floatValue ?? 0, i, `dairy-purchase-dollar-per-units-${i}`, `dairy-purchase-total-amount-${i}`, `dairy-sale-net-amount-${i}`)}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-purchase-total-amount-${i}`}>Total Amount of Purchase*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        disabled={true}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        placeholder="Enter the total amount for each type of dairy livestock to be purchased"
                                                        value={li.productionPurchase?.purchaseTotalAmount}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>
                                                  </Row>
                                                </>
                                              </>
                                            }

                                            {(li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.PurchaseAndSale || li.purchaseSaleType === CashFlowLineItemPurchaseSaleType.SaleOnly) &&
                                              <>
                                                <h5>Sale Information</h5>
                                                <>
                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-sale-weight-${i}`}>Sale Weight Amount (Per Head)</Form.Label>
                                                      <NumericFormat
                                                        value={li.productionSale?.weightPerUnit}
                                                        placeholder="Enter the average weight per unit of dairy livestock to be sold"
                                                        className="form-control"
                                                        thousandSeparator
                                                        onValueChange={(values) => this.setCashFlowProductionPurchaseSaleWeight(i, `dairy-sale-weight-${i}`, `dairy-sale-total-amount-${i}`, `dairy-sale-net-amount-${i}`, values.floatValue)}
                                                      />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-total-sale-weight-${i}`}>Total Sale Weight*</Form.Label>
                                                      <NumericFormat
                                                        value={(li.productionPurchase?.numberOfUnits ?? 0) * (li.productionPurchase?.saleWeightPerUnit ?? 0)}
                                                        className="form-control"
                                                        thousandSeparator
                                                        decimalScale={0}
                                                        disabled={true}
                                                      />
                                                    </Form.Group>
                                                  </Row>

                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-sale-dollar-per-units-${i}`}>Sale $ Per Lb*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        placeholder="Enter the dollar per head for each type dairy livestock to be sold"
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        value={li.productionPurchase?.saleDollarPerUnit}
                                                        onValueChange={(values) => this.setCashFlowProductionPurchaseSaleDollarPerUnit(values?.floatValue ?? 0, i, `dairy-sale-dollar-per-units-${i}`, `dairy-sale-total-amount-${i}`, `dairy-sale-net-amount-${i}`)}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>

                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-sale-total-amount-${i}`}>Total Amount of Sales*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        disabled={true}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator
                                                        value={li.productionPurchase?.saleTotalAmount}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>
                                                  </Row>

                                                  <Row className="mb-3">
                                                    <Form.Group as={Col}>
                                                      <Form.Label id={`dairy-sale-net-amount-${i}`}>Net Amount of Sales*</Form.Label>
                                                      <NumericFormat
                                                        prefix="$"
                                                        disabled={true}
                                                        decimalScale={2}
                                                        thousandSeparator
                                                        placeholder="Enter the total amount for each livestock to be sold"
                                                        value={li.productionPurchase?.netTotalAmount ?? 0}
                                                        className="form-control"
                                                      />
                                                    </Form.Group>
                                                  </Row>
                                                </>
                                              </>
                                            }
                                          </div>
                                        </>
                                      }
                                    </>
                                  )
                                })
                                }

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Dairy Livestock Item"
                                    onClick={() => { this.addCashFlowIncomeLineItem(CashFlowIncomeType.DairyLivestock) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {/* Milk Production */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="milk-production">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Milk Production | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.MilkProduction)
                                      .reduce((subTotal, li) => {
                                        return subTotal + ((li.productionPurchase?.netTotalAmount ?? 0) + (li.productionSale?.totalAmount ?? 0))
                                      }, 0))}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.MilkProduction)}
                                  onChange={(event) => this.setCashFlowIncomeType(CashFlowIncomeType.MilkProduction, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="milk-production" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.MilkProduction)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'milk-production'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.MilkProduction) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.map((li, i) => {
                                  return (
                                    <>
                                      {li.incomeType === CashFlowIncomeType.MilkProduction &&
                                        <>
                                          <div style={{ marginLeft: 15, marginRight: 15 }}>
                                            <h3>
                                              {`Income Item #${i + 1}`}
                                              <span>
                                                <FontAwesomeIcon icon={'trash'} title={'Remove income item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowIncomeType(CashFlowIncomeType.MilkProduction, i)} />
                                              </span>
                                            </h3>

                                            <h5>Milk Production Information</h5>
                                            <>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`milk-production-description-${i}`}>Description*</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter description"
                                                    value={li.description}
                                                    onChange={(event) => this.setCashFlowLineItemDescription(event.target.value, i, `milk-production-description-${i}`)}
                                                  />
                                                </Form.Group>

                                                <Form.Group as={Col}>
                                                  <Form.Label id={`milk-production-type-${i}`}>Breed*</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter dairy livestock breed"
                                                    value={li.type}
                                                    onChange={(event) => this.setCashFlowLineItemType(event.target.value, i, `milk-production-type-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>
                                              <Row className="mb-3">
                                                <Form.Group as={Col}>
                                                  <Form.Label id={`milk-production-location-${i}`}>Location</Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter general location"
                                                    value={li.location}
                                                    onChange={(event) => this.setCashFlowLineItemLocation(event.target.value, i, `milk-production-location-${i}`)}
                                                  />
                                                </Form.Group>
                                              </Row>
                                            </>

                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`milk-sale-number-of-units-${i}`}>Number of Head*</Form.Label>
                                                <NumericFormat
                                                  value={li.productionSale?.numberOfHead}
                                                  placeholder="Enter the number of livestock to be produced or in production"
                                                  className="form-control"
                                                  thousandSeparator
                                                  onValueChange={(values) => this.setCashFlowProductionSaleHead(i, `milk-sale-production-per-head-${i}`, `milk-sale-total-production-${i}`, values.floatValue)}
                                                />
                                              </Form.Group>
                                            </Row>

                                            <Row>
                                              <Form.Group as={Col}>
                                                <Form.Label id={`milk-sale-production-per-head-${i}`}>Production Lbs Per Head/Per Year*</Form.Label>
                                                <NumericFormat
                                                  value={li.productionSale?.productionPerHead}
                                                  placeholder="Enter the production amount per head per year for the operating year"
                                                  className="form-control"
                                                  thousandSeparator
                                                  onValueChange={(values) => this.setCashFlowProductionSaleProductionPerHead(i, `milk-sale-production-per-head-${i}`, `milk-sale-total-production-${i}`, values.floatValue)}
                                                />
                                              </Form.Group>
                                            </Row>

                                            <Row>
                                              <Form.Group as={Col}>
                                                <Form.Label id={`milk-sale-total-production-${i}`}>Total Production*</Form.Label>
                                                <NumericFormat
                                                  value={li.productionSale?.totalProduction}
                                                  placeholder="Enter the total production per year"
                                                  disabled={true}
                                                  decimalScale={2}
                                                  className="form-control"
                                                  thousandSeparator />
                                              </Form.Group>
                                            </Row>

                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`milk-sale-market-price-${i}`}>Market Price Per Unit *</Form.Label>
                                                <NumericFormat
                                                  prefix="$"
                                                  placeholder="Enter the current market price for the type of milk produced"
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  value={li.productionSale?.marketPrice}
                                                  onValueChange={(values) => this.setCashFlowProductionSaleMarketPrice(values?.floatValue ?? 0, i, `milk-sale-market-price-${i}`)}
                                                  className="form-control"
                                                />
                                              </Form.Group>

                                              <Form.Group as={Col}>
                                                <Form.Label id={`milk-sale-total-amount-${i}`}>Total Sales*</Form.Label>
                                                <NumericFormat
                                                  prefix="$"
                                                  disabled={true}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  thousandSeparator
                                                  placeholder="Enter the total annual sales"
                                                  value={li.productionSale?.totalAmount}
                                                  className="form-control"
                                                />
                                              </Form.Group>
                                            </Row>
                                          </div>
                                        </>
                                      }
                                    </>
                                  )
                                })
                                }
                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Milk Production Item"
                                    onClick={() => { this.addCashFlowIncomeLineItem(CashFlowIncomeType.MilkProduction) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {/* Livestock Product Sales */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="livestock-product-sale">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Farm Product Sales | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.incomeLineItems?.filter(li => li.incomeType === CashFlowIncomeType.LivestockProduct)
                                      .reduce((subTotal, li) => {
                                        return subTotal + ((li.productionPurchase?.netTotalAmount ?? 0) + (li.productionSale?.totalAmount ?? 0))
                                      }, 0))}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockProduct)}
                                  onChange={(event) => this.setCashFlowIncomeType(CashFlowIncomeType.LivestockProduct, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="livestock-product-sale" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockProduct)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'livestock-product-sale'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.incomeTypes?.includes(CashFlowIncomeType.LivestockProduct) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.incomeLineItems?.map((li, i) => {
                                  return (
                                    <>
                                      {li.incomeType === CashFlowIncomeType.LivestockProduct &&
                                        <>
                                          <div style={{ marginLeft: 15, marginRight: 15 }}>
                                            <h5>
                                              {`Income Item #${i + 1}`}
                                              <span>
                                                <FontAwesomeIcon icon={'trash'} title={'Remove income item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowIncomeType(CashFlowIncomeType.LivestockProduct, i)} />
                                              </span>
                                            </h5>
                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`livestock-product-sale-description-${i}`}>Description*</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter the type of livestock producing the commodity (Sheep, Goats, Poultry, etc)"
                                                  value={li.description}
                                                  onChange={(event) => this.setCashFlowLineItemDescription(event.target.value, i, `livestock-product-sale-description-${i}`)}
                                                />
                                              </Form.Group>
                                            </Row>

                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`livestock-product-sale-commodity-${i}`}>Commodity Type*</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter the type of commodity produced (Wool, Eggs, etc)"
                                                  value={li.productionSale?.commodityProduced}
                                                  onChange={(event) => this.setCashFlowProductionSaleCommodityProduced(event.target.value, i, `livestock-product-sale-commodity-${i}`)}
                                                />
                                              </Form.Group>
                                            </Row>
                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`livestock-product-sale-commodity-measure-${i}`}>Commodity Measure*</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter the unit for the commodity (Pounds of Wool, Dozens of Eggs, etc)"
                                                  value={li.productionSale?.commodityMeasure}
                                                  onChange={(event) => this.setCashFlowProductionSaleCommodityMeasure(event.target.value, i, `livestock-product-sale-commodity-measure-${i}`)}
                                                />
                                              </Form.Group>
                                            </Row>

                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`livestock-product-sale-number-of-units-${i}`}>Number of Units Selling*</Form.Label>
                                                <NumericFormat
                                                  value={li.productionSale?.numberOfUnits}
                                                  placeholder="Enter number of units to be sold"
                                                  className="form-control"
                                                  thousandSeparator
                                                  onValueChange={(values) => this.setCashFlowProductionSaleUnits(i, `livestock-product-sale-number-of-units-${i}`, `livestock-product-sale-total-amount-${i}`, values.floatValue,)}
                                                />
                                              </Form.Group>

                                              <Form.Group as={Col}>
                                                <Form.Label id={`livestock-product-sale-price-per-units-${i}`}>Price Per Unit*</Form.Label>
                                                <NumericFormat
                                                  prefix="$"
                                                  placeholder="Enter price per unit to be sold"
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  thousandSeparator
                                                  value={li.productionSale?.pricePerUnit}
                                                  onValueChange={(values) => this.setCashFlowProductionSalePricePerUnit(values?.floatValue ?? 0, i, `livestock-product-sale-price-per-units-${i}`, `livestock-product-sale-total-amount-${i}`)}
                                                  className="form-control"
                                                />
                                              </Form.Group>
                                            </Row>

                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`livestock-product-sale-total-amount-${i}`}>Total Amount of Sales*</Form.Label>
                                                <NumericFormat
                                                  prefix="$"
                                                  disabled={true}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  thousandSeparator
                                                  placeholder="Enter the total amount for livestock products to be sold"
                                                  value={li.productionSale?.totalAmount}
                                                  className="form-control"
                                                />
                                              </Form.Group>
                                            </Row>
                                          </div>
                                        </>
                                      }
                                    </>
                                  )
                                })
                                }

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Farm Product Item"
                                    onClick={() => { this.addCashFlowIncomeLineItem(CashFlowIncomeType.LivestockProduct) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    <Row>
                      <Col xs={10}>
                        <div style={{ lineHeight: 3, fontStyle: 'italic', fontWeight: 'bold' }}>
                          {
                            `Total Production Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.totalProductionIncome)}`
                          }
                        </div>
                      </Col>

                      <Col xs={2}>
                        {this.getNextButton('cash-flow-other-incomes', this.state.validAllCashFlowIncomeData)}
                      </Col>
                    </Row>
                  </>
                </Tab>

                <Tab eventKey="cash-flow-other-incomes"
                  title={this.getTabHTML('Production Plan - Other Incomes', 'cash-flow-other-income-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validCashFlowOtherIncomeData, 'cash-flow-other-income-tab')}>
                  <>
                    <div style={{ fontStyle: 'italic' }}>
                      Please select all sources that apply. Estimate values when necessary.
                    </div>

                    {/* Other Farm Income */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="other-farm-income">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Other Farm Income (Custom Hire Income, etc) | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalOtherFarmIncome)}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.OtherFarmIncome)}
                                  onChange={(event) => this.setCashFlowOtherIncomeType(CashFlowIncomeType.OtherFarmIncome, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="other-farm-income" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.OtherFarmIncome)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'other-farm-income'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.OtherFarmIncome) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.otherFarmIncome?.map((ofi, i) => {
                                  return (
                                    <>
                                      <div style={{ marginLeft: 15, marginRight: 15 }}>
                                        <h5>
                                          {`Other Farm Income Item #${i + 1}`}
                                          <span>
                                            <FontAwesomeIcon icon={'trash'} title={'Remove other income item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowOtherIncomeType(CashFlowIncomeType.OtherFarmIncome, i)} />
                                          </span>
                                        </h5>
                                        <Row className="mb-3">
                                          <Form.Group as={Col}>
                                            <Form.Label className="mb-3" id={`other-farm-income-type-${i}`}>Income Type*</Form.Label>
                                            <Form.Group className="mb-3" >
                                              <Form.Check type="checkbox" label={'Custom Hire Income'} checked={ofi.otherIncomeType === OtherFarmIncomeType.CustomHireIncome} onChange={(event) => this.setCashFlowOtherFarmIncomeType(OtherFarmIncomeType.CustomHireIncome, i, `other-farm-income-type-${i}`)} />
                                              <Form.Check type="checkbox" label={'Other (Ag Payments, Rent Received, Account Receivables, etc)'} checked={ofi.otherIncomeType === OtherFarmIncomeType.Other} onChange={(event) => this.setCashFlowOtherFarmIncomeType(OtherFarmIncomeType.Other, i, `other-farm-income-type-${i}`)} />
                                            </Form.Group>
                                          </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                          <Form.Group as={Col}>
                                            <Form.Label id={`other-farm-income-description-${i}`}>Description*</Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder="Describe the income source"
                                              value={ofi.description}
                                              onChange={(event) => this.setCashFlowOtherFarmIncomeDescription(event.target.value, i, `other-farm-income-description-${i}`)}
                                            />
                                          </Form.Group>

                                          <Form.Group as={Col}>
                                            <Form.Label id={`other-farm-income-amount-${i}`}>Amount*</Form.Label>
                                            <NumericFormat
                                              prefix="$"
                                              placeholder="Enter the income amount"
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator
                                              value={ofi.totalAmount}
                                              onValueChange={(values) => this.setCashFlowOtherFarmIncomeAmount(i, `other-farm-income-amount-${i}`, values?.floatValue ?? undefined)}
                                              className="form-control"
                                            />
                                          </Form.Group>
                                        </Row>
                                      </div>
                                    </>
                                  )
                                })
                                }

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Other Farm Income"
                                    onClick={() => { this.addCashFlowOtherIncomeItem(CashFlowIncomeType.OtherFarmIncome) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {/* Non-Farm Income*/}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="non-farm-income">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Non-Farm Income (Personal Income, Business Income, etc) | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalNonFarmIncome)}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.NonFarmIncome)}
                                  onChange={(event) => this.setCashFlowOtherIncomeType(CashFlowIncomeType.NonFarmIncome, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="non-farm-income" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.NonFarmIncome)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'non-farm-income'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.NonFarmIncome) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.nonFarmIncome?.map((nfi, i) => {
                                  return (
                                    <>
                                      <div style={{ marginLeft: 15, marginRight: 15 }}>
                                        <h5>
                                          {`Non-Farm Income Item #${i + 1}`}
                                          <span>
                                            <FontAwesomeIcon icon={'trash'} title={'Remove non-farm income item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowOtherIncomeType(CashFlowIncomeType.NonFarmIncome, i)} />
                                          </span>
                                        </h5>
                                        <Row className="mb-3">
                                          <Form.Group as={Col}>
                                            <Form.Label className="mb-3" id={`non-farm-income-type-${i}`}>Income Type*</Form.Label>
                                            <Form.Group className="mb-3" >
                                              <Form.Check type="checkbox" label={'Personal Income'} checked={nfi.nonFarmIncomeType === NonFarmIncomeType.PersonalIncome} onChange={(event) => this.setCashFlowNonFarmIncomeType(NonFarmIncomeType.PersonalIncome, i, `non-farm-income-type-${i}`)} />
                                              <Form.Check type="checkbox" label={'Business Income'} checked={nfi.nonFarmIncomeType === NonFarmIncomeType.BusinessIncome} onChange={(event) => this.setCashFlowNonFarmIncomeType(NonFarmIncomeType.BusinessIncome, i, `non-farm-income-type-${i}`)} />
                                              <Form.Check type="checkbox" label={'Other (Specify)'} checked={nfi.nonFarmIncomeType === NonFarmIncomeType.Other} onChange={(event) => this.setCashFlowNonFarmIncomeType(NonFarmIncomeType.Other, i, `non-farm-income-type-${i}`)} />
                                            </Form.Group>
                                          </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                          <Form.Group as={Col}>
                                            <Form.Label id={`non-farm-income-description-${i}`}>Description*</Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder="Describe the income source"
                                              value={nfi.description}
                                              onChange={(event) => this.setCashFlowNonFarmIncomeDescription(event.target.value, i, `non-farm-income-description-${i}`)}
                                            />
                                          </Form.Group>
                                          <Form.Group as={Col}>
                                            <Form.Label id={`non-farm-income-amount-${i}`}>Amount*</Form.Label>
                                            <NumericFormat
                                              prefix="$"
                                              placeholder="Enter the income amount"
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator
                                              value={nfi.totalAmount}
                                              onValueChange={(values) => this.setCashFlowNonFarmIncomeAmount(i, `non-farm-income-amount-${i}`, values?.floatValue ?? undefined)}
                                              className="form-control"
                                            />
                                          </Form.Group>
                                        </Row>
                                      </div>
                                    </>
                                  )
                                })
                                }

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Non-Farm Income"
                                    onClick={() => { this.addCashFlowOtherIncomeItem(CashFlowIncomeType.NonFarmIncome) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {/* Capital Sales Income */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="capital-sale-income">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={
                                    `Capital Sales Income (Equipment Sales, Real Estate Sales, etc) | ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalCapitalSalesIncome)}`
                                  }
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.CapitalSaleIncome)}
                                  onChange={(event) => this.setCashFlowOtherIncomeType(CashFlowIncomeType.CapitalSaleIncome, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="capital-sale-income" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.CapitalSaleIncome)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>
                        <Accordion.Collapse eventKey={'capital-sale-income'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection?.otherIncomeTypes?.includes(CashFlowIncomeType.CapitalSaleIncome) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.incomeSection.capitalSalesIncome?.map((csi, i) => {
                                  return (
                                    <>
                                      <div style={{ marginLeft: 15, marginRight: 15 }}>
                                        <h5>
                                          {`Capital Sale Income Item #${i + 1}`}
                                          <span>
                                            <FontAwesomeIcon icon={'trash'} title={'Remove other income item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowOtherIncomeType(CashFlowIncomeType.CapitalSaleIncome, i)} />
                                          </span>
                                        </h5>
                                        <Row className="mb-3">
                                          <Form.Group as={Col}>
                                            <Form.Label className="mb-3" id={`capital-sale-income-type-${i}`}>Income Type*</Form.Label>
                                            <Form.Group className="mb-3" >
                                              <Form.Check type="checkbox" label={'Equipment'} checked={csi.capitalSalesIncomeType === CapitalSalesIncomeType.Equipment} onChange={(event) => this.setCashFlowCapitalSaleIncomeType(CapitalSalesIncomeType.Equipment, i, `capital-sale-income-type-${i}`)} />
                                              <Form.Check type="checkbox" label={'Real Estate'} checked={csi.capitalSalesIncomeType === CapitalSalesIncomeType.RealEstate} onChange={(event) => this.setCashFlowCapitalSaleIncomeType(CapitalSalesIncomeType.RealEstate, i, `capital-sale-income-type-${i}`)} />
                                              <Form.Check type="checkbox" label={'Other'} checked={csi.capitalSalesIncomeType === CapitalSalesIncomeType.Other} onChange={(event) => this.setCashFlowCapitalSaleIncomeType(CapitalSalesIncomeType.Other, i, `capital-sale-income-type-${i}`)} />
                                            </Form.Group>
                                          </Form.Group>
                                        </Row>

                                        <Row className="mb-3">
                                          <Form.Group as={Col}>
                                            <Form.Label id={`capital-sale-income-description-${i}`}>Description*</Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder="Describe the income source"
                                              value={csi.description}
                                              onChange={(event) => this.setCashFlowCapitalSaleIncomeDescription(event.target.value, i, `capital-sale-income-description-${i}`)}
                                            />
                                          </Form.Group>

                                          <Form.Group as={Col}>
                                            <Form.Label id={`capital-sale-income-amount-${i}`}>Amount*</Form.Label>
                                            <NumericFormat
                                              prefix="$"
                                              placeholder="Enter the income amount"
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator
                                              value={csi.totalAmount}
                                              onValueChange={(values) => this.setCashFlowCapitalSaleIncomeAmount(i, `capital-sale-income-amount-${i}`, values?.floatValue ?? undefined)}
                                              className="form-control"
                                            />
                                          </Form.Group>
                                        </Row>
                                      </div>
                                    </>
                                  )
                                })
                                }

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Capital Sale Income"
                                    onClick={() => { this.addCashFlowOtherIncomeItem(CashFlowIncomeType.CapitalSaleIncome) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {this.getNextButton('cash-flow-income-summary', this.state.validCashFlowOtherIncomeData)}
                  </>
                </Tab>

                <Tab eventKey="cash-flow-income-summary"
                  title={this.getTabHTML('Production Plan - Income Summary', 'cash-flow-income-summary-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit ? '' : 'd-none'}>
                  <>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Production Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalProductionIncome)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Other Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalOtherFarmIncome)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Non-Farm Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalNonFarmIncome)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Capital Sale Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalCapitalSalesIncome)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label style={{ fontWeight: 'bold' }}>
                          {
                            `Grand Total Income: ${loanApplicationUtility.BuildCurrencyAmount((this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalProductionIncome ?? 0)
                              + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalOtherFarmIncome ?? 0)
                              + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalNonFarmIncome ?? 0)
                              + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalCapitalSalesIncome ?? 0))}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    {this.getNextButton('cash-flow-expenses', true)}
                  </>
                </Tab>

                <Tab eventKey="cash-flow-expenses"
                  title={this.getTabHTML('Production Plan - Expenses', 'cash-flow-expenses-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validCashFlowExpensesData, 'cash-flow-expenses-tab')}>
                  <>
                    <div style={{ fontStyle: 'italic' }}>
                      Please select all that apply. Estimate values when necessary.
                    </div>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Car and Truck'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.CarAndTruck)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.CarAndTruck, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.CarAndTruck) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`car-and-truck-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.CarAndTruck)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.CarAndTruck, `car-and-truck-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Chemicals'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Chemicals)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.Chemicals, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Chemicals) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`chemicals-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.Chemicals)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.Chemicals, `chemicals-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Conservation'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Conservation)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.Conservation, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Conservation) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`conservation-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.Conservation)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.Conservation, `conservation-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Custom Hire'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.CustomHire)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.CustomHire, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.CustomHire) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`custom-hire-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.CustomHire)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.CustomHire, `custom-hire-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Feed Supplement'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.FeedSupplement)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.FeedSupplement, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.FeedSupplement) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`feed-supplement-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.FeedSupplement)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.FeedSupplement, `feed-supplement-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Feed, Grain, and Roughage'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.FeedGrainAndRoughage)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.FeedGrainAndRoughage, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.FeedGrainAndRoughage) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`feed-grain-roughage-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.FeedGrainAndRoughage)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.FeedGrainAndRoughage, `feed-grain-roughage-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Fertilizers and Lime'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.FertilizersAndLime)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.FertilizersAndLime, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.FertilizersAndLime) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`fertilizers-lime-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.FertilizersAndLime)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.FertilizersAndLime, `fertilizers-lime-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Freight and Trucking'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.FreightAndTrucking)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.FreightAndTrucking, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.FreightAndTrucking) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`freight-trucking-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.FreightAndTrucking)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.FreightAndTrucking, `freight-trucking-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Gas/Fuel/Oil'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.GasFuelOil)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.GasFuelOil, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.GasFuelOil) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`gas-fuel-oil-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.GasFuelOil)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.GasFuelOil, `gas-fuel-oil-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Insurance'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Insurance)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.Insurance, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Insurance) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`insurance-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.Insurance)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.Insurance, `insurance-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Labor Hired'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.LaborHired)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.LaborHired, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.LaborHired) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`labor-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.LaborHired)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.LaborHired, `labor-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Rent - Machinery/Equipment/Vehicles'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.RentMachineryEquipmentVehicles)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.RentMachineryEquipmentVehicles, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.RentMachineryEquipmentVehicles) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`rent-machinery-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.RentMachineryEquipmentVehicles)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.RentMachineryEquipmentVehicles, `rent-machinery-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Rent - Land/Animals'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.RentLandAnimals)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.RentLandAnimals, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.RentLandAnimals) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`rent-land-animal-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.RentLandAnimals)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.RentLandAnimals, `rent-land-animal-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Repairs and Maintenance'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.RepairsAndMaintenance)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.RepairsAndMaintenance, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.RepairsAndMaintenance) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`repairs-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.RepairsAndMaintenance)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.RepairsAndMaintenance, `repairs-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Seeds and Plants'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.SeedsAndPlants)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.SeedsAndPlants, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.SeedsAndPlants) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`seeds-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.SeedsAndPlants)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.SeedsAndPlants, `seeds-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Storage and Warehousing'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.StorageAndWarehousing)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.StorageAndWarehousing, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.StorageAndWarehousing) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`storage-warehousing-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.StorageAndWarehousing)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.StorageAndWarehousing, `storage-warehousing-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Supplies'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Supplies)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.Supplies, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Supplies) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`supplies-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.Supplies)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.Supplies, `supplies-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Taxes - Real Estate'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.TaxesRealEstate)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.TaxesRealEstate, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.TaxesRealEstate) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`taxes-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.TaxesRealEstate)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.TaxesRealEstate, `taxes-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Utilities'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Utilities)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.Utilities, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.Utilities) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`utilities-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.Utilities)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.Utilities, `utilities-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Veterinary/Breeding/Medicine'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.VeterinaryBreedingMedicine)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.VeterinaryBreedingMedicine, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.VeterinaryBreedingMedicine) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`vet-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.VeterinaryBreedingMedicine)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.VeterinaryBreedingMedicine, `vet-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Other Expenses'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.OtherExpenses)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.OtherExpenses, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.OtherExpenses) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`other-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.OtherExpenses)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.OtherExpenses, `other-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Other - Irrigation'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.OtherIrrigation)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.OtherIrrigation, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.OtherIrrigation) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`irrigation-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.OtherIrrigation)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.OtherIrrigation, `irrigation-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group as={Col}>
                        <Form.Check type="checkbox"
                          className={'custom-checkbox'}
                          style={{ fontSize: 18 }}
                          label={'Operating Loan Interest'}
                          checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.OperatingLoanInterest)}
                          onChange={(event) => this.setCashFlowExpenseType(CashFlowExpenseType.OperatingLoanInterest, event.target.checked)}
                        >
                        </Form.Check>
                        {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenseTypes?.includes(CashFlowExpenseType.OperatingLoanInterest) &&
                          <div style={{ paddingLeft: 20 }}>
                            <Form.Label id={`interest-expense`}>Amount*</Form.Label>
                            <NumericFormat
                              prefix="$"
                              placeholder="Enter the expense amount"
                              decimalScale={2}
                              fixedDecimalScale={true}
                              thousandSeparator
                              value={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection?.expenses?.find(e => e.expenseType === CashFlowExpenseType.OperatingLoanInterest)?.totalAmount}
                              onValueChange={(values) => this.setCashFlowExpenseAmount(CashFlowExpenseType.OperatingLoanInterest, `interest-expense`, values?.floatValue ?? undefined)}
                              className="form-control"
                            />
                          </div>
                        }
                      </Form.Group>
                    </Row>

                    <Row>
                      <Col xs={10}>
                        <div style={{ lineHeight: 3, fontStyle: 'italic', fontWeight: 'bold' }}>
                          {
                            `Total Production Plan Expenses: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection.totalExpenseAmount)}`
                          }
                        </div>
                      </Col>

                      <Col xs={2}>
                        {this.getNextButton('cash-flow-other-expenses', this.state.validCashFlowExpensesData)}
                      </Col>
                    </Row>
                  </>
                </Tab>

                <Tab eventKey="cash-flow-other-expenses"
                  title={this.getTabHTML('Production Plan - Other Expenses', 'cash-flow-other-expenses-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validCashFlowOtherExpensesData, 'cash-flow-other-expenses-tab')}>
                  <>
                    <div style={{ fontStyle: 'italic' }}>
                      (Optional) Please select all that apply. Estimate values when necessary.
                    </div>

                    {/* Household Operating Expenses */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="other-expense-household">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={<span>Total Household Operating Expenses <div style={{ fontStyle: 'italic', fontSize: 12 }}>(Ex. Utilities, personal insurance, income taxes, phone, entertainment, groceries, etc)</div></span>}
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseTypes?.includes(CashFlowOtherExpenseType.Household)}
                                  onChange={(event) => this.setCashFlowOtherExpenseType(CashFlowOtherExpenseType.Household, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="other-expense-household" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseTypes?.includes(CashFlowOtherExpenseType.Household)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>

                        <Accordion.Collapse eventKey={'other-expense-household'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseTypes?.includes(CashFlowOtherExpenseType.Household) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.otherExpenseSection.otherExpenseItems?.map((oei, i) => {
                                  return (
                                    <>
                                      {oei.otherExpenseType === CashFlowOtherExpenseType.Household &&
                                        <>
                                          <div style={{ marginLeft: 15, marginRight: 15 }}>
                                            <h5>
                                              {`Other Expense Item #${i + 1}`}
                                              <span>
                                                <FontAwesomeIcon icon={'trash'} title={'Remove other expense item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowOtherExpenseType(CashFlowOtherExpenseType.Household, i)} />
                                              </span>
                                            </h5>
                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`other-expense-household-description-${i}`}>Description*</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter household operating expense description"
                                                  value={oei.description}
                                                  onChange={(event) => this.setCashFlowOtherExpenseDescription(i, `other-expense-household-description-${i}`, event.target.value)}
                                                />
                                              </Form.Group>

                                              <Form.Group as={Col}>
                                                <Form.Label id={`other-expense-household-amount`}>Amount*</Form.Label>
                                                <NumericFormat
                                                  prefix="$"
                                                  placeholder="Enter the expense amount"
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  thousandSeparator
                                                  value={oei.totalAmount}
                                                  onValueChange={(values) => this.setCashFlowOtherExpenseAmount(i, `other-expense-household-amount`, values?.floatValue ?? undefined)}
                                                  className="form-control"
                                                />
                                              </Form.Group>
                                            </Row>
                                          </div>
                                        </>
                                      }
                                    </>
                                  )
                                })}

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Other Household Expense"
                                    onClick={() => { this.addCashFlowOtherExpenseItem(CashFlowOtherExpenseType.Household) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    {/* Capital Purchases */}
                    <div className="mb-3">
                      <Accordion defaultActiveKey="other-expense-capital">
                        <div>
                          <Row>
                            <Col xs={10}>
                              <Form.Group>
                                <Form.Check type="checkbox"
                                  className={'custom-checkbox'}
                                  style={{ fontSize: 18 }}
                                  label={'Planned Capital Purchases'}
                                  checked={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseTypes?.includes(CashFlowOtherExpenseType.CapitalPurchases)}
                                  onChange={(event) => this.setCashFlowOtherExpenseType(CashFlowOtherExpenseType.CapitalPurchases, event.target.checked)}
                                >
                                </Form.Check>
                              </Form.Group>
                            </Col>

                            <Col>
                              <Form.Group>
                                <div className="accordion-carrot">
                                  <AccordionToggle eventKey="other-expense-capital" hasData={this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseTypes?.includes(CashFlowOtherExpenseType.CapitalPurchases)}></AccordionToggle>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </div>

                        <Accordion.Collapse eventKey={'other-expense-capital'}>
                          <>
                            {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection?.otherExpenseTypes?.includes(CashFlowOtherExpenseType.CapitalPurchases) &&
                              <>
                                {this.state.loanApplication.loanProductionLineOfCredit.cashFlow.otherExpenseSection.otherExpenseItems?.map((oei, i) => {
                                  return (
                                    <>
                                      {oei.otherExpenseType === CashFlowOtherExpenseType.CapitalPurchases &&
                                        <>
                                          <div style={{ marginLeft: 15, marginRight: 15 }}>
                                            <h5>
                                              {`Other Expense Item #${i + 1}`}
                                              <span>
                                                <FontAwesomeIcon icon={'trash'} title={'Remove other expense item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowOtherExpenseType(CashFlowOtherExpenseType.CapitalPurchases, i)} />
                                              </span>
                                            </h5>
                                            <Row className="mb-3">
                                              <Form.Group as={Col}>
                                                <Form.Label id={`other-expense-capital-description-${i}`}>Description*</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter capital purchase description"
                                                  value={oei.description}
                                                  onChange={(event) => this.setCashFlowOtherExpenseDescription(i, `other-expense-capital-description-${i}`, event.target.value)}
                                                />
                                              </Form.Group>

                                              <Form.Group as={Col}>
                                                <Form.Label id={`other-expense-capital-amount`}>Amount*</Form.Label>
                                                <NumericFormat
                                                  prefix="$"
                                                  placeholder="Enter the capital purchase amount"
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  thousandSeparator
                                                  value={oei.totalAmount}
                                                  onValueChange={(values) => this.setCashFlowOtherExpenseAmount(i, `other-expense-capital-amount`, values?.floatValue ?? undefined)}
                                                  className="form-control"
                                                />
                                              </Form.Group>
                                            </Row>
                                          </div>
                                        </>
                                      }
                                    </>
                                  )
                                })}

                                <div className="mb-3">
                                  <SecondaryButton
                                    buttonText="Add Other Capital Purchase"
                                    onClick={() => { this.addCashFlowOtherExpenseItem(CashFlowOtherExpenseType.CapitalPurchases) }}
                                  />
                                </div>
                              </>
                            }
                          </>
                        </Accordion.Collapse>
                      </Accordion>
                    </div>

                    <Row>
                      <Col xs={10}>
                        <div style={{ lineHeight: 3, fontStyle: 'italic', fontWeight: 'bold' }}>
                          {
                            `Total Other Expenses: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection.totalOtherExpenseAmount)}`
                          }
                        </div>
                      </Col>

                      <Col xs={2}>
                        {this.getNextButton('cash-flow-loan-payments', this.state.validCashFlowOtherExpensesData)}
                      </Col>
                    </Row>
                  </>
                </Tab>

                <Tab eventKey="cash-flow-loan-payments"
                  title={this.getTabHTML('Production Plan - Loan Payments', 'cash-flow-loan-payments-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validCashFlowLoanPaymentData, 'cash-flow-loan-payments-tab')}>
                  <>
                    <div className="mb-3" style={{ fontStyle: 'italic' }}>
                      (Optional) Please add all that apply. Estimate values when necessary.
                    </div>

                    {/* Loan Payment Items */}
                    <div className="mb-3">
                      {(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection?.loanPaymentItems ?? []).length > 0
                        ?
                        <>
                          {this.state.loanApplication.loanProductionLineOfCredit?.cashFlow.loanPaymentsSection.loanPaymentItems?.map((lpi, i) => {
                            return (
                              <>
                                <div style={{ marginLeft: 15, marginRight: 15 }}>
                                  <h5>
                                    {`Loan Payment Item #${i + 1}`}
                                    <span>
                                      <FontAwesomeIcon icon={'trash'} title={'Remove loan payment item'} color="red" size="1x" style={{ paddingLeft: 20 }} onClick={() => this.removeCashFlowLoanPaymentItem(i)} />
                                    </span>
                                  </h5>
                                  <Row className="mb-3">
                                    <Form.Group as={Col}>
                                      <Form.Label id={`loan-payment-creditor-${i}`}>Creditor*</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter the creditor of this loan"
                                        value={lpi.creditor}
                                        onChange={(event) => this.setCashFlowLoanPaymentCreditor(i, `loan-payment-creditor-${i}`, event.target.value)}
                                      />
                                    </Form.Group>

                                    <Form.Group as={Col}>
                                      <Form.Label id={`loan-payment-purpose-${i}`}>Purpose*</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter the purpose of this loan"
                                        value={lpi.purpose}
                                        onChange={(event) => this.setCashFlowLoanPaymentPurpose(i, `loan-payment-purpose-${i}`, event.target.value)}
                                      />
                                    </Form.Group>
                                  </Row>

                                  <Row className="mb-3">
                                    <Form.Group as={Col}>
                                      <Form.Label id={`loan-payment-frequency-${i}`}>Payment Frequency (Monthly, Annual, etc)*</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter the frequency of payments (monthly, annual, etc)"
                                        value={lpi.frequency}
                                        onChange={(event) => this.setCashFlowLoanPaymentFrequency(i, `loan-payment-frequency-${i}`, event.target.value)}
                                      />
                                    </Form.Group>
                                  </Row>

                                  <Row className="mb-3">
                                    <Form.Group as={Col}>
                                      <Form.Label id={`loan-payment-amount-${i}`}>Payment Amount*</Form.Label>
                                      <NumericFormat
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix="$"
                                        value={lpi.paymentAmount}
                                        placeholder="Enter each payment amount"
                                        className="form-control"
                                        thousandSeparator
                                        onValueChange={(values) => this.setCashFlowLoanPaymentAmount(i, `loan-payment-amount-${i}`, values.floatValue)}
                                      />
                                    </Form.Group>

                                    <Form.Group as={Col}>
                                      <Form.Label id={`loan-payment-next-payment-${i}`}>Next Payment Date*</Form.Label>
                                      <DatePicker
                                        placeholderText="Enter next payment date"
                                        selected={isValid(lpi.nextPaymentDate) ? lpi.nextPaymentDate : (lpi.nextPaymentDate != undefined) ? new Date(lpi.nextPaymentDate) : undefined}
                                        onChange={(selectedDate: Date) => this.setCashFlowLoanPaymentDate(i, `loan-payment-next-payment-${i}`, selectedDate)}
                                      />
                                    </Form.Group>
                                  </Row>
                                </div>
                              </>
                            )
                          })
                          }
                        </>
                        :
                        <>
                          <div>No loan payment items added</div>
                        </>
                      }

                      <div className="mb-3">
                        <SecondaryButton
                          buttonText="Add Loan Payment Item"
                          onClick={() => { this.addCashFlowLoanPaymentItem() }}
                        />
                      </div>
                    </div>

                    <Row>
                      <Col xs={10}>
                        <div style={{ lineHeight: 3, fontStyle: 'italic', fontWeight: 'bold' }}>
                          {
                            `Total Loan Payment Amount: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection.totalLoanPaymentsAmount)}`
                          }
                        </div>
                      </Col>

                      <Col xs={2}>
                        {this.getNextButton('cash-flow-production-summary', this.state.validCashFlowLoanPaymentData)}
                      </Col>
                    </Row>
                  </>
                </Tab>

                <Tab eventKey="cash-flow-production-summary"
                  title={this.getTabHTML('Production Plan - Production Summary', 'cash-flow-production-summary-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType === LoanType.ProductionLineOfCredit ? '' : 'd-none'}>
                  <>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Production Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalProductionIncome)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Other Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalOtherFarmIncome)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Non-Farm Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalNonFarmIncome)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Capital Sale Income: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalCapitalSalesIncome)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label style={{ fontWeight: 'bold' }}>
                          {
                            `Grand Total Income: ${loanApplicationUtility.BuildCurrencyAmount((this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalProductionIncome ?? 0)
                              + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalOtherFarmIncome ?? 0)
                              + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalNonFarmIncome ?? 0)
                              + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalCapitalSalesIncome ?? 0))}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Production Plan Expenses: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection.totalExpenseAmount)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Total Other Expenses: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection.totalOtherExpenseAmount)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group>
                        <Form.Label style={{ fontWeight: 'bold' }}>
                          {
                            `Grand Total Expenses: ${loanApplicationUtility.BuildCurrencyAmount((this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection.totalExpenseAmount ?? 0)
                              + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection.totalOtherExpenseAmount ?? 0))}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group>
                        <Form.Label style={{ fontWeight: 'bold' }}>
                          {
                            `Net Income Available For Debt Service: ${loanApplicationUtility.BuildCurrencyAmount(
                              (
                                (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalProductionIncome ?? 0)
                                + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalOtherFarmIncome ?? 0)
                                + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalNonFarmIncome ?? 0)
                                + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalCapitalSalesIncome ?? 0)
                              ) -
                              (
                                (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection.totalExpenseAmount ?? 0)
                                + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection.totalOtherExpenseAmount ?? 0)
                              )
                            )}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group>
                        <Form.Label>
                          {
                            `Loan Payments In Production Cycle: ${loanApplicationUtility.BuildCurrencyAmount(this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection.totalLoanPaymentsAmount)}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>

                    <Row>
                      <Form.Group>
                        <Form.Label style={{ fontWeight: 'bold' }}>
                          {
                            `Production Plan Margin: ${loanApplicationUtility.BuildCurrencyAmount(
                              (
                                (
                                  (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalProductionIncome ?? 0)
                                  + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalOtherFarmIncome ?? 0)
                                  + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.incomeSection.totalNonFarmIncome ?? 0)
                                ) -
                                (
                                  (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.expensesSection.totalExpenseAmount ?? 0)
                                  + (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.otherExpenseSection.totalOtherExpenseAmount ?? 0)
                                )
                              ) -
                              (
                                (this.state.loanApplication.loanProductionLineOfCredit?.cashFlow?.loanPaymentsSection.totalLoanPaymentsAmount ?? 0)
                              )
                            )}`
                          }
                        </Form.Label>
                      </Form.Group>
                    </Row>

                    {this.getNextButton('lending-reference', true)}
                  </>
                </Tab>

                <Tab eventKey="lending-reference"
                  title={this.getTabHTML('Lending Reference', 'lending-reference-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  onExit={() => this.checkForValidTabData(this.state.validLendingReferenceData, 'lending-reference-tab')}>
                  {/* Lending Reference Section */}
                  <div>
                    <h3>Main Lending Reference Information</h3>
                    <Row className="mb-3">
                      <Form.Group as={Col}>
                        <Form.Label id="lending-bank-name">Bank Name*</Form.Label>
                        <Form.Control type="text" placeholder="Enter bank name" value={this.state.loanApplication.loanLendingReference?.bankName} defaultValue={''} onChange={(event) => this.setLendingReferenceBankState(event.target.value)} />
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Label id="lending-contact-name">Contact Name*</Form.Label>
                        <Form.Control type="text" placeholder="Enter contact name" value={this.state.loanApplication.loanLendingReference?.contactName} defaultValue={''} onChange={(event) => this.setLendingReferenceNameState(event.target.value)} />
                      </Form.Group>

                      <Form.Group as={Col}>
                        <Form.Label id="lending-phone-number">Contact Phone Number*</Form.Label>
                        <PhoneInput
                          specialLabel=""
                          inputClass="form-control"
                          country={'us'}
                          onlyCountries={['us']}
                          value={this.state.loanApplication.loanLendingReference?.displayPhoneNumber}
                          onChange={this.setLendingReferencePhoneNumberState.bind(this)}
                        />
                      </Form.Group>
                    </Row>

                    {this.state.loanApplication.loanType !== LoanType.ProductionLineOfCredit ?
                      this.getNextButton('revenues', this.state.validLendingReferenceData)
                      :
                      this.getNextButton('applicant-information', this.state.validLendingReferenceData)
                    }
                  </div>
                </Tab>

                <Tab eventKey="revenues"
                  title={this.getTabHTML('Revenues', 'revenue-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  tabClassName={this.state.loanApplication.loanType !== LoanType.ProductionLineOfCredit ? '' : 'd-none'}
                  onExit={() => this.checkForValidTabData(this.state.validRevenueData, 'revenue-tab')}>
                  {(this.state.loanApplication.loanType === LoanType.EquipmentAuctionPurchase || EquipmentOnlyLoans.includes(this.state.loanApplication.loanType)) &&
                    <>
                      <h3>Customer Information</h3>
                      <h5>Projected Annual Gross Revenues (approximate)*</h5>
                      <Row className="mb-3">
                        <Form.Group as={Col}>
                          <Form.Label id="projected-gross-revenues">Farm/Business Revenues</Form.Label>
                          <NumericFormat
                            prefix="$"
                            placeholder="Enter the gross revenues from your business"
                            defaultValue={0}
                            decimalScale={2}
                            thousandSeparator
                            value={this.state.loanApplication.projectedGrossRevenues?.farmRevenues ?? 0}
                            onValueChange={(values) => this.setProjectedFarmRevenuesAmountState(values?.floatValue ?? 0)}
                            className="form-control"
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label id="projected-off-farm-revenues">Off-Farm/Outside Revenues</Form.Label>
                          <NumericFormat
                            prefix="$"
                            placeholder="Enter your outside gross revenues"
                            defaultValue={0}
                            decimalScale={2}
                            thousandSeparator
                            value={this.state.loanApplication.projectedGrossRevenues?.offFarmRevenues ?? 0}
                            onValueChange={(values) => this.setProjectedOffFarmRevenuesAmountState(values?.floatValue ?? 0)}
                            className="form-control"
                          />
                        </Form.Group>
                      </Row>

                      <h5>Prior Year Revenues From Schedule "F"/"C" (approximate)</h5>
                      <div style={{ fontStyle: "italic" }}>(Optional)</div>
                      <Row className="mb-3">
                        <Form.Group as={Col}>
                          <Form.Label>Farm/Business Revenues</Form.Label>
                          <NumericFormat
                            prefix="$"
                            placeholder="Enter the gross revenues from your business"
                            value={this.state.loanApplication.priorGrossRevenues?.farmRevenues ?? 0}
                            decimalScale={2}
                            thousandSeparator
                            onValueChange={(values) => this.setPriorFarmRevenuesAmountState(values?.floatValue ?? 0)}
                            className="form-control"
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label>Off-Farm/Outside Revenues</Form.Label>
                          <NumericFormat
                            prefix="$"
                            placeholder="Enter your outside gross revenues"
                            value={this.state.loanApplication.priorGrossRevenues?.offFarmRevenues ?? 0}
                            decimalScale={2}
                            thousandSeparator
                            onValueChange={(values) => this.setPriorOffFarmRevenuesAmountState(values?.floatValue ?? 0)}
                            className="form-control"
                          />
                        </Form.Group>
                      </Row>
                    </>
                  }

                  {this.state.loanApplication.loanType === LoanType.GapFinancing &&
                    <>
                      <h3>Business Information</h3>
                      <h5>Projected Annual Gross Revenues (approximate)*</h5>
                      <Row className="mb-3">
                        <Form.Group as={Col}>
                          <Form.Label id="projected-gross-revenues">Business Revenues</Form.Label>
                          <NumericFormat
                            prefix="$"
                            placeholder="Enter the gross revenues from your business"
                            defaultValue={0}
                            decimalScale={2}
                            thousandSeparator
                            value={this.state.loanApplication.projectedGrossRevenues?.farmRevenues ?? 0}
                            onValueChange={(values) => this.setProjectedFarmRevenuesAmountState(values?.floatValue ?? 0)}
                            className="form-control"
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label id="projected-off-farm-revenues">Outside Revenues (i.e. W-2, 1099s)</Form.Label>
                          <NumericFormat
                            prefix="$"
                            placeholder="Enter your outside gross revenues"
                            defaultValue={0}
                            decimalScale={2}
                            thousandSeparator
                            value={this.state.loanApplication.projectedGrossRevenues?.offFarmRevenues ?? 0}
                            onValueChange={(values) => this.setProjectedOffFarmRevenuesAmountState(values?.floatValue ?? 0)}
                            className="form-control"
                          />
                        </Form.Group>
                      </Row>

                      <h5>Prior Year Business Revenues From Schedule "C" (approximate)</h5>
                      <div style={{ fontStyle: "italic" }}>(Optional)</div>
                      <Row className="mb-3">
                        <Form.Group as={Col}>
                          <Form.Label>Business Revenues</Form.Label>
                          <NumericFormat
                            prefix="$"
                            placeholder="Enter prior year gross revenues from your business"
                            value={this.state.loanApplication.priorGrossRevenues?.farmRevenues ?? 0}
                            decimalScale={2}
                            thousandSeparator
                            onValueChange={(values) => this.setPriorFarmRevenuesAmountState(values?.floatValue ?? 0)}
                            className="form-control"
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label>Outside Revenues (i.e. W-2, 1099s)</Form.Label>
                          <NumericFormat
                            prefix="$"
                            placeholder="Enter prior year outside gross revenues"
                            value={this.state.loanApplication.priorGrossRevenues?.offFarmRevenues ?? 0}
                            decimalScale={2}
                            thousandSeparator
                            onValueChange={(values) => this.setPriorOffFarmRevenuesAmountState(values?.floatValue ?? 0)}
                            className="form-control"
                          />
                        </Form.Group>
                      </Row>
                    </>
                  }

                  {this.getNextButton('applicant-information', this.state.validRevenueData)}
                </Tab>

                <Tab eventKey="applicant-information"
                  title={this.getTabHTML('Applicant Information', 'applicant-info-tab')}
                  disabled={this.state.loanApplication.loanType == undefined || this.state.loanApplication.loanType === 0}
                  onExit={() => this.checkForValidTabData(this.state.validApplicantInfo, 'applicant-info-tab')}>
                  {!this.props.userLoggedIn && (
                    <Alert variant="warning" className="mb-3">
                      For security purposes, personal information entered here will not be saved to the draft.
                      Please <strong>log in</strong> to save your progress.
                    </Alert>
                  )}
                  <h5>Personal Information</h5>
                  <div>
                    <div>
                      <h6>{`Primary Applicant`}</h6>
                      <Form.Group className="mb-3">
                        <span>An account will be created for this applicant upon submitting an application if it doesn't exist.</span>
                      </Form.Group>

                      <Row>
                        <Form.Group as={Col}>
                          <Form.Label id={`customer-email`}>Email Address*</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter email address"
                            value={this.state.loanApplication.applicant.emailAddress}
                            defaultValue={''}
                            onChange={(event) => this.setApplicantEmailState(event.target.value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                          {this.state.loanApplication.applicant.validationAccountExists &&
                            <div style={{ color: 'red', fontStyle: 'italic' }}>Account already exists</div>
                          }
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label id={`customer-phone-number`}>Phone Number*</Form.Label>
                          <PhoneInput
                            specialLabel=""
                            inputClass="form-control"
                            country={'us'}
                            onlyCountries={['us']}
                            value={this.state.loanApplication.applicant.displayPhoneNumber}
                            onChange={(value, data, event, formattedValue) => this.setApplicantPhoneNumberState(value, data, event, formattedValue, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>
                      </Row >

                      <Row>
                        <Form.Group as={Col}>
                          <Form.Label id={`customer-first-name`}>First Name*</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter first name"
                            value={this.state.loanApplication.applicant.firstName}
                            defaultValue={''}
                            onChange={(event) => this.setApplicantFirstNameState(event.target.value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label
                            id={`customer-last-name`}>Last Name*</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter last name"
                            value={this.state.loanApplication.applicant.lastName}
                            defaultValue={''}
                            onChange={(event) => this.setApplicantLastNameState(event.target.value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label>Suffix (Jr, Sr, III)</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter suffix"
                            value={this.state.loanApplication.applicant.suffix}
                            defaultValue={''}
                            onChange={(event) => this.setApplicantSuffixState(event.target.value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col}>
                          <Form.Label
                            id={`customer-address`}>Address Line 1*</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter address (line 1)"
                            value={this.state.loanApplication.applicant.address}
                            defaultValue={''}
                            onChange={(event) => this.setApplicantAddressLine1State(event.target.value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label>Address Line 2</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter address (line 2)"
                            value={this.state.loanApplication.applicant.addressLine2}
                            defaultValue={''}
                            onChange={(event) => this.setApplicantAddressLine2State(event.target.value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col}>
                          <Form.Label
                            id={`customer-city`}>City*</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter city"
                            value={this.state.loanApplication.applicant.city}
                            defaultValue={''}
                            onChange={(event) => this.setApplicantCityState(event.target.value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label
                            id={`customer-state`}>State*</Form.Label>
                          <Form.Control as="select"
                            onChange={(event) => this.setApplicantStateValueState(event.target.value, ApplicantType.Primary)}
                            value={this.state.loanApplication.applicant.state}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          >
                            <option value={-1}>Please select a state...</option>
                            {STATES.map(s => {
                              return (
                                <option value={s}>{s}</option>
                              )
                            })}
                          </Form.Control>
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label
                            id={`customer-zip`}>Zip Code*</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter 5 digit zip code"
                            value={this.state.loanApplication.applicant.zipCode}
                            defaultValue={''}
                            onChange={(event) => this.setApplicantZipCodeState(event.target.value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col}>
                          <Form.Label
                            id={`customer-dob`}>Date of Birth*</Form.Label>
                          <div style={{ fontSize: 12 }}>&nbsp;</div>
                          <DatePicker
                            selected={isValid(this.state.loanApplication.applicant.dateOfBirth) ? this.state.loanApplication.applicant.dateOfBirth : undefined}
                            //onSelect={(value: Date) => this.setApplicantDOBState(value)}
                            onChange={(value: Date) => this.setApplicantDOBState(value, ApplicantType.Primary)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label
                            id={`customer-ssn`}>Social Security Number (###-##-####)*</Form.Label>
                          <div style={{ fontSize: 12, fontStyle: 'italic' }}>Input in format shown above</div>
                          <PatternFormat
                            format="###-##-####"
                            type="text"
                            className="form-control"
                            placeholder="123-45-6789"
                            value={this.state.loanApplication.applicant.ssn ?? ''}
                            onValueChange={(values) => this.setApplicantSSNState(values.formattedValue, ApplicantType.Primary)} />
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col}>
                          <Form.Label
                            id={`business-name`}>Business Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter business name (Optional)"
                            value={this.state.loanApplication.applicant.businessName}
                            defaultValue={''}
                            onChange={(event) => this.setBusinessNameState(event.target.value)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Form.Label
                            id={`managing-farm`}>Year Began Managing Farm/Business*</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Ex. 2000"
                            autoComplete="new-password"
                            value={this.state.loanApplication.applicant.farmingStartYear}
                            defaultValue={''}
                            onChange={(event) => this.setYearsManagingFarmState(event.target.value)}
                            disabled={this.state.loanApplication.applicant.hasAccount}
                          />
                        </Form.Group>
                      </Row>

                      <Form.Group className="mb-3" style={{ maxWidth: 500 }}>
                        <Form.Check type="checkbox"
                          label="I Agree"
                          checked={this.state.loanApplication.applicant.experianAgreed}
                          onChange={(event) => this.setExperianAgreedState(event.target.checked)}
                        />
                        <Form.Label style={{ fontSize: 12, fontStyle: 'italic' }}>You understand that by checking 'I Agree', immediately following this notice you are providing ‘written instructions’ to agCredit, Inc under the Fair Credit Reporting Act, authorizing agCredit, Inc to obtain information from your personal credit profile or other information from Experian. You authorize agCredit, Inc to obtain such information solely to pre-qualify you for credit options.</Form.Label>
                      </Form.Group>
                    </div>
                  </div>

                  <div>
                    <h5>Joint Applicant Information
                      {this.state.loanApplication.jointApplicant != undefined &&
                        <span>
                          <Button variant="link" onClick={() => this.removeJointApplicantClicked()} >
                            <FontAwesomeIcon icon="minus" color="red" />
                          </Button>
                        </span>
                      }
                    </h5>
                    {this.state.loanApplication.jointApplicant != undefined &&
                      <>
                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label id={`customer-email-joint`}>Email Address*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter email address"
                              value={this.state.loanApplication.jointApplicant?.emailAddress}
                              defaultValue={''}
                              onChange={(event) => this.setApplicantEmailState(event.target.value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                            {this.state.loanApplication.jointApplicant?.validationAccountExists &&
                              <div style={{ color: 'red', fontStyle: 'italic' }}>Account already exists</div>
                            }
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label id={`customer-phone-number-joint`}>Phone Number*</Form.Label>
                            <PhoneInput
                              specialLabel=""
                              inputClass="form-control"
                              country={'us'}
                              onlyCountries={['us']}
                              value={this.state.loanApplication.jointApplicant?.displayPhoneNumber}
                              onChange={(value, data, event, formattedValue) => this.setApplicantPhoneNumberState(value, data, event, formattedValue, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>
                        </Row >

                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label id={`customer-first-name-joint`}>First Name*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter first name"
                              value={this.state.loanApplication.jointApplicant?.firstName}
                              defaultValue={''}
                              onChange={(event) => this.setApplicantFirstNameState(event.target.value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label
                              id={`customer-last-name-joint`}>Last Name*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter last name"
                              value={this.state.loanApplication.jointApplicant?.lastName}
                              defaultValue={''}
                              onChange={(event) => this.setApplicantLastNameState(event.target.value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label>Suffix (Jr, Sr, III)</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter suffix"
                              value={this.state.loanApplication.jointApplicant?.suffix}
                              defaultValue={''}
                              onChange={(event) => this.setApplicantSuffixState(event.target.value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>
                        </Row>

                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label
                              id={`customer-address-joint`}>Address Line 1*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter address (line 1)"
                              value={this.state.loanApplication.jointApplicant?.address}
                              defaultValue={''}
                              onChange={(event) => this.setApplicantAddressLine1State(event.target.value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label>Address Line 2</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter address (line 2)"
                              value={this.state.loanApplication.jointApplicant?.addressLine2}
                              defaultValue={''}
                              onChange={(event) => this.setApplicantAddressLine2State(event.target.value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>
                        </Row>

                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label
                              id={`customer-city-joint`}>City*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter city"
                              value={this.state.loanApplication.jointApplicant?.city}
                              defaultValue={''}
                              onChange={(event) => this.setApplicantCityState(event.target.value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label
                              id={`customer-state-joint`}>State*</Form.Label>
                            <Form.Control as="select"
                              onChange={(event) => this.setApplicantStateValueState(event.target.value, ApplicantType.Joint)}
                              value={this.state.loanApplication.jointApplicant?.state}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            >
                              <option value={-1}>Please select a state...</option>
                              {STATES.map(s => {
                                return (
                                  <option value={s}>{s}</option>
                                )
                              })}
                            </Form.Control>
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label
                              id={`customer-zip-joint`}>Zip Code*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter 5 digit zip code"
                              value={this.state.loanApplication.jointApplicant?.zipCode}
                              defaultValue={''}
                              onChange={(event) => this.setApplicantZipCodeState(event.target.value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>
                        </Row>

                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label
                              id={`customer-dob-joint`}>Date of Birth*</Form.Label>
                            <div style={{ fontSize: 12 }}>&nbsp;</div>
                            <DatePicker
                              selected={isValid(this.state.loanApplication.jointApplicant?.dateOfBirth) ? this.state.loanApplication.jointApplicant.dateOfBirth : undefined}
                              //onSelect={(value: Date) => this.setApplicantDOBState(value)}
                              onChange={(value: Date) => this.setApplicantDOBState(value, ApplicantType.Joint)}
                              disabled={this.state.loanApplication.jointApplicant?.hasAccount}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label
                              id={`customer-ssn-joint`}>Social Security Number (###-##-####)*</Form.Label>
                            <div style={{ fontSize: 12, fontStyle: 'italic' }}>Input in format shown above</div>
                            <PatternFormat
                              format="###-##-####"
                              type="text"
                              className="form-control"
                              placeholder="123-45-6789"
                              value={this.state.loanApplication.jointApplicant?.ssn ?? ''}
                              onValueChange={(values) => this.setApplicantSSNState(values.formattedValue, ApplicantType.Joint)} />
                          </Form.Group>
                        </Row>
                      </>
                    }

                    {this.state.loanApplication.jointApplicant == undefined &&
                      <div className="mb-3">
                        <SecondaryButton
                          buttonText="Add Joint Applicant"
                          onClick={this.addJointApplicantButtonClicked.bind(this)}
                        />
                      </div>
                    }
                  </div>

                  <div>
                    <h5>Entity Information
                      {this.state.loanApplication.entityApplicant != undefined &&
                        <span>
                          <Button variant="link" onClick={this.removeEntityClicked.bind(this)} >
                            <FontAwesomeIcon icon="minus" color="red" />
                          </Button>
                        </span>
                      }

                    </h5>
                    {this.state.loanApplication.entityApplicant == undefined &&
                      <div className="mb-3">
                        <SecondaryButton
                          buttonText="Add Entity Information"
                          onClick={this.addEntityButtonClicked.bind(this)}
                        />
                      </div>
                    }

                    {this.state.loanApplication.entityApplicant != undefined &&
                      <>
                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label
                              id="entity-name">Organization Name*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter organization's legal name"
                              value={this.state.loanApplication.entityApplicant.organizationName}
                              defaultValue={''}
                              onChange={(event) => this.setEntityNameState(event.target.value)} />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label
                              id="entity-date">Date Organized*</Form.Label>
                            <DatePicker
                              selected={this.state.loanApplication.entityApplicant.dateOrganized}
                              onChange={(value: Date) => this.setEntityDateOrganizedState(value)}
                            />
                          </Form.Group>
                        </Row>

                        <Form.Group>
                          <Form.Label
                            id="entity-ein">EIN (##-#######)*</Form.Label>
                          <div style={{ fontSize: 12, fontStyle: 'italic' }}>Input in format shown above</div>
                          <Form.Control
                            type="text"
                            placeholder="12-3456789"
                            value={this.state.loanApplication.entityApplicant.ein}
                            defaultValue={''}
                            onChange={(event) => this.setEntityEINState(event.target.value)} />
                        </Form.Group>

                        <Form.Group>
                          <Form.Label
                            id="entity-address">Address*</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter organization's address"
                            value={this.state.loanApplication.entityApplicant.address}
                            defaultValue={''}
                            onChange={(event) => this.setEntityAddressState(event.target.value)} />
                        </Form.Group>

                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label
                              id="entity-city">City*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter organization's city"
                              value={this.state.loanApplication.entityApplicant.city}
                              defaultValue={''}
                              onChange={(event) => this.setEntityCityState(event.target.value)} />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label
                              id="entity-state">State*</Form.Label>
                            <Form.Control as="select"
                              onChange={(event) => this.setEntityStateValueState(event.target.value)}
                              value={this.state.loanApplication.entityApplicant.state}>
                              <option value={-1}>Please select a state...</option>
                              {STATES.map(s => {
                                return (
                                  <option value={s}>{s}</option>
                                )
                              })}
                            </Form.Control>
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Label
                              id="entity-zip">Zip Code*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter organizations's 5 digit zip code"
                              value={this.state.loanApplication.entityApplicant.zipCode}
                              defaultValue={''}
                              onChange={(event) => this.setEntityZipCodeState(event.target.value)} />
                          </Form.Group>
                        </Row>

                        <h5>Entity Questions</h5>
                        <Row>
                          <Form.Group as={Col}>
                            <Form.Check
                              type="checkbox"
                              label={`Was this business formed in the United States?`}
                              checked={this.state.loanApplication.entityApplicant.extraDataObject?.isBusinessFormedInUsa}
                              onChange={(event) => this.setEntityExtraQuestion(event.target.checked, 'isBusinessFormedInUsa')}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Check
                              type="checkbox"
                              label={`Is your business directly or indirectly involved in marijuana, cannabis, hemp or CBD?`}
                              checked={this.state.loanApplication.entityApplicant.extraDataObject?.isBusinessInvolvedWithCannabis}
                              onChange={(event) => this.setEntityExtraQuestion(event.target.checked, 'isBusinessInvolvedWithCannabis')}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Check
                              type="checkbox"
                              label={'Does your business issue, exchange or redeem virtual currency (i.e. Bit Coin)?'}
                              checked={this.state.loanApplication.entityApplicant.extraDataObject?.isBusinessExchangeDigitalCurrency}
                              onChange={(event) => this.setEntityExtraQuestion(event.target.checked, 'isBusinessExchangeDigitalCurrency')}
                            />
                          </Form.Group>
                        </Row>
                        <Row>
                          <Form.Group as={Col}>
                            <Form.Check
                              type="checkbox"
                              label={`Is your business a casino?`}
                              checked={this.state.loanApplication.entityApplicant.extraDataObject?.isBusinessCasino}
                              onChange={(event) => this.setEntityExtraQuestion(event.target.checked, 'isBusinessCasino')}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Check
                              type="checkbox"
                              label={`Is your business involved in internet gambling or have any games or financial activities on your website?`}
                              checked={this.state.loanApplication.entityApplicant.extraDataObject?.isBusinessInInternetGambling}
                              onChange={(event) => this.setEntityExtraQuestion(event.target.checked, 'isBusinessInInternetGambling')}
                            />
                          </Form.Group>

                          <Form.Group as={Col}>
                            <Form.Check
                              type="checkbox"
                              label={'Is your business publicly traded?'}
                              checked={this.state.loanApplication.entityApplicant.extraDataObject?.isBusinessPubliclyTraded}
                              onChange={(event) => this.setEntityExtraQuestion(event.target.checked, 'isBusinessPubliclyTraded')}
                            />
                          </Form.Group>
                        </Row>

                        <h5>Principal / Ownership Information </h5>
                        <span style={{ fontStyle: 'italic', fontWeight: 'bold', fontSize: 12 }}>**At least one owner with 25% or more ownership interest in Applicant must complete this section in its entirety**</span>
                        {this.state.loanApplication.entityApplicant.extraDataObject?.principalOwnershipInformation?.map((po: PrincipalOwnerInformation, i: number) => {
                          return (
                            <>
                              <h5>
                                {`Principal/Owner #${i + 1}`}
                                {i > 0 &&
                                  <span>
                                    <Button variant="link" onClick={this.removePrincipalOwnerButtonClicked.bind(this, i)} >
                                      <FontAwesomeIcon icon="minus" color="red" />
                                    </Button>
                                  </span>
                                }
                              </h5>
                              <Row>
                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-first-name-${i}`}>Principal/Owner First Name*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter Principal/Owner first name"
                                    value={po.principalOwnerFirstName}
                                    defaultValue={''}
                                    onChange={(event) => this.setPrincipalOwnerFirstNameState(event.target.value, i, `principal-first-name-${i}`)} />
                                </Form.Group>

                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-last-name-${i}`}>Principal/Owner Last Name*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter Principal/Owner last name"
                                    value={po.principalOwnerLastName}
                                    defaultValue={''}
                                    onChange={(event) => this.setPrincipalOwnerLastNameState(event.target.value, i, `principal-last-name-${i}`)} />
                                </Form.Group>

                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-ssn-taxid-${i}`}>Social Security No./Tax ID*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter either the owner's SSN or Principal's Tax ID"
                                    value={po.ssnTaxId}
                                    defaultValue={''}
                                    onChange={(event) => this.setPrincipalSSNTaxIdState(event.target.value, i, `principal-ssn-taxid-${i}`)} />
                                </Form.Group>
                              </Row>

                              <Row>
                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-address-${i}`}>Physical Address*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter the physical address"
                                    value={po.physicalAddress}
                                    defaultValue={''}
                                    onChange={(event) => this.setPrincipalAddressState(event.target.value, i, `principal-address-${i}`)} />
                                </Form.Group>
                              </Row>

                              <Row>
                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-city-${i}`}>City*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter the city"
                                    value={po.city}
                                    defaultValue={''}
                                    onChange={(event) => this.setPrincipalCityState(event.target.value, i, `principal-city-${i}`)} />
                                </Form.Group>

                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-state-${i}`}>State*</Form.Label>
                                  <Form.Control as="select"
                                    id={`principal-state-${i}`}
                                    onChange={(event) => this.setPrincipalStateState(event.target.value, i, `principal-state-${i}`)}
                                    value={po.state}
                                  >
                                    <option value={-1}>Please select a state...</option>
                                    {STATES.map(s => {
                                      return (
                                        <option value={s}>{s}</option>
                                      )
                                    })}
                                  </Form.Control>
                                </Form.Group>

                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-zip-${i}`}>Zip Code*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter the zip code"
                                    value={po.zipCode}
                                    defaultValue={''}
                                    onChange={(event) => this.setPrincipalZipCodeState(event.target.value, i, `principal-zip-${i}`)} />
                                </Form.Group>
                              </Row>

                              <Row>
                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-dob-${i}`}>Date of Birth*</Form.Label>
                                  <DatePicker
                                    selected={isValid(po.dateOfBirth) ? po.dateOfBirth : (po.dateOfBirth != undefined) ? new Date(po.dateOfBirth) : undefined}
                                    //onSelect={(value: Date) => this.setApplicantDOBState(value)}
                                    onChange={(value: Date) => this.setPrincipalDOBState(value, i, `principal-dob-${i}`)}
                                  />
                                </Form.Group>
                              </Row>

                              <Row>
                                <Form.Group as={Col}>
                                  <Form.Label id={`principal-phone-${i}`}>Phone Number*</Form.Label>
                                  <PhoneInput
                                    specialLabel=""
                                    inputClass="form-control"
                                    country={'us'}
                                    onlyCountries={['us']}
                                    value={po.displayPhoneNumber}
                                    onChange={(value, data, event, formattedValue) => this.setPrincipalPhoneNumberState(value, formattedValue, i, `principal-phone-${i}`)}
                                  />
                                </Form.Group>

                                <Form.Group as={Col}>
                                  <Form.Label id={`principal-percentage-${i}`}>Ownership Percentage*</Form.Label>
                                  <NumericFormat
                                    value={po.percentageOwned}
                                    placeholder="Enter the share percent of ownership"
                                    className="form-control"
                                    thousandSeparator
                                    suffix="%"
                                    onValueChange={(values) => this.setPrincipalPercentage(values.floatValue ?? 0, i, `principal-percentage-${i}`)}
                                  />
                                </Form.Group>
                              </Row>

                              <Row>
                                <Form.Group as={Col}>
                                  <Form.Label
                                    id={`principal-title-${i}`}>Title*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter their title"
                                    value={po.title}
                                    defaultValue={''}
                                    onChange={(event) => this.setPrincipalTitleState(event.target.value, i, `principal-address-${i}`)} />
                                </Form.Group>
                              </Row>
                            </>
                          )
                        })
                        }

                        <div className="mb-3">
                          <SecondaryButton
                            buttonText="Add Additional Principal/Ownership Information"
                            onClick={this.addPrincipalOwnerButtonClicked.bind(this)}
                          />
                        </div>

                        <Form.Group className="mb-3" style={{ maxWidth: 500 }}>
                          <Form.Check type="checkbox"
                            label="I Agree"
                            checked={this.state.loanApplication.entityApplicant.experianAgreed}
                            onChange={(event) => this.setEntityExperianAgreedState(event.target.checked)}
                          />
                          <Form.Label style={{ fontSize: 12, fontStyle: 'italic' }}>On behalf of the customer, you understand that by checking 'I Agree', immediately following this notice they are providing ‘written instructions’ to agCredit, Inc under the Fair Credit Reporting Act authorizing agCredit, Inc to obtain information from their personal credit profile or other information from Experian. They authorize agCredit, Inc to obtain such information solely to pre-qualify them for credit options.</Form.Label>
                        </Form.Group>
                      </>
                    }
                  </div>

                  {this.getNextButton('summary', this.state.validApplicantInfo)}
                </Tab>

                <Tab eventKey="summary"
                  title={this.getTabHTML('Application Summary', 'summary-tab')}
                  disabled={!(this.state.validStartData &&
                    this.state.validGeneralData &&
                    this.state.validLendingReferenceData &&
                    this.state.validApplicantInfo)}>
                  <SubmitSummary loanDetails={this.state.loanApplication} />
                  {!this.props.userLoggedIn && this.state.draftEmailOptInVisible && (
                    <Form.Group className="mb-3">
                      <Form.Label><strong>Resume on another device</strong></Form.Label>
                      <Form.Text className="d-block mb-2">
                        To resume this application on a different device, enter your email:
                      </Form.Text>
                      <Row>
                        <Col>
                          <Form.Control
                            type="email"
                            placeholder="your@email.com"
                            value={this.state.draftMagicLinkEmail}
                            onChange={(e) => this.setState({ draftMagicLinkEmail: e.target.value })}
                          />
                        </Col>
                        <Col xs="auto">
                          <PrimaryButton
                            buttonText="Send Link"
                            onClick={async () => {
                              const { draftToken, draftMagicLinkEmail } = this.state;
                              if (draftToken && draftMagicLinkEmail) {
                                const sent = await loanApplicationService.SendDraftMagicLink(draftToken, draftMagicLinkEmail, this.props.sqId);
                                if (sent) {
                                  toastUtility.showSuccessToast('Resume link sent! Check your email.');
                                  this.setState({ draftEmailOptInVisible: false });
                                }
                              }
                            }}
                            disabled={!this.state.draftMagicLinkEmail}
                          />
                        </Col>
                        <Col xs="auto">
                          <SecondaryButton
                            buttonText="Dismiss"
                            onClick={() => this.setState({ draftEmailOptInVisible: false })}
                          />
                        </Col>
                      </Row>
                    </Form.Group>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                    {!this.props.userLoggedIn && (
                      <SecondaryButton
                        buttonText="Resume on Different Device"
                        onClick={() => this.setState({ draftEmailOptInVisible: !this.state.draftEmailOptInVisible })}
                      />
                    )}
                    <SecondaryButton
                      buttonText="Save Draft"
                      onClick={() => this.saveDraft(true)}
                    />
                    <PrimaryButton
                      buttonText="Submit Application"
                      disabled={!this.checkForValidApplication()}
                      onClick={this.submitApplication.bind(this)}
                    />
                  </div>
                </Tab>
              </Tabs>
            }
          </Form>
        </Row >
      </div >
    );
  }
}

export default ApplicationForm;